import { __decorate, __metadata, __awaiter, __param } from 'tslib';
import { ɵɵdefineInjectable, Injectable, ɵɵinject, ViewChild, ElementRef, Input, HostListener, Component, Inject, EventEmitter, Output, Pipe, ViewContainerRef, NgModule } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BehaviorSubject, throwError } from 'rxjs';
import { OpenVidu, StreamManager } from 'openvidu-browser';
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/material/snack-bar';
import * as ɵngcc2 from '@angular/material/button';
import * as ɵngcc3 from '@angular/material/icon';
import * as ɵngcc4 from '@angular/material/tooltip';
import * as ɵngcc5 from '@angular/common';
import * as ɵngcc6 from '@angular/forms';
import * as ɵngcc7 from '@angular/flex-layout/extended';
import * as ɵngcc8 from '@angular/material/dialog';
import * as ɵngcc9 from '@angular/common/http';
import * as ɵngcc10 from '@angular/router';
import * as ɵngcc11 from '@angular/material/sidenav';
import * as ɵngcc12 from 'ngx-linkifyjs';
import * as ɵngcc13 from '@angular/material/form-field';
import * as ɵngcc14 from '@angular/material/input';
import * as ɵngcc15 from '@angular/material/toolbar';
import * as ɵngcc16 from '@angular/flex-layout/flex';
import * as ɵngcc17 from '@angular/material/badge';
import * as ɵngcc18 from '@angular/material/progress-spinner';
import * as ɵngcc19 from '@angular/material/select';
import * as ɵngcc20 from '@angular/material/core';

const _c0 = ["chatScroll"];
const _c1 = ["chatInput"];
function ChatComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵelement(1, "img", 14);
    ɵngcc0.ɵɵelementStart(2, "div", 15);
    ɵngcc0.ɵɵelementStart(3, "div", 16);
    ɵngcc0.ɵɵelementStart(4, "p");
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 17);
    ɵngcc0.ɵɵelement(7, "span", 18);
    ɵngcc0.ɵɵelement(8, "p", 19);
    ɵngcc0.ɵɵpipe(9, "linkify");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const data_r3 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngClass", data_r3.isLocal ? "right" : "left");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("src", data_r3.userAvatar, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(data_r3.nickname);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("innerHTML", ɵngcc0.ɵɵpipeBind1(9, 4, data_r3.message), ɵngcc0.ɵɵsanitizeHtml);
} }
const _c2 = ["chatComponent"];
const _c3 = ["sidenav"];
function VideoRoomComponent_div_0_app_room_config_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "app-room-config", 4);
    ɵngcc0.ɵɵlistener("join", function VideoRoomComponent_div_0_app_room_config_1_Template_app_room_config_join_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(2); return ctx_r3.onConfigRoomJoin(); })("leaveSession", function VideoRoomComponent_div_0_app_room_config_1_Template_app_room_config_leaveSession_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ctx_r5.leaveSession(); })("publisherCreated", function VideoRoomComponent_div_0_app_room_config_1_Template_app_room_config_publisherCreated_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ctx_r6.emitPublisher($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ovSettings", ctx_r1.ovSettings)("externalConfig", ctx_r1.externalConfig);
} }
function VideoRoomComponent_div_0_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 14);
} }
function VideoRoomComponent_div_0_div_2_mat_sidenav_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-sidenav", 15, 16);
    ɵngcc0.ɵɵelement(2, "chat-component", 17, 18);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵclassProp("boundsLight", ctx_r8.lightTheme);
    ɵngcc0.ɵɵpropertyInterpolate("mode", ctx_r8.sidenavMode);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("lightTheme", ctx_r8.lightTheme);
} }
function VideoRoomComponent_div_0_div_2_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵelementStart(1, "stream-component", 20);
    ɵngcc0.ɵɵlistener("nicknameClicked", function VideoRoomComponent_div_0_div_2_div_8_Template_stream_component_nicknameClicked_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(3); return ctx_r14.onNicknameUpdate($event); })("replaceScreenTrackClicked", function VideoRoomComponent_div_0_div_2_div_8_Template_stream_component_replaceScreenTrackClicked_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r16 = ɵngcc0.ɵɵnextContext(3); return ctx_r16.onReplaceScreenTrack($event); })("toggleVideoSizeClicked", function VideoRoomComponent_div_0_div_2_div_8_Template_stream_component_toggleVideoSizeClicked_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r17 = ɵngcc0.ɵɵnextContext(3); return ctx_r17.onToggleVideoSize($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const localUser_r13 = ctx.$implicit;
    ɵngcc0.ɵɵstyleProp("display", !(localUser_r13.streamManager == null ? null : localUser_r13.streamManager.stream == null ? null : localUser_r13.streamManager.stream.videoActive) ? "none" : "block");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("user", localUser_r13)("videoSizeBig", localUser_r13.videoSizeBig);
} }
function VideoRoomComponent_div_0_div_2_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 21);
    ɵngcc0.ɵɵelementStart(1, "stream-component", 22);
    ɵngcc0.ɵɵlistener("toggleVideoSizeClicked", function VideoRoomComponent_div_0_div_2_div_9_Template_stream_component_toggleVideoSizeClicked_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r19 = ɵngcc0.ɵɵnextContext(3); return ctx_r19.onToggleVideoSize($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const user_r18 = ctx.$implicit;
    ɵngcc0.ɵɵstyleProp("display", !(user_r18.streamManager == null ? null : user_r18.streamManager.stream == null ? null : user_r18.streamManager.stream.videoActive) ? "none" : "block");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("user", user_r18)("videoSizeBig", user_r18.videoSizeBig);
} }
function VideoRoomComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, VideoRoomComponent_div_0_div_2_div_1_Template, 1, 0, "div", 5);
    ɵngcc0.ɵɵelementStart(2, "app-toolbar", 6);
    ɵngcc0.ɵɵlistener("camButtonClicked", function VideoRoomComponent_div_0_div_2_Template_app_toolbar_camButtonClicked_2_listener() { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r21 = ɵngcc0.ɵɵnextContext(2); return ctx_r21.toggleCam(); })("micButtonClicked", function VideoRoomComponent_div_0_div_2_Template_app_toolbar_micButtonClicked_2_listener() { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r23 = ɵngcc0.ɵɵnextContext(2); return ctx_r23.toggleMic(); })("screenShareClicked", function VideoRoomComponent_div_0_div_2_Template_app_toolbar_screenShareClicked_2_listener() { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r24 = ɵngcc0.ɵɵnextContext(2); return ctx_r24.toggleScreenShare(); })("layoutButtonClicked", function VideoRoomComponent_div_0_div_2_Template_app_toolbar_layoutButtonClicked_2_listener() { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r25 = ɵngcc0.ɵɵnextContext(2); return ctx_r25.toggleSpeakerLayout(); })("leaveSessionButtonClicked", function VideoRoomComponent_div_0_div_2_Template_app_toolbar_leaveSessionButtonClicked_2_listener() { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r26 = ɵngcc0.ɵɵnextContext(2); return ctx_r26.leaveSession(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "mat-sidenav-container", 7);
    ɵngcc0.ɵɵtemplate(4, VideoRoomComponent_div_0_div_2_mat_sidenav_4_Template, 4, 4, "mat-sidenav", 8);
    ɵngcc0.ɵɵpipe(5, "hasChat");
    ɵngcc0.ɵɵelementStart(6, "mat-sidenav-content", 9);
    ɵngcc0.ɵɵelementStart(7, "div", 10);
    ɵngcc0.ɵɵtemplate(8, VideoRoomComponent_div_0_div_2_div_8_Template, 2, 4, "div", 11);
    ɵngcc0.ɵɵtemplate(9, VideoRoomComponent_div_0_div_2_div_9_Template, 2, 4, "div", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(10, "app-footer", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.isConnectionLost);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("lightTheme", ctx_r2.lightTheme)("compact", ctx_r2.compact)("mySessionId", ctx_r2.mySessionId)("ovSettings", ctx_r2.ovSettings)("hasVideoDevices", ctx_r2.hasVideoDevices)("hasAudioDevices", ctx_r2.hasAudioDevices)("isWebcamVideoEnabled", ctx_r2.oVSessionService.hasWebcamVideoActive())("isWebcamAudioEnabled", ctx_r2.toolbarMicIconEnabled())("isScreenEnabled", ctx_r2.oVSessionService.isScreenShareEnabled())("isAutoLayout", ctx_r2.isAutoLayout)("isConnectionLost", ctx_r2.isConnectionLost);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("boundsLight", ctx_r2.lightTheme);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(5, 21, ctx_r2.ovSettings));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵclassProp("boundsLight", ctx_r2.lightTheme);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.localUsers);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.remoteUsers);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("lightTheme", ctx_r2.lightTheme)("participants", ctx_r2.remoteUsers);
} }
function VideoRoomComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵtemplate(1, VideoRoomComponent_div_0_app_room_config_1_Template, 1, 2, "app-room-config", 2);
    ɵngcc0.ɵɵtemplate(2, VideoRoomComponent_div_0_div_2_Template, 11, 23, "div", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("boundsLight", ctx_r0.lightTheme);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.showConfigRoomCard);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.localUsers && ctx_r0.localUsers.length > 0);
} }
const _c4 = ["videoRoom"];
function OpenviduSessionComponent_app_video_room_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "app-video-room", 1, 2);
    ɵngcc0.ɵɵlistener("_session", function OpenviduSessionComponent_app_video_room_0_Template_app_video_room__session_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.emitSession($event); })("_publisher", function OpenviduSessionComponent_app_video_room_0_Template_app_video_room__publisher_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.emitPublisher($event); })("_error", function OpenviduSessionComponent_app_video_room_0_Template_app_video_room__error_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.emitErrorEvent($event); })("_leaveSession", function OpenviduSessionComponent_app_video_room_0_Template_app_video_room__leaveSession_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.emitLeaveSessionEvent($event); })("_joinSession", function OpenviduSessionComponent_app_video_room_0_Template_app_video_room__joinSession_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.emitJoinSessionEvent($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("externalConfig", ctx_r0.angularLibrary);
} }
const _c5 = ["nicknameInput"];
const _c6 = ["streamComponent"];
function StreamComponent_div_0_div_3_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1, " (edit)");
    ɵngcc0.ɵɵelementEnd();
} }
function StreamComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵlistener("click", function StreamComponent_div_0_div_3_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.toggleNicknameForm(); });
    ɵngcc0.ɵɵelementStart(1, "span", 16);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, StreamComponent_div_0_div_3_span_3_Template, 2, 0, "span", 17);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2._user.nickname);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r2._user.streamManager.remote);
} }
function StreamComponent_div_0_div_4_mat_error_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-error");
    ɵngcc0.ɵɵtext(1, " Nickname is ");
    ɵngcc0.ɵɵelementStart(2, "strong");
    ɵngcc0.ɵɵtext(3, "required");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function StreamComponent_div_0_div_4_mat_error_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-error");
    ɵngcc0.ɵɵtext(1, " Nickname is ");
    ɵngcc0.ɵɵelementStart(2, "strong");
    ɵngcc0.ɵɵtext(3, "too long!");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function StreamComponent_div_0_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵelementStart(1, "button", 19);
    ɵngcc0.ɵɵlistener("click", function StreamComponent_div_0_div_4_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(2); return ctx_r14.toggleNicknameForm(); });
    ɵngcc0.ɵɵelementStart(2, "mat-icon", 20);
    ɵngcc0.ɵɵtext(3, "highlight_off");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "form", 21);
    ɵngcc0.ɵɵelementStart(5, "mat-form-field", 22);
    ɵngcc0.ɵɵelementStart(6, "input", 23, 24);
    ɵngcc0.ɵɵlistener("keypress", function StreamComponent_div_0_div_4_Template_input_keypress_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r16 = ɵngcc0.ɵɵnextContext(2); return ctx_r16.eventKeyPress($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(8, StreamComponent_div_0_div_4_mat_error_8_Template, 4, 0, "mat-error", 17);
    ɵngcc0.ɵɵtemplate(9, StreamComponent_div_0_div_4_mat_error_9_Template, 4, 0, "mat-error", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassProp("fullscreen", ctx_r3.isFullscreen);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵpropertyInterpolate1("placeholder", "Nick: ", ctx_r3._user.nickname, "");
    ɵngcc0.ɵɵproperty("formControl", ctx_r3.nicknameFormControl)("errorStateMatcher", ctx_r3.matcher);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.nicknameFormControl.hasError("required"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.nicknameFormControl.hasError("maxlength"));
} }
function StreamComponent_div_0_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 25);
    ɵngcc0.ɵɵelementStart(1, "mat-icon");
    ɵngcc0.ɵɵtext(2, "mic_off");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function StreamComponent_div_0_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 26);
    ɵngcc0.ɵɵelementStart(1, "mat-icon");
    ɵngcc0.ɵɵtext(2, "videocam_off");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function StreamComponent_div_0_button_16_mat_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon", 30);
    ɵngcc0.ɵɵtext(1, "volume_up");
    ɵngcc0.ɵɵelementEnd();
} }
function StreamComponent_div_0_button_16_mat_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon", 31);
    ɵngcc0.ɵɵtext(1, "volume_off");
    ɵngcc0.ɵɵelementEnd();
} }
function StreamComponent_div_0_button_16_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 27);
    ɵngcc0.ɵɵlistener("click", function StreamComponent_div_0_button_16_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r19 = ɵngcc0.ɵɵnextContext(2); return ctx_r19.toggleSound(); });
    ɵngcc0.ɵɵtemplate(1, StreamComponent_div_0_button_16_mat_icon_1_Template, 2, 0, "mat-icon", 28);
    ɵngcc0.ɵɵtemplate(2, StreamComponent_div_0_button_16_mat_icon_2_Template, 2, 0, "mat-icon", 29);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r6.mutedSound);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.mutedSound);
} }
function StreamComponent_div_0_button_17_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 32);
    ɵngcc0.ɵɵlistener("click", function StreamComponent_div_0_button_17_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r21 = ɵngcc0.ɵɵnextContext(2); return ctx_r21.replaceScreenTrack(); });
    ɵngcc0.ɵɵelementStart(1, "mat-icon", 33);
    ɵngcc0.ɵɵtext(2, "picture_in_picture");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function StreamComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r24 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1, 2);
    ɵngcc0.ɵɵlistener("dblclick", function StreamComponent_div_0_Template_div_dblclick_0_listener() { ɵngcc0.ɵɵrestoreView(_r24); const ctx_r23 = ɵngcc0.ɵɵnextContext(); return ctx_r23.toggleVideoSize(); });
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵtemplate(3, StreamComponent_div_0_div_3_Template, 4, 2, "div", 4);
    ɵngcc0.ɵɵtemplate(4, StreamComponent_div_0_div_4_Template, 10, 7, "div", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "ov-video", 6);
    ɵngcc0.ɵɵlistener("toggleVideoSizeEvent", function StreamComponent_div_0_Template_ov_video_toggleVideoSizeEvent_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r24); const ctx_r25 = ɵngcc0.ɵɵnextContext(); return ctx_r25.toggleVideoSize($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 7);
    ɵngcc0.ɵɵtemplate(7, StreamComponent_div_0_div_7_Template, 3, 0, "div", 8);
    ɵngcc0.ɵɵtemplate(8, StreamComponent_div_0_div_8_Template, 3, 0, "div", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "div", 10);
    ɵngcc0.ɵɵelementStart(10, "button", 11);
    ɵngcc0.ɵɵlistener("click", function StreamComponent_div_0_Template_button_click_10_listener() { ɵngcc0.ɵɵrestoreView(_r24); const ctx_r26 = ɵngcc0.ɵɵnextContext(); return ctx_r26.toggleVideoSize(); });
    ɵngcc0.ɵɵelementStart(11, "mat-icon");
    ɵngcc0.ɵɵtext(12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "button", 12);
    ɵngcc0.ɵɵlistener("click", function StreamComponent_div_0_Template_button_click_13_listener() { ɵngcc0.ɵɵrestoreView(_r24); const ctx_r27 = ɵngcc0.ɵɵnextContext(); return ctx_r27.toggleFullscreen(); });
    ɵngcc0.ɵɵelementStart(14, "mat-icon");
    ɵngcc0.ɵɵtext(15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(16, StreamComponent_div_0_button_16_Template, 3, 2, "button", 13);
    ɵngcc0.ɵɵtemplate(17, StreamComponent_div_0_button_17_Template, 3, 0, "button", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("id", "container-" + ctx_r0._user.streamManager.stream.streamId);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassProp("fullscreen", ctx_r0.isFullscreen);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.toggleNickname);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.toggleNickname && !ctx_r0._user.streamManager.remote);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("streamManager", ctx_r0._user.streamManager)("mutedSound", ctx_r0.mutedSound);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0._user.streamManager.stream.audioActive);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0._user.streamManager.stream.videoActive);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.videoSizeIcon);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.fullscreenIcon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0._user.streamManager.remote);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0._user.streamManager.remote && ctx_r0._user.isScreen());
} }
const _c7 = ["videoElement"];
function ToolbarComponent_button_5_mat_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon", 14);
    ɵngcc0.ɵɵtext(1, "mic");
    ɵngcc0.ɵɵelementEnd();
} }
function ToolbarComponent_button_5_mat_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon", 15);
    ɵngcc0.ɵɵtext(1, "mic_off");
    ɵngcc0.ɵɵelementEnd();
} }
function ToolbarComponent_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 11);
    ɵngcc0.ɵɵlistener("click", function ToolbarComponent_button_5_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.toggleMicrophone(); });
    ɵngcc0.ɵɵtemplate(1, ToolbarComponent_button_5_mat_icon_1_Template, 2, 0, "mat-icon", 12);
    ɵngcc0.ɵɵtemplate(2, ToolbarComponent_button_5_mat_icon_2_Template, 2, 0, "mat-icon", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", ctx_r0.isConnectionLost);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.isWebcamAudioEnabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.isWebcamAudioEnabled);
} }
function ToolbarComponent_button_7_mat_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon", 19);
    ɵngcc0.ɵɵtext(1, "videocam");
    ɵngcc0.ɵɵelementEnd();
} }
function ToolbarComponent_button_7_mat_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon", 20);
    ɵngcc0.ɵɵtext(1, "videocam_off");
    ɵngcc0.ɵɵelementEnd();
} }
function ToolbarComponent_button_7_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 16);
    ɵngcc0.ɵɵlistener("click", function ToolbarComponent_button_7_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.toggleCamera(); });
    ɵngcc0.ɵɵtemplate(1, ToolbarComponent_button_7_mat_icon_1_Template, 2, 0, "mat-icon", 17);
    ɵngcc0.ɵɵtemplate(2, ToolbarComponent_button_7_mat_icon_2_Template, 2, 0, "mat-icon", 18);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", ctx_r1.isConnectionLost);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.isWebcamVideoEnabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r1.isWebcamVideoEnabled);
} }
function ToolbarComponent_button_9_mat_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon", 24);
    ɵngcc0.ɵɵtext(1, "stop_screen_share");
    ɵngcc0.ɵɵelementEnd();
} }
function ToolbarComponent_button_9_mat_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon", 25);
    ɵngcc0.ɵɵtext(1, "screen_share");
    ɵngcc0.ɵɵelementEnd();
} }
function ToolbarComponent_button_9_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 21);
    ɵngcc0.ɵɵlistener("click", function ToolbarComponent_button_9_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17.toggleScreenShare(); });
    ɵngcc0.ɵɵtemplate(1, ToolbarComponent_button_9_mat_icon_1_Template, 2, 0, "mat-icon", 22);
    ɵngcc0.ɵɵtemplate(2, ToolbarComponent_button_9_mat_icon_2_Template, 2, 0, "mat-icon", 23);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", ctx_r2.isConnectionLost);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r2.isScreenEnabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.isScreenEnabled);
} }
function ToolbarComponent_button_11_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 26);
    ɵngcc0.ɵɵlistener("click", function ToolbarComponent_button_11_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.toggleFullscreen(); });
    ɵngcc0.ɵɵelementStart(1, "mat-icon", 27);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", ctx_r3.isConnectionLost);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.fullscreenIcon);
} }
function ToolbarComponent_button_13_mat_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon", 30);
    ɵngcc0.ɵɵtext(1, "voice_over_off");
    ɵngcc0.ɵɵelementEnd();
} }
function ToolbarComponent_button_13_mat_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon", 31);
    ɵngcc0.ɵɵtext(1, "record_voice_over");
    ɵngcc0.ɵɵelementEnd();
} }
function ToolbarComponent_button_13_Template(rf, ctx) { if (rf & 1) {
    const _r24 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 26);
    ɵngcc0.ɵɵlistener("click", function ToolbarComponent_button_13_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r24); const ctx_r23 = ɵngcc0.ɵɵnextContext(); return ctx_r23.toggleSpeakerLayout(); });
    ɵngcc0.ɵɵtemplate(1, ToolbarComponent_button_13_mat_icon_1_Template, 2, 0, "mat-icon", 28);
    ɵngcc0.ɵɵtemplate(2, ToolbarComponent_button_13_mat_icon_2_Template, 2, 0, "mat-icon", 29);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", ctx_r4.isConnectionLost);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r4.isAutoLayout);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.isAutoLayout);
} }
function ToolbarComponent_button_15_Template(rf, ctx) { if (rf & 1) {
    const _r26 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 32);
    ɵngcc0.ɵɵlistener("click", function ToolbarComponent_button_15_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r26); const ctx_r25 = ɵngcc0.ɵɵnextContext(); return ctx_r25.leaveSession(); });
    ɵngcc0.ɵɵelementStart(1, "mat-icon", 33);
    ɵngcc0.ɵɵtext(2, "power_settings_new");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function ToolbarComponent_button_18_Template(rf, ctx) { if (rf & 1) {
    const _r28 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 26);
    ɵngcc0.ɵɵlistener("click", function ToolbarComponent_button_18_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r27 = ɵngcc0.ɵɵnextContext(); return ctx_r27.toggleChat(); });
    ɵngcc0.ɵɵelementStart(1, "mat-icon", 34);
    ɵngcc0.ɵɵtext(2, "chat");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", ctx_r6.isConnectionLost);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("matBadge", ctx_r6.newMessagesNum);
    ɵngcc0.ɵɵproperty("matBadgeHidden", ctx_r6.newMessagesNum === 0);
} }
const _c8 = function (a1, a2) { return { "titleContent": true, "titleContentLight": a1, "titleContentDark": a2 }; };
function ToolbarLogoComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "span", 4);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(2, _c8, ctx_r0.lightTheme, !ctx_r0.lightTheme));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.sessionId);
} }
const _c9 = ["bodyCard"];
function RoomConfigComponent_div_2_div_16_ov_video_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ov-video", 38);
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext();
    const localUser_r9 = ctx_r13.$implicit;
    const i_r10 = ctx_r13.index;
    const ctx_r11 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("streamManager", localUser_r9.streamManager)("className", ctx_r11.localUsers.length > 1 && i_r10 === 0 ? "ovVideoSmall" : "");
} }
function RoomConfigComponent_div_2_div_16_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 39);
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2, "Oops! Camera is not available");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function RoomConfigComponent_div_2_div_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, RoomConfigComponent_div_2_div_16_ov_video_1_Template, 1, 2, "ov-video", 36);
    ɵngcc0.ɵɵtemplate(2, RoomConfigComponent_div_2_div_16_div_2_Template, 3, 0, "div", 37);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const localUser_r9 = ctx.$implicit;
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", localUser_r9.isCamera() && ctx_r2.hasVideoDevices || localUser_r9.isScreen());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", localUser_r9.isCamera() && !ctx_r2.hasVideoDevices);
} }
function RoomConfigComponent_div_2_div_27_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 46);
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2, "Press Avatar Button");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function RoomConfigComponent_div_2_div_27_img_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 47);
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("src", ctx_r15.videoAvatar, ɵngcc0.ɵɵsanitizeUrl);
} }
function RoomConfigComponent_div_2_div_27_mat_spinner_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "mat-spinner", 48);
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("diameter", 70);
} }
function RoomConfigComponent_div_2_div_27_img_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 47);
} if (rf & 2) {
    const ctx_r17 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("src", ctx_r17.randomAvatar, ɵngcc0.ɵɵsanitizeUrl);
} }
function RoomConfigComponent_div_2_div_27_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 40);
    ɵngcc0.ɵɵelementStart(1, "div", 41);
    ɵngcc0.ɵɵelementStart(2, "div", 42);
    ɵngcc0.ɵɵlistener("click", function RoomConfigComponent_div_2_div_27_Template_div_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r18 = ɵngcc0.ɵɵnextContext(2); return ctx_r18.setAvatar("video"); });
    ɵngcc0.ɵɵtemplate(3, RoomConfigComponent_div_2_div_27_div_3_Template, 3, 0, "div", 43);
    ɵngcc0.ɵɵtemplate(4, RoomConfigComponent_div_2_div_27_img_4_Template, 1, 1, "img", 44);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 42);
    ɵngcc0.ɵɵlistener("click", function RoomConfigComponent_div_2_div_27_Template_div_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r20 = ɵngcc0.ɵɵnextContext(2); return ctx_r20.setAvatar("random"); });
    ɵngcc0.ɵɵtemplate(6, RoomConfigComponent_div_2_div_27_mat_spinner_6_Template, 1, 1, "mat-spinner", 45);
    ɵngcc0.ɵɵtemplate(7, RoomConfigComponent_div_2_div_27_img_7_Template, 1, 1, "img", 44);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵstyleProp("background", ctx_r3.avatarSelected === "video" ? "lightgreen" : "transparent", ɵngcc0.ɵɵdefaultStyleSanitizer);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r3.videoAvatar);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.videoAvatar);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵstyleProp("background", ctx_r3.avatarSelected === "random" ? "lightgreen" : "transparent", ɵngcc0.ɵɵdefaultStyleSanitizer);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r3.randomAvatar);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.randomAvatar);
} }
function RoomConfigComponent_div_2_mat_error_38_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-error");
    ɵngcc0.ɵɵtext(1, " Nickname is ");
    ɵngcc0.ɵɵelementStart(2, "strong");
    ɵngcc0.ɵɵtext(3, "required");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function RoomConfigComponent_div_2_mat_error_39_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-error");
    ɵngcc0.ɵɵtext(1, " Nickname is ");
    ɵngcc0.ɵɵelementStart(2, "strong");
    ɵngcc0.ɵɵtext(3, "too long!");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function RoomConfigComponent_div_2_div_40_mat_icon_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon", 55);
    ɵngcc0.ɵɵtext(1, "mic");
    ɵngcc0.ɵɵelementEnd();
} }
function RoomConfigComponent_div_2_div_40_mat_icon_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon", 56);
    ɵngcc0.ɵɵtext(1, "mic_off");
    ɵngcc0.ɵɵelementEnd();
} }
function RoomConfigComponent_div_2_div_40_mat_option_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-option", 57);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const microphone_r24 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("value", microphone_r24.device);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", microphone_r24.label, " ");
} }
function RoomConfigComponent_div_2_div_40_Template(rf, ctx) { if (rf & 1) {
    const _r26 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 24);
    ɵngcc0.ɵɵelementStart(1, "div", 25);
    ɵngcc0.ɵɵelementStart(2, "div", 26);
    ɵngcc0.ɵɵelementStart(3, "button", 49);
    ɵngcc0.ɵɵlistener("click", function RoomConfigComponent_div_2_div_40_Template_button_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r26); const ctx_r25 = ɵngcc0.ɵɵnextContext(2); return ctx_r25.toggleMic(); });
    ɵngcc0.ɵɵtemplate(4, RoomConfigComponent_div_2_div_40_mat_icon_4_Template, 2, 0, "mat-icon", 50);
    ɵngcc0.ɵɵtemplate(5, RoomConfigComponent_div_2_div_40_mat_icon_5_Template, 2, 0, "mat-icon", 51);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 29);
    ɵngcc0.ɵɵelementStart(7, "mat-form-field", 52);
    ɵngcc0.ɵɵelementStart(8, "mat-select", 53);
    ɵngcc0.ɵɵlistener("selectionChange", function RoomConfigComponent_div_2_div_40_Template_mat_select_selectionChange_8_listener($event) { ɵngcc0.ɵɵrestoreView(_r26); const ctx_r27 = ɵngcc0.ɵɵnextContext(2); return ctx_r27.onMicrophoneSelected($event); });
    ɵngcc0.ɵɵtemplate(9, RoomConfigComponent_div_2_div_40_mat_option_9_Template, 2, 2, "mat-option", 54);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.isAudioActive);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r6.isAudioActive);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r6.isAudioActive && ctx_r6.micSelected ? ctx_r6.micSelected.device : "None");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r6.microphones);
} }
function RoomConfigComponent_div_2_div_42_mat_icon_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon", 62);
    ɵngcc0.ɵɵtext(1, "videocam");
    ɵngcc0.ɵɵelementEnd();
} }
function RoomConfigComponent_div_2_div_42_mat_icon_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon", 63);
    ɵngcc0.ɵɵtext(1, "videocam_off");
    ɵngcc0.ɵɵelementEnd();
} }
function RoomConfigComponent_div_2_div_42_mat_option_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-option", 57);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const camera_r31 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("value", camera_r31.device);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", camera_r31.label, " ");
} }
function RoomConfigComponent_div_2_div_42_Template(rf, ctx) { if (rf & 1) {
    const _r33 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 24);
    ɵngcc0.ɵɵelementStart(1, "div", 25);
    ɵngcc0.ɵɵelementStart(2, "div", 26);
    ɵngcc0.ɵɵelementStart(3, "button", 58);
    ɵngcc0.ɵɵlistener("click", function RoomConfigComponent_div_2_div_42_Template_button_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r33); const ctx_r32 = ɵngcc0.ɵɵnextContext(2); return ctx_r32.toggleCam(); });
    ɵngcc0.ɵɵtemplate(4, RoomConfigComponent_div_2_div_42_mat_icon_4_Template, 2, 0, "mat-icon", 59);
    ɵngcc0.ɵɵtemplate(5, RoomConfigComponent_div_2_div_42_mat_icon_5_Template, 2, 0, "mat-icon", 60);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 29);
    ɵngcc0.ɵɵelementStart(7, "mat-form-field", 52);
    ɵngcc0.ɵɵelementStart(8, "mat-select", 61);
    ɵngcc0.ɵɵlistener("selectionChange", function RoomConfigComponent_div_2_div_42_Template_mat_select_selectionChange_8_listener($event) { ɵngcc0.ɵɵrestoreView(_r33); const ctx_r34 = ɵngcc0.ɵɵnextContext(2); return ctx_r34.onCameraSelected($event); });
    ɵngcc0.ɵɵtemplate(9, RoomConfigComponent_div_2_div_42_mat_option_9_Template, 2, 2, "mat-option", 54);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r7.isVideoActive);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r7.isVideoActive);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r7.isVideoActive && ctx_r7.camSelected ? ctx_r7.camSelected.device : "None");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r7.cameras);
} }
function RoomConfigComponent_div_2_div_44_mat_icon_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon", 68);
    ɵngcc0.ɵɵtext(1, "screen_share");
    ɵngcc0.ɵɵelementEnd();
} }
function RoomConfigComponent_div_2_div_44_mat_icon_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon", 69);
    ɵngcc0.ɵɵtext(1, " stop_screen_share");
    ɵngcc0.ɵɵelementEnd();
} }
function RoomConfigComponent_div_2_div_44_Template(rf, ctx) { if (rf & 1) {
    const _r38 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 24);
    ɵngcc0.ɵɵelementStart(1, "div", 25);
    ɵngcc0.ɵɵelementStart(2, "div", 26);
    ɵngcc0.ɵɵelementStart(3, "button", 64);
    ɵngcc0.ɵɵlistener("click", function RoomConfigComponent_div_2_div_44_Template_button_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r38); const ctx_r37 = ɵngcc0.ɵɵnextContext(2); return ctx_r37.toggleScreenShare(); });
    ɵngcc0.ɵɵtemplate(4, RoomConfigComponent_div_2_div_44_mat_icon_4_Template, 2, 0, "mat-icon", 65);
    ɵngcc0.ɵɵtemplate(5, RoomConfigComponent_div_2_div_44_mat_icon_5_Template, 2, 0, "mat-icon", 66);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 29);
    ɵngcc0.ɵɵelementStart(7, "mat-form-field", 52);
    ɵngcc0.ɵɵelement(8, "input", 67);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r8.oVSessionService.isScreenShareEnabled());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r8.oVSessionService.isScreenShareEnabled());
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r8.oVSessionService.isScreenShareEnabled() ? "Screen" : "None");
} }
function RoomConfigComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r40 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "div", 4);
    ɵngcc0.ɵɵelementStart(3, "div", 5);
    ɵngcc0.ɵɵelementStart(4, "div", 6);
    ɵngcc0.ɵɵelement(5, "img", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "h3", 8);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "button", 9);
    ɵngcc0.ɵɵlistener("click", function RoomConfigComponent_div_2_Template_button_click_8_listener() { ɵngcc0.ɵɵrestoreView(_r40); const ctx_r39 = ɵngcc0.ɵɵnextContext(); return ctx_r39.close(); });
    ɵngcc0.ɵɵelementStart(9, "mat-icon", 10);
    ɵngcc0.ɵɵtext(10, "highlight_off");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "div", 11, 12);
    ɵngcc0.ɵɵelementStart(13, "div", 13);
    ɵngcc0.ɵɵelementStart(14, "div", 14);
    ɵngcc0.ɵɵelementStart(15, "div", 15);
    ɵngcc0.ɵɵtemplate(16, RoomConfigComponent_div_2_div_16_Template, 3, 2, "div", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(17, "div", 17);
    ɵngcc0.ɵɵelementStart(18, "button", 18);
    ɵngcc0.ɵɵlistener("click", function RoomConfigComponent_div_2_Template_button_click_18_listener() { ɵngcc0.ɵɵrestoreView(_r40); const ctx_r41 = ɵngcc0.ɵɵnextContext(); return ctx_r41.takePhoto(); });
    ɵngcc0.ɵɵelementStart(19, "mat-icon", 19);
    ɵngcc0.ɵɵtext(20, "photo_camera");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(21, "span", 20);
    ɵngcc0.ɵɵtext(22, "Capture Avatar");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(23, "div", 21);
    ɵngcc0.ɵɵelementStart(24, "div", 22);
    ɵngcc0.ɵɵelementStart(25, "h3");
    ɵngcc0.ɵɵtext(26, "Avatar");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(27, RoomConfigComponent_div_2_div_27_Template, 8, 8, "div", 23);
    ɵngcc0.ɵɵelementStart(28, "div", 24);
    ɵngcc0.ɵɵelementStart(29, "div", 25);
    ɵngcc0.ɵɵelementStart(30, "div", 26);
    ɵngcc0.ɵɵelementStart(31, "button", 27);
    ɵngcc0.ɵɵlistener("click", function RoomConfigComponent_div_2_Template_button_click_31_listener() { ɵngcc0.ɵɵrestoreView(_r40); const ctx_r42 = ɵngcc0.ɵɵnextContext(); return ctx_r42.setNicknameForm(); });
    ɵngcc0.ɵɵelementStart(32, "mat-icon", 28);
    ɵngcc0.ɵɵtext(33, "person");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(34, "div", 29);
    ɵngcc0.ɵɵelementStart(35, "form", 30);
    ɵngcc0.ɵɵelementStart(36, "mat-form-field");
    ɵngcc0.ɵɵelementStart(37, "input", 31);
    ɵngcc0.ɵɵlistener("keypress", function RoomConfigComponent_div_2_Template_input_keypress_37_listener($event) { ɵngcc0.ɵɵrestoreView(_r40); const ctx_r43 = ɵngcc0.ɵɵnextContext(); return ctx_r43.eventKeyPress($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(38, RoomConfigComponent_div_2_mat_error_38_Template, 4, 0, "mat-error", 32);
    ɵngcc0.ɵɵtemplate(39, RoomConfigComponent_div_2_mat_error_39_Template, 4, 0, "mat-error", 32);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(40, RoomConfigComponent_div_2_div_40_Template, 10, 4, "div", 33);
    ɵngcc0.ɵɵpipe(41, "hasAudio");
    ɵngcc0.ɵɵtemplate(42, RoomConfigComponent_div_2_div_42_Template, 10, 4, "div", 33);
    ɵngcc0.ɵɵpipe(43, "hasVideo");
    ɵngcc0.ɵɵtemplate(44, RoomConfigComponent_div_2_div_44_Template, 9, 3, "div", 33);
    ɵngcc0.ɵɵpipe(45, "hasScreenSharing");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(46, "div", 34);
    ɵngcc0.ɵɵelementStart(47, "button", 35);
    ɵngcc0.ɵɵlistener("click", function RoomConfigComponent_div_2_Template_button_click_47_listener() { ɵngcc0.ɵɵrestoreView(_r40); const ctx_r44 = ɵngcc0.ɵɵnextContext(); return ctx_r44.joinSession(); });
    ɵngcc0.ɵɵtext(48, "JOIN");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.mySessionId);
    ɵngcc0.ɵɵadvance(9);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.localUsers);
    ɵngcc0.ɵɵadvance(11);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.hasVideoDevices);
    ɵngcc0.ɵɵadvance(10);
    ɵngcc0.ɵɵproperty("formControl", ctx_r0.nicknameFormControl)("errorStateMatcher", ctx_r0.matcher);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.nicknameFormControl.hasError("required"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.nicknameFormControl.hasError("maxlength"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.hasAudioDevices && ɵngcc0.ɵɵpipeBind1(41, 10, ctx_r0.ovSettings));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.hasVideoDevices && ɵngcc0.ɵɵpipeBind1(43, 12, ctx_r0.ovSettings));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(45, 14, ctx_r0.ovSettings));
} }
const _c10 = function (a0) { return { display: a0 }; };
export * from 'openvidu-browser';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogModule } from '@angular/material/dialog';
import { HttpHeaders, HttpClient, HttpClientModule } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { CommonModule } from '@angular/common';
import { FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxLinkifyjsService, NgxLinkifyjsModule } from 'ngx-linkifyjs';
import { FlexLayoutModule } from '@angular/flex-layout';

class OpenViduLayout {
    /**
     * Update the layout container
     */
    updateLayout() {
        setTimeout(() => {
            if (this.layoutContainer.style.display === 'none') {
                return;
            }
            let id = this.layoutContainer.id;
            if (!id) {
                id = 'OT_' + this.cheapUUID();
                this.layoutContainer.id = id;
            }
            const HEIGHT = this.getHeight(this.layoutContainer) -
                this.getCSSNumber(this.layoutContainer, 'borderTop') -
                this.getCSSNumber(this.layoutContainer, 'borderBottom');
            const WIDTH = this.getWidth(this.layoutContainer) -
                this.getCSSNumber(this.layoutContainer, 'borderLeft') -
                this.getCSSNumber(this.layoutContainer, 'borderRight');
            const availableRatio = HEIGHT / WIDTH;
            let offsetLeft = 0;
            let offsetTop = 0;
            let bigOffsetTop = 0;
            let bigOffsetLeft = 0;
            const bigOnes = Array.prototype.filter.call(this.layoutContainer.querySelectorAll('#' + id + '>.' + this.opts.bigClass), this.filterDisplayNone);
            const smallOnes = Array.prototype.filter.call(this.layoutContainer.querySelectorAll('#' + id + '>*:not(.' + this.opts.bigClass + ')'), this.filterDisplayNone);
            if (bigOnes.length > 0 && smallOnes.length > 0) {
                let bigWidth, bigHeight;
                if (availableRatio > this.getVideoRatio(bigOnes[0])) {
                    // We are tall, going to take up the whole width and arrange small
                    // guys at the bottom
                    bigWidth = WIDTH;
                    bigHeight = Math.floor(HEIGHT * this.opts.bigPercentage);
                    offsetTop = bigHeight;
                    bigOffsetTop = HEIGHT - offsetTop;
                }
                else {
                    // We are wide, going to take up the whole height and arrange the small
                    // guys on the right
                    bigHeight = HEIGHT;
                    bigWidth = Math.floor(WIDTH * this.opts.bigPercentage);
                    offsetLeft = bigWidth;
                    bigOffsetLeft = WIDTH - offsetLeft;
                }
                if (this.opts.bigFirst) {
                    this.arrange(bigOnes, bigWidth, bigHeight, 0, 0, this.opts.bigFixedRatio, this.opts.bigMinRatio, this.opts.bigMaxRatio, this.opts.animate);
                    this.arrange(smallOnes, WIDTH - offsetLeft, HEIGHT - offsetTop, offsetLeft, offsetTop, this.opts.fixedRatio, this.opts.minRatio, this.opts.maxRatio, this.opts.animate);
                }
                else {
                    this.arrange(smallOnes, WIDTH - offsetLeft, HEIGHT - offsetTop, 0, 0, this.opts.fixedRatio, this.opts.minRatio, this.opts.maxRatio, this.opts.animate);
                    this.arrange(bigOnes, bigWidth, bigHeight, bigOffsetLeft, bigOffsetTop, this.opts.bigFixedRatio, this.opts.bigMinRatio, this.opts.bigMaxRatio, this.opts.animate);
                }
            }
            else if (bigOnes.length > 0 && smallOnes.length === 0) {
                this
                    // We only have one bigOne just center it
                    .arrange(bigOnes, WIDTH, HEIGHT, 0, 0, this.opts.bigFixedRatio, this.opts.bigMinRatio, this.opts.bigMaxRatio, this.opts.animate);
            }
            else {
                this.arrange(smallOnes, WIDTH - offsetLeft, HEIGHT - offsetTop, offsetLeft, offsetTop, this.opts.fixedRatio, this.opts.minRatio, this.opts.maxRatio, this.opts.animate);
            }
        }, 50);
    }
    /**
     * Initialize the layout inside of the container with the options required
     * @param container
     * @param opts
     */
    initLayoutContainer(container, opts) {
        this.opts = {
            maxRatio: opts.maxRatio != null ? opts.maxRatio : 3 / 2,
            minRatio: opts.minRatio != null ? opts.minRatio : 9 / 16,
            fixedRatio: opts.fixedRatio != null ? opts.fixedRatio : false,
            animate: opts.animate != null ? opts.animate : false,
            bigClass: opts.bigClass != null ? opts.bigClass : 'OT_big',
            bigPercentage: opts.bigPercentage != null ? opts.bigPercentage : 0.8,
            bigFixedRatio: opts.bigFixedRatio != null ? opts.bigFixedRatio : false,
            bigMaxRatio: opts.bigMaxRatio != null ? opts.bigMaxRatio : 3 / 2,
            bigMinRatio: opts.bigMinRatio != null ? opts.bigMinRatio : 9 / 16,
            bigFirst: opts.bigFirst != null ? opts.bigFirst : true
        };
        this.layoutContainer = typeof container === 'string' ? $(container) : container;
    }
    /**
     * Set the layout configuration
     * @param options
     */
    setLayoutOptions(options) {
        this.opts = options;
    }
    /**
     * @hidden
     */
    fixAspectRatio(elem, width) {
        const sub = elem.querySelector('.OT_root');
        if (sub) {
            // If this is the parent of a subscriber or publisher then we need
            // to force the mutation observer on the publisher or subscriber to
            // trigger to get it to fix it's layout
            const oldWidth = sub.style.width;
            sub.style.width = width + 'px';
            // sub.style.height = height + 'px';
            sub.style.width = oldWidth || '';
        }
    }
    /**
     * @hidden
     */
    positionElement(elem, x, y, width, height, animate) {
        const targetPosition = {
            left: x + 'px',
            top: y + 'px',
            width: width + 'px',
            height: height + 'px'
        };
        this.fixAspectRatio(elem, width);
        if (animate && $) {
            $(elem).stop();
            $(elem).animate(targetPosition, animate.duration || 200, animate.easing || 'swing', () => {
                this.fixAspectRatio(elem, width);
                if (animate.complete) {
                    animate.complete.call(this);
                }
            });
        }
        else {
            $(elem).css(targetPosition);
        }
        this.fixAspectRatio(elem, width);
    }
    /**
     * @hidden
     */
    getVideoRatio(elem) {
        if (!elem) {
            return 3 / 4;
        }
        const video = elem.querySelector('video');
        if (video && video.videoHeight && video.videoWidth) {
            return video.videoHeight / video.videoWidth;
        }
        else if (elem.videoHeight && elem.videoWidth) {
            return elem.videoHeight / elem.videoWidth;
        }
        return 3 / 4;
    }
    /**
     * @hidden
     */
    getCSSNumber(elem, prop) {
        const cssStr = $(elem).css(prop);
        return cssStr ? parseInt(cssStr, 10) : 0;
    }
    /**
     * @hidden
     */
    // Really cheap UUID function
    cheapUUID() {
        return (Math.random() * 100000000).toFixed(0);
    }
    /**
     * @hidden
     */
    getHeight(elem) {
        const heightStr = $(elem).css('height');
        return heightStr ? parseInt(heightStr, 10) : 0;
    }
    /**
     * @hidden
     */
    getWidth(elem) {
        const widthStr = $(elem).css('width');
        return widthStr ? parseInt(widthStr, 10) : 0;
    }
    /**
     * @hidden
     */
    getBestDimensions(minR, maxR, count, WIDTH, HEIGHT, targetHeight) {
        let maxArea, targetCols, targetRows, targetWidth, tWidth, tHeight, tRatio;
        // Iterate through every possible combination of rows and columns
        // and see which one has the least amount of whitespace
        for (let i = 1; i <= count; i++) {
            const colsAux = i;
            const rowsAux = Math.ceil(count / colsAux);
            // Try taking up the whole height and width
            tHeight = Math.floor(HEIGHT / rowsAux);
            tWidth = Math.floor(WIDTH / colsAux);
            tRatio = tHeight / tWidth;
            if (tRatio > maxR) {
                // We went over decrease the height
                tRatio = maxR;
                tHeight = tWidth * tRatio;
            }
            else if (tRatio < minR) {
                // We went under decrease the width
                tRatio = minR;
                tWidth = tHeight / tRatio;
            }
            const area = tWidth * tHeight * count;
            // If this width and height takes up the most space then we're going with that
            if (maxArea === undefined || area > maxArea) {
                maxArea = area;
                targetHeight = tHeight;
                targetWidth = tWidth;
                targetCols = colsAux;
                targetRows = rowsAux;
            }
        }
        return {
            maxArea: maxArea,
            targetCols: targetCols,
            targetRows: targetRows,
            targetHeight: targetHeight,
            targetWidth: targetWidth,
            ratio: targetHeight / targetWidth
        };
    }
    /**
     * @hidden
     */
    arrange(children, WIDTH, HEIGHT, offsetLeft, offsetTop, fixedRatio, minRatio, maxRatio, animate) {
        let targetHeight;
        const count = children.length;
        let dimensions;
        if (!fixedRatio) {
            dimensions = this.getBestDimensions(minRatio, maxRatio, count, WIDTH, HEIGHT, targetHeight);
        }
        else {
            // Use the ratio of the first video element we find to approximate
            const ratio = this.getVideoRatio(children.length > 0 ? children[0] : null);
            dimensions = this.getBestDimensions(ratio, ratio, count, WIDTH, HEIGHT, targetHeight);
        }
        // Loop through each stream in the container and place it inside
        let x = 0, y = 0;
        const rows = [];
        let row;
        // Iterate through the children and create an array with a new item for each row
        // and calculate the width of each row so that we know if we go over the size and need
        // to adjust
        for (let i = 0; i < children.length; i++) {
            if (i % dimensions.targetCols === 0) {
                // This is a new row
                row = {
                    children: [],
                    width: 0,
                    height: 0
                };
                rows.push(row);
            }
            const elem = children[i];
            row.children.push(elem);
            let targetWidth = dimensions.targetWidth;
            targetHeight = dimensions.targetHeight;
            // If we're using a fixedRatio then we need to set the correct ratio for this element
            if (fixedRatio) {
                targetWidth = targetHeight / this.getVideoRatio(elem);
            }
            row.width += targetWidth;
            row.height = targetHeight;
        }
        // Calculate total row height adjusting if we go too wide
        let totalRowHeight = 0;
        let remainingShortRows = 0;
        for (let i = 0; i < rows.length; i++) {
            row = rows[i];
            if (row.width > WIDTH) {
                // Went over on the width, need to adjust the height proportionally
                row.height = Math.floor(row.height * (WIDTH / row.width));
                row.width = WIDTH;
            }
            else if (row.width < WIDTH) {
                remainingShortRows += 1;
            }
            totalRowHeight += row.height;
        }
        if (totalRowHeight < HEIGHT && remainingShortRows > 0) {
            // We can grow some of the rows, we're not taking up the whole height
            let remainingHeightDiff = HEIGHT - totalRowHeight;
            totalRowHeight = 0;
            for (let i = 0; i < rows.length; i++) {
                row = rows[i];
                if (row.width < WIDTH) {
                    // Evenly distribute the extra height between the short rows
                    let extraHeight = remainingHeightDiff / remainingShortRows;
                    if (extraHeight / row.height > (WIDTH - row.width) / row.width) {
                        // We can't go that big or we'll go too wide
                        extraHeight = Math.floor(((WIDTH - row.width) / row.width) * row.height);
                    }
                    row.width += Math.floor((extraHeight / row.height) * row.width);
                    row.height += extraHeight;
                    remainingHeightDiff -= extraHeight;
                    remainingShortRows -= 1;
                }
                totalRowHeight += row.height;
            }
        }
        // vertical centering
        y = (HEIGHT - totalRowHeight) / 2;
        // Iterate through each row and place each child
        for (let i = 0; i < rows.length; i++) {
            row = rows[i];
            // center the row
            const rowMarginLeft = (WIDTH - row.width) / 2;
            x = rowMarginLeft;
            for (let j = 0; j < row.children.length; j++) {
                const elem = row.children[j];
                let targetWidth = dimensions.targetWidth;
                targetHeight = row.height;
                // If we're using a fixedRatio then we need to set the correct ratio for this element
                if (fixedRatio) {
                    targetWidth = Math.floor(targetHeight / this.getVideoRatio(elem));
                }
                elem.style.position = 'absolute';
                // $(elem).css('position', 'absolute');
                const actualWidth = targetWidth -
                    this.getCSSNumber(elem, 'paddingLeft') -
                    this.getCSSNumber(elem, 'paddingRight') -
                    this.getCSSNumber(elem, 'marginLeft') -
                    this.getCSSNumber(elem, 'marginRight') -
                    this.getCSSNumber(elem, 'borderLeft') -
                    this.getCSSNumber(elem, 'borderRight');
                const actualHeight = targetHeight -
                    this.getCSSNumber(elem, 'paddingTop') -
                    this.getCSSNumber(elem, 'paddingBottom') -
                    this.getCSSNumber(elem, 'marginTop') -
                    this.getCSSNumber(elem, 'marginBottom') -
                    this.getCSSNumber(elem, 'borderTop') -
                    this.getCSSNumber(elem, 'borderBottom');
                this.positionElement(elem, x + offsetLeft, y + offsetTop, actualWidth, actualHeight, animate);
                x += targetWidth;
            }
            y += targetHeight;
        }
    }
    /**
     * @hidden
     */
    filterDisplayNone(element) {
        return element.style.display !== 'none';
    }
}

var VideoType;
(function (VideoType) {
    VideoType["CAMERA"] = "CAMERA";
    VideoType["SCREEN"] = "SCREEN";
    VideoType["CUSTOM"] = "CUSTOM";
})(VideoType || (VideoType = {}));
var ScreenType;
(function (ScreenType) {
    ScreenType["WINDOW"] = "window";
    ScreenType["SCREEN"] = "screen";
})(ScreenType || (ScreenType = {}));

/**
 * Packs all the information about the user
 */
class UserModel {
    /**
     * @hidden
     */
    constructor(connectionId, streamManager, nickname) {
        this.connectionId = connectionId || '';
        this.nickname = nickname || 'OpenVidu';
        this.streamManager = streamManager || null;
    }
    /**
     * Return `true` if audio track is active and `false` if audio track is muted
     */
    isAudioActive() {
        var _a, _b;
        // console.log("isAudioActive");
        return (_b = (_a = this.streamManager) === null || _a === void 0 ? void 0 : _a.stream) === null || _b === void 0 ? void 0 : _b.audioActive;
    }
    /**
     * Return `true` if video track is active and `false` if video track is muted
     */
    isVideoActive() {
        var _a, _b;
        // console.log("isVideoActive");
        return (_b = (_a = this.streamManager) === null || _a === void 0 ? void 0 : _a.stream) === null || _b === void 0 ? void 0 : _b.videoActive;
    }
    /**
     * Return the connection ID
     */
    getConnectionId() {
        var _a, _b, _c;
        return (_c = (_b = (_a = this.streamManager) === null || _a === void 0 ? void 0 : _a.stream) === null || _b === void 0 ? void 0 : _b.connection) === null || _c === void 0 ? void 0 : _c.connectionId;
    }
    /**
     * Return the user nickname
     */
    getNickname() {
        return this.nickname;
    }
    /**
     * Return the [[streamManger]] object
     */
    getStreamManager() {
        return this.streamManager;
    }
    /**
     * Return the user avatar
     */
    getAvatar() {
        return this.videoAvatar ? this.videoAvatar.toDataURL() : this.randomAvatar;
    }
    /**
     * Return `true` if user has a local role and `false` if not
     */
    isLocal() {
        return !this.isRemote();
    }
    /**
     * Return `true` if user has a remote role and `false` if not
     */
    isRemote() {
        var _a;
        return (_a = this.streamManager) === null || _a === void 0 ? void 0 : _a.remote;
    }
    /**
     * Return `true` if user has a screen role and `false` if not
     */
    isScreen() {
        var _a, _b;
        // console.log("isScreen");
        return ((_b = (_a = this.streamManager) === null || _a === void 0 ? void 0 : _a.stream) === null || _b === void 0 ? void 0 : _b.typeOfVideo) === VideoType.SCREEN;
    }
    /**
     * Return `true` if user has a camera role and `false` if not
     */
    isCamera() {
        var _a, _b;
        // console.log("CCC");
        return ((_b = (_a = this.streamManager) === null || _a === void 0 ? void 0 : _a.stream) === null || _b === void 0 ? void 0 : _b.typeOfVideo) === VideoType.CAMERA || (this.isLocal() && !this.isScreen());
    }
    /**
     * Set the streamManager value object
     * @param streamManager value of streamManager
     */
    setStreamManager(streamManager) {
        this.streamManager = streamManager;
    }
    /**
     * Set the user nickname value
     * @param nickname value of user nickname
     */
    setNickname(nickname) {
        this.nickname = nickname;
    }
    isVideoSizeBig() {
        return this.videoSizeBig;
    }
    /**
     * @hidden
     */
    setVideoSizeBig(big) {
        this.videoSizeBig = big;
    }
    /**
     * @hidden
     */
    setUserAvatar(img) {
        return new Promise(resolve => {
            if (!img) {
                this.createVideoAvatar();
                const video = document.getElementById('video-' + this.getStreamManager().stream.streamId);
                const avatar = this.videoAvatar.getContext('2d');
                avatar.drawImage(video, 200, 120, 285, 285, 0, 0, 100, 100);
                resolve();
            }
            else {
                this.randomAvatar = img;
                resolve();
            }
        });
    }
    removeVideoAvatar() {
        this.videoAvatar = null;
    }
    /**
     * @hidden
     */
    createVideoAvatar() {
        this.videoAvatar = document.createElement('canvas');
        this.videoAvatar.className = 'user-img';
        this.videoAvatar.width = 100;
        this.videoAvatar.height = 100;
    }
}

var AvatarType;
(function (AvatarType) {
    AvatarType["RANDOM"] = "random";
    AvatarType["VIDEO"] = "video";
})(AvatarType || (AvatarType = {}));

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
const environment = {
    production: false,
    openvidu_url: '',
    openvidu_secret: ''
};
/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

let LoggerService = class LoggerService {
    constructor() {
        this.log = window.console;
        this.LOG_FNS = [];
        this.MSG_PREFIXES = [
            ['[', ']'],
            ['[', '] WARN: '],
            ['[', '] ERROR: ']
        ];
        this.LOG_FNS = [this.log.log, this.log.warn, this.log.error];
    }
    get(prefix) {
        const prodMode = environment.production;
        const loggerFns = this.LOG_FNS.map((logTemplFn, i) => {
            return logTemplFn.bind(this.log, this.MSG_PREFIXES[i][0] + prefix + this.MSG_PREFIXES[i][1]);
        });
        return {
            d: function (...args) {
                if (!prodMode) {
                    loggerFns[0].apply(this.log, arguments);
                }
            },
            w: function (...args) {
                loggerFns[1].apply(this.log, arguments);
            },
            e: function (...args) {
                loggerFns[2].apply(this.log, arguments);
            }
        };
    }
};
LoggerService.ɵfac = function LoggerService_Factory(t) { return new (t || LoggerService)(); };
LoggerService.ɵprov = ɵɵdefineInjectable({ factory: function LoggerService_Factory() { return new LoggerService(); }, token: LoggerService, providedIn: "root" });
LoggerService = __decorate([ __metadata("design:paramtypes", [])
], LoggerService);

let OpenViduSessionService = class OpenViduSessionService {
    constructor(loggerSrv) {
        this.loggerSrv = loggerSrv;
        this._OVUsers = new BehaviorSubject([]);
        this.OV = null;
        this.OVScreen = null;
        this.webcamSession = null;
        this.screenSession = null;
        this.webcamUser = null;
        this.screenUser = null;
        this.videoSource = undefined;
        this.audioSource = undefined;
        this.sessionId = '';
        this.screenMediaStream = null;
        this.webcamMediaStream = null;
        this.log = this.loggerSrv.get('OpenViduSessionService');
        this.OV = new OpenVidu();
        this.OVScreen = new OpenVidu();
        this.OVUsers = this._OVUsers.asObservable();
        this.webcamUser = new UserModel();
        this._OVUsers.next([this.webcamUser]);
    }
    initSessions() {
        this.webcamSession = this.OV.initSession();
        this.screenSession = this.OVScreen.initSession();
    }
    getWebcamSession() {
        return this.webcamSession;
    }
    getConnectedUserSession() {
        return this.isWebCamEnabled() ? this.getWebcamSession() : this.getScreenSession();
    }
    getScreenSession() {
        return this.screenSession;
    }
    connectWebcamSession(token) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!!token) {
                yield this.webcamSession.connect(token, { clientData: this.getWebcamUserName(), avatar: this.getWebCamAvatar() });
            }
        });
    }
    connectScreenSession(token) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!!token) {
                yield this.screenSession.connect(token, { clientData: this.getScreenUserName(), avatar: this.getWebCamAvatar() });
            }
        });
    }
    publishWebcam() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.webcamSession.capabilities.publish) {
                const publisher = this.webcamUser.getStreamManager();
                if (!!publisher) {
                    return yield this.webcamSession.publish(publisher);
                }
            }
            this.log.w('User cannot publish');
        });
    }
    publishScreen() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.screenSession.capabilities.publish) {
                const publisher = this.screenUser.getStreamManager();
                if (!!publisher) {
                    return yield this.screenSession.publish(publisher);
                }
            }
            this.log.w('User cannot publish');
        });
    }
    unpublishWebcam() {
        const publisher = this.webcamUser.getStreamManager();
        if (!!publisher) {
            this.publishScreenAudio(this.hasWebcamAudioActive());
            this.webcamSession.unpublish(publisher);
        }
    }
    unpublishScreen() {
        const publisher = this.screenUser.getStreamManager();
        if (!!publisher) {
            this.screenSession.unpublish(publisher);
        }
    }
    enableWebcamUser() {
        this._OVUsers.next([this.webcamUser, this.screenUser]);
    }
    disableWebcamUser() {
        // this.destryowebcamUser();
        this._OVUsers.next([this.screenUser]);
    }
    enableScreenUser(screenPublisher) {
        var _a, _b;
        const connectionId = (_b = (_a = this.screenSession) === null || _a === void 0 ? void 0 : _a.connection) === null || _b === void 0 ? void 0 : _b.connectionId;
        this.screenUser = new UserModel(connectionId, screenPublisher, this.getScreenUserName());
        this.screenUser.setUserAvatar(this.webcamUser.getAvatar());
        if (this.isWebCamEnabled()) {
            this._OVUsers.next([this.webcamUser, this.screenUser]);
            return;
        }
        this.log.d('ENABLED SCREEN SHARE');
        this._OVUsers.next([this.screenUser]);
    }
    disableScreenUser() {
        this.destryoScreenUser();
        this._OVUsers.next([this.webcamUser]);
    }
    initCamPublisher(targetElement, properties) {
        const publisher = this.initPublisher(targetElement, properties);
        this.webcamUser.setStreamManager(publisher);
        return publisher;
    }
    publishVideo(isVideoActive) {
        this.webcamUser.getStreamManager().publishVideo(isVideoActive);
        // Send event to subscribers because of viedeo has changed and view must update
        this._OVUsers.next(this._OVUsers.getValue());
    }
    publishWebcamAudio(audio) {
        var _a;
        const publisher = (_a = this.webcamUser) === null || _a === void 0 ? void 0 : _a.getStreamManager();
        if (!!publisher) {
            publisher.publishAudio(audio);
        }
    }
    publishScreenAudio(audio) {
        var _a;
        const publisher = (_a = this.screenUser) === null || _a === void 0 ? void 0 : _a.getStreamManager();
        if (!!publisher) {
            publisher.publishAudio(audio);
        }
    }
    replaceTrack(videoSource, audioSource, mirror = true) {
        return new Promise((resolve, reject) => {
            if (!!videoSource) {
                this.log.d('Replacing video track ' + videoSource);
                this.videoSource = videoSource;
                // this.stopVideoTracks(this.webcamUser.getStreamManager().stream.getMediaStream());
            }
            if (!!audioSource) {
                this.log.d('Replacing audio track ' + audioSource);
                this.audioSource = audioSource;
                // this.stopAudioTracks(this.webcamUser.getStreamManager().stream.getMediaStream());
            }
            this.destryoWebcamUser();
            const properties = this.createProperties(this.videoSource, this.audioSource, this.hasWebcamVideoActive(), this.hasWebcamAudioActive(), mirror);
            const publisher = this.initCamPublisher(undefined, properties);
            publisher.once('streamPlaying', () => {
                this.webcamUser.setStreamManager(publisher);
                resolve();
            });
            publisher.once('accessDenied', () => {
                reject();
            });
            // Reeplace track method
            // this.webcamMediaStream = await this.OV.getUserMedia(properties);
            // const track: MediaStreamTrack = !!videoSource
            // 	? this.webcamMediaStream.getVideoTracks()[0]
            // 	: this.webcamMediaStream.getAudioTracks()[0];
            // try {
            // 	await (<Publisher>this.webcamUser.getStreamManager()).replaceTrack(track);
            // } catch (error) {
            // 	this.log.e('Error replacing track ', error);
            // }
        });
    }
    replaceScreenTrack() {
        return __awaiter(this, void 0, void 0, function* () {
            const videoSource = ScreenType.SCREEN;
            const hasAudio = !this.isWebCamEnabled();
            const properties = this.createProperties(videoSource, undefined, true, hasAudio, false);
            this.stopScreenTracks();
            this.screenMediaStream = yield this.OVScreen.getUserMedia(properties);
            yield this.screenUser.getStreamManager().replaceTrack(this.screenMediaStream.getVideoTracks()[0]);
        });
    }
    initScreenPublisher(targetElement, properties) {
        this.log.d('init screen properties', properties);
        return this.initPublisher(targetElement, properties);
    }
    destroyUsers() {
        this.destryoScreenUser();
        this.destryoWebcamUser();
    }
    disconnect() {
        if (this.webcamSession) {
            this.log.d('Disconnecting screen session');
            this.webcamSession.disconnect();
            // this.stopWebcamTracks();
            this.webcamSession = null;
        }
        if (this.screenSession) {
            // Timeout neccessary to avoid race conditin error:
            // OpenVidu Error Remote connection unknown when 'onParticipantLeft'. Existing remote connections: []
            setTimeout(() => {
                this.log.d('Disconnecting screen session');
                this.screenSession.disconnect();
                this.stopScreenTracks();
                this.screenSession = null;
            }, 50);
        }
        this.destroyUsers();
        this.screenUser = null;
        this.videoSource = undefined;
        this.audioSource = undefined;
        this.sessionId = '';
        this.webcamUser = new UserModel();
        this._OVUsers.next([this.webcamUser]);
    }
    isWebCamEnabled() {
        return this._OVUsers.getValue()[0].isCamera();
    }
    isOnlyScreenConnected() {
        return this._OVUsers.getValue()[0].isScreen();
    }
    hasWebcamVideoActive() {
        return this.webcamUser.isVideoActive();
    }
    hasWebcamAudioActive() {
        var _a;
        return (_a = this.webcamUser) === null || _a === void 0 ? void 0 : _a.isAudioActive();
    }
    hasScreenAudioActive() {
        var _a;
        return (_a = this.screenUser) === null || _a === void 0 ? void 0 : _a.isAudioActive();
    }
    areBothConnected() {
        return this._OVUsers.getValue().length === 2;
    }
    isOnlyWebcamConnected() {
        return this.isWebCamEnabled() && !this.areBothConnected();
    }
    isScreenShareEnabled() {
        return this.areBothConnected() || this.isOnlyScreenConnected();
    }
    isMyOwnConnection(connectionId) {
        var _a, _b;
        return ((_a = this.webcamUser) === null || _a === void 0 ? void 0 : _a.getConnectionId()) === connectionId || ((_b = this.screenUser) === null || _b === void 0 ? void 0 : _b.getConnectionId()) === connectionId;
    }
    createProperties(videoSource, audioSource, publishVideo, publishAudio, mirror) {
        return {
            videoSource,
            audioSource,
            publishVideo,
            publishAudio,
            mirror
        };
    }
    setSessionId(sessionId) {
        this.sessionId = sessionId;
    }
    getSessionId() {
        return this.sessionId;
    }
    setWebcamAvatar() {
        this.webcamUser.setUserAvatar();
    }
    setAvatar(option, avatar) {
        if ((option === AvatarType.RANDOM && avatar) || (AvatarType.VIDEO && avatar)) {
            if (option === AvatarType.RANDOM) {
                this.webcamUser.setUserAvatar(avatar);
            }
        }
    }
    setWebcamName(nickname) {
        this.webcamUser.setNickname(nickname);
    }
    getWebCamAvatar() {
        return this.webcamUser.getAvatar();
    }
    getWebcamUserName() {
        return this.webcamUser.getNickname();
    }
    getScreenUserName() {
        return this.getWebcamUserName() + '_SCREEN';
    }
    resetUsersZoom() {
        var _a, _b;
        (_a = this.webcamUser) === null || _a === void 0 ? void 0 : _a.setVideoSizeBig(false);
        (_b = this.screenUser) === null || _b === void 0 ? void 0 : _b.setVideoSizeBig(false);
    }
    toggleZoom(connectionId) {
        if (this.webcamUser.getConnectionId() === connectionId) {
            this.webcamUser.setVideoSizeBig(!this.webcamUser.isVideoSizeBig());
            return;
        }
        this.screenUser.setVideoSizeBig(!this.screenUser.isVideoSizeBig());
    }
    initPublisher(targetElement, properties) {
        return this.OV.initPublisher(targetElement, properties);
    }
    destryoScreenUser() {
        var _a;
        if ((_a = this.screenUser) === null || _a === void 0 ? void 0 : _a.getStreamManager()) {
            // this.screenUser.getStreamManager().off('streamAudioVolumeChange');
            this.screenUser.getStreamManager().stream.disposeWebRtcPeer();
            this.screenUser.getStreamManager().stream.disposeMediaStream();
        }
    }
    destryoWebcamUser() {
        var _a;
        if ((_a = this.webcamUser) === null || _a === void 0 ? void 0 : _a.getStreamManager()) {
            // this.webcamUser.getStreamManager().off('streamAudioVolumeChange');
            this.webcamUser.getStreamManager().stream.disposeWebRtcPeer();
            this.webcamUser.getStreamManager().stream.disposeMediaStream();
        }
    }
    stopScreenTracks() {
        if (this.screenMediaStream) {
            this.stopAudioTracks(this.screenMediaStream);
            this.stopVideoTracks(this.screenMediaStream);
        }
    }
    // private stopWebcamTracks() {
    // 	if (this.webcamMediaStream) {
    // 		this.stopAudioTracks(this.webcamMediaStream);
    // 		this.stopVideoTracks(this.webcamMediaStream);
    // 	}
    // }
    stopAudioTracks(mediaStream) {
        var _a, _b;
        (_a = mediaStream) === null || _a === void 0 ? void 0 : _a.getAudioTracks().forEach((track) => {
            track.stop();
            track.enabled = false;
        });
        (_b = this.webcamMediaStream) === null || _b === void 0 ? void 0 : _b.getAudioTracks().forEach((track) => {
            track.stop();
        });
    }
    stopVideoTracks(mediaStream) {
        var _a;
        (_a = mediaStream) === null || _a === void 0 ? void 0 : _a.getVideoTracks().forEach((track) => {
            track.stop();
        });
    }
};
OpenViduSessionService.ɵfac = function OpenViduSessionService_Factory(t) { return new (t || OpenViduSessionService)(ɵngcc0.ɵɵinject(LoggerService)); };
OpenViduSessionService.ctorParameters = () => [
    { type: LoggerService }
];
OpenViduSessionService.ɵprov = ɵɵdefineInjectable({ factory: function OpenViduSessionService_Factory() { return new OpenViduSessionService(ɵɵinject(LoggerService)); }, token: OpenViduSessionService, providedIn: "root" });
OpenViduSessionService = __decorate([ __metadata("design:paramtypes", [LoggerService])
], OpenViduSessionService);

let RemoteUsersService = class RemoteUsersService {
    constructor(loggerSrv) {
        this.loggerSrv = loggerSrv;
        this._remoteUsers = new BehaviorSubject([]);
        this.users = [];
        this.log = this.loggerSrv.get('RemoteService');
        this.remoteUsers = this._remoteUsers.asObservable();
    }
    updateUsers() {
        this._remoteUsers.next(this.users);
    }
    add(event, subscriber) {
        var _a, _b;
        let nickname = '';
        let avatar = '';
        const connectionId = event.stream.connection.connectionId;
        try {
            nickname = (_a = JSON.parse(event.stream.connection.data)) === null || _a === void 0 ? void 0 : _a.clientData;
            avatar = (_b = JSON.parse(event.stream.connection.data)) === null || _b === void 0 ? void 0 : _b.avatar;
        }
        catch (error) {
            nickname = 'Unknown';
        }
        const newUser = new UserModel(connectionId, subscriber, nickname);
        newUser.setUserAvatar(avatar);
        this.users.push(newUser);
        this.updateUsers();
    }
    removeUserByConnectionId(connectionId) {
        this.log.w('Deleting user: ', connectionId);
        const user = this.getRemoteUserByConnectionId(connectionId);
        const index = this.users.indexOf(user, 0);
        if (index > -1) {
            this.users.splice(index, 1);
            this.updateUsers();
        }
    }
    someoneIsSharingScreen() {
        return this.users.some(user => user.isScreen());
    }
    toggleUserZoom(connectionId) {
        const user = this.getRemoteUserByConnectionId(connectionId);
        user.setVideoSizeBig(!user.isVideoSizeBig());
    }
    resetUsersZoom() {
        this.users.forEach(u => u.setVideoSizeBig(false));
    }
    setUserZoom(connectionId, zoom) {
        var _a;
        (_a = this.getRemoteUserByConnectionId(connectionId)) === null || _a === void 0 ? void 0 : _a.setVideoSizeBig(zoom);
    }
    getRemoteUserByConnectionId(connectionId) {
        return this.users.find(u => u.getConnectionId() === connectionId);
    }
    updateNickname(connectionId, nickname) {
        var _a;
        const user = this.getRemoteUserByConnectionId(connectionId);
        (_a = user) === null || _a === void 0 ? void 0 : _a.setNickname(nickname);
        this._remoteUsers.next(this.users);
    }
    clean() {
        this._remoteUsers = new BehaviorSubject([]);
        this.remoteUsers = this._remoteUsers.asObservable();
        this.users = [];
    }
    getUserAvatar(connectionId) {
        return this.getRemoteUserByConnectionId(connectionId).getAvatar();
    }
};
RemoteUsersService.ɵfac = function RemoteUsersService_Factory(t) { return new (t || RemoteUsersService)(ɵngcc0.ɵɵinject(LoggerService)); };
RemoteUsersService.ctorParameters = () => [
    { type: LoggerService }
];
RemoteUsersService.ɵprov = ɵɵdefineInjectable({ factory: function RemoteUsersService_Factory() { return new RemoteUsersService(ɵɵinject(LoggerService)); }, token: RemoteUsersService, providedIn: "root" });
RemoteUsersService = __decorate([ __metadata("design:paramtypes", [LoggerService])
], RemoteUsersService);

let NotificationService = class NotificationService {
    constructor(snackBar) {
        this.snackBar = snackBar;
    }
    newMessage(nickname, callback) {
        const alert = this.launchNotification(nickname + ' sent a message', 'OPEN', 'messageSnackbar', 3000);
        alert.onAction().subscribe(() => {
            callback();
        });
    }
    launchNotification(message, action, className, durationTimeMs) {
        return this.snackBar.open(message, action, {
            duration: durationTimeMs,
            verticalPosition: 'top',
            horizontalPosition: 'end',
            panelClass: className
        });
    }
};
NotificationService.ɵfac = function NotificationService_Factory(t) { return new (t || NotificationService)(ɵngcc0.ɵɵinject(ɵngcc1.MatSnackBar)); };
NotificationService.ctorParameters = () => [
    { type: MatSnackBar }
];
NotificationService.ɵprov = ɵɵdefineInjectable({ factory: function NotificationService_Factory() { return new NotificationService(ɵɵinject(MatSnackBar)); }, token: NotificationService, providedIn: "root" });
NotificationService = __decorate([ __metadata("design:paramtypes", [MatSnackBar])
], NotificationService);

let ChatService = class ChatService {
    constructor(loggerSrv, oVSessionService, remoteUsersService, notificationService) {
        this.loggerSrv = loggerSrv;
        this.oVSessionService = oVSessionService;
        this.remoteUsersService = remoteUsersService;
        this.notificationService = notificationService;
        this._messageList = new BehaviorSubject([]);
        this._toggleChat = new BehaviorSubject(false);
        this.messageList = [];
        this.messagesUnread = 0;
        this._messagesUnread = new BehaviorSubject(0);
        this.log = this.loggerSrv.get('ChatService');
        this.messagesObs = this._messageList.asObservable();
        this.toggleChatObs = this._toggleChat.asObservable();
        this.messagesUnreadObs = this._messagesUnread.asObservable();
    }
    setChatComponent(chatSidenav) {
        this.chatComponent = chatSidenav;
    }
    subscribeToChat() {
        const session = this.oVSessionService.getWebcamSession();
        session.on('signal:chat', (event) => {
            const connectionId = event.from.connectionId;
            const data = JSON.parse(event.data);
            const isMyOwnConnection = this.oVSessionService.isMyOwnConnection(connectionId);
            this.messageList.push({
                isLocal: isMyOwnConnection,
                nickname: data.nickname,
                message: data.message,
                userAvatar: isMyOwnConnection
                    ? this.oVSessionService.getWebCamAvatar()
                    : this.remoteUsersService.getUserAvatar(connectionId)
            });
            if (!this.isChatOpened()) {
                this.addMessageUnread();
                this.notificationService.newMessage(data.nickname.toUpperCase(), this.toggleChat.bind(this));
            }
            this._messageList.next(this.messageList);
        });
    }
    sendMessage(message) {
        message = message.replace(/ +(?= )/g, '');
        if (message !== '' && message !== ' ') {
            const data = {
                message: message,
                nickname: this.oVSessionService.getWebcamUserName()
            };
            const sessionAvailable = this.oVSessionService.getConnectedUserSession();
            sessionAvailable.signal({
                data: JSON.stringify(data),
                type: 'chat'
            });
        }
    }
    toggleChat() {
        this.log.d('Toggling chat');
        this.chatComponent.toggle().then(() => {
            this.chatOpened = this.chatComponent.opened;
            this._toggleChat.next(this.chatOpened);
            if (this.chatOpened) {
                this.messagesUnread = 0;
                this._messagesUnread.next(this.messagesUnread);
            }
        });
    }
    isChatOpened() {
        return this.chatOpened;
    }
    addMessageUnread() {
        this.messagesUnread++;
        this._messagesUnread.next(this.messagesUnread);
    }
};
ChatService.ɵfac = function ChatService_Factory(t) { return new (t || ChatService)(ɵngcc0.ɵɵinject(LoggerService), ɵngcc0.ɵɵinject(OpenViduSessionService), ɵngcc0.ɵɵinject(RemoteUsersService), ɵngcc0.ɵɵinject(NotificationService)); };
ChatService.ctorParameters = () => [
    { type: LoggerService },
    { type: OpenViduSessionService },
    { type: RemoteUsersService },
    { type: NotificationService }
];
ChatService.ɵprov = ɵɵdefineInjectable({ factory: function ChatService_Factory() { return new ChatService(ɵɵinject(LoggerService), ɵɵinject(OpenViduSessionService), ɵɵinject(RemoteUsersService), ɵɵinject(NotificationService)); }, token: ChatService, providedIn: "root" });
ChatService = __decorate([ __metadata("design:paramtypes", [LoggerService,
        OpenViduSessionService,
        RemoteUsersService,
        NotificationService])
], ChatService);

let ChatComponent = class ChatComponent {
    constructor(chatService) {
        this.chatService = chatService;
        this.messageList = [];
    }
    onKeydownHandler(event) {
        console.log(event);
        if (this.chatOpened) {
            this.close();
        }
    }
    ngOnInit() {
        this.subscribeToMessages();
        this.subscribeToToggleChat();
    }
    ngOnDestroy() {
        if (this.chatMessageSubscription) {
            this.chatMessageSubscription.unsubscribe();
        }
        if (this.chatToggleSubscription) {
            this.chatToggleSubscription.unsubscribe();
        }
    }
    eventKeyPress(event) {
        // Pressed 'Enter' key
        if (event && event.keyCode === 13) {
            this.sendMessage();
        }
    }
    sendMessage() {
        this.chatService.sendMessage(this.message);
        this.message = '';
    }
    scrollToBottom() {
        setTimeout(() => {
            try {
                this.chatScroll.nativeElement.scrollTop = this.chatScroll.nativeElement.scrollHeight;
            }
            catch (err) { }
        }, 20);
    }
    close() {
        this.chatService.toggleChat();
    }
    subscribeToMessages() {
        this.chatMessageSubscription = this.chatService.messagesObs.subscribe((messages) => {
            this.messageList = messages;
        });
    }
    subscribeToToggleChat() {
        this.chatToggleSubscription = this.chatService.toggleChatObs.subscribe((opened) => {
            this.chatOpened = opened;
            if (this.chatOpened) {
                this.scrollToBottom();
                setTimeout(() => {
                    this.chatInput.nativeElement.focus();
                });
            }
        });
    }
};
ChatComponent.ɵfac = function ChatComponent_Factory(t) { return new (t || ChatComponent)(ɵngcc0.ɵɵdirectiveInject(ChatService)); };
ChatComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ChatComponent, selectors: [["chat-component"]], viewQuery: function ChatComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, true);
        ɵngcc0.ɵɵviewQuery(_c1, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.chatScroll = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.chatInput = _t.first);
    } }, hostBindings: function ChatComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown.escape", function ChatComponent_keydown_escape_HostBindingHandler($event) { return ctx.onKeydownHandler($event); }, false, ɵngcc0.ɵɵresolveDocument);
    } }, inputs: { lightTheme: "lightTheme" }, decls: 17, vars: 4, consts: [["id", "chatContainer"], ["id", "chatComponent"], ["id", "chatToolbar"], ["mat-icon-button", "", "id", "closeButton", 3, "click"], ["matTooltip", "Close", "color", "warn"], [1, "message-wrap"], ["chatScroll", ""], ["class", "message", 3, "ngClass", 4, "ngFor", "ngForOf"], ["id", "messageInput"], ["placeholder", "Send a message", "autocomplete", "off", "id", "chatInput", 3, "ngModel", "keypress", "ngModelChange"], ["chatInput", ""], ["mat-mini-fab", "", "id", "sendButton", 3, "click"], ["matTooltip", "Send"], [1, "message", 3, "ngClass"], [1, "user-img", 3, "src"], [1, "msg-detail"], [1, "msg-info"], [1, "msg-content"], [1, "triangle"], [1, "text", 3, "innerHTML"]], template: function ChatComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "span");
        ɵngcc0.ɵɵtext(4, " CHAT");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "button", 3);
        ɵngcc0.ɵɵlistener("click", function ChatComponent_Template_button_click_5_listener() { return ctx.close(); });
        ɵngcc0.ɵɵelementStart(6, "mat-icon", 4);
        ɵngcc0.ɵɵtext(7, "highlight_off");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 5, 6);
        ɵngcc0.ɵɵtemplate(10, ChatComponent_div_10_Template, 10, 6, "div", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 8);
        ɵngcc0.ɵɵelementStart(12, "input", 9, 10);
        ɵngcc0.ɵɵlistener("keypress", function ChatComponent_Template_input_keypress_12_listener($event) { return ctx.eventKeyPress($event); })("ngModelChange", function ChatComponent_Template_input_ngModelChange_12_listener($event) { return ctx.message = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "button", 11);
        ɵngcc0.ɵɵlistener("click", function ChatComponent_Template_button_click_14_listener() { return ctx.sendMessage(); });
        ɵngcc0.ɵɵelementStart(15, "mat-icon", 12);
        ɵngcc0.ɵɵtext(16, "send");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("chatComponentLight", ctx.lightTheme);
        ɵngcc0.ɵɵadvance(9);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.messageList);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.message);
    } }, directives: function () { return [ɵngcc2.MatButton, ɵngcc3.MatIcon, ɵngcc4.MatTooltip, ɵngcc5.NgForOf, ɵngcc6.DefaultValueAccessor, ɵngcc6.NgControlStatus, ɵngcc6.NgModel, ɵngcc5.NgClass, ɵngcc7.DefaultClassDirective]; }, pipes: function () { return [LinkifyPipe]; }, styles: ["#chatContainer[_ngcontent-%COMP%]{position:absolute;z-index:0;width:100%;height:calc(100% - 20px)}input[_ngcontent-%COMP%]{font-family:Ubuntu,sans-serif}#chatToolbar[_ngcontent-%COMP%]{height:30px;background-color:#3d3d3d;box-sizing:border-box;font-weight:700;font-size:14px;text-align:center;padding-top:4px;border-top-left-radius:6px;border-top-right-radius:6px;color:#fff}#closeButton[_ngcontent-%COMP%]{position:absolute;right:0;top:-5px}#chatComponent[_ngcontent-%COMP%]{background-color:#b8b8b8;position:absolute;z-index:99999;top:0;left:0;right:0;bottom:0;margin:auto;height:calc(100% - 30px);width:calc(100% - 30px);border-radius:20px}.message-wrap[_ngcontent-%COMP%]{padding:0 15px;height:calc(100% - 80px);overflow:auto}.message[_ngcontent-%COMP%]{position:relative;padding:7px 0}.user-img[_ngcontent-%COMP%]{position:absolute;border-radius:45px;width:60px;height:60px;top:15px}.msg-detail[_ngcontent-%COMP%]{width:calc(100% - 65px);display:inline-block}.msg-detail[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin:0;font-size:15px}.msg-info[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{font-size:.8em;color:#000;font-style:italic}.msg-content[_ngcontent-%COMP%]{position:relative;margin-top:5px;border-radius:5px;padding:8px;color:#000;width:auto;max-width:95%}span.triangle[_ngcontent-%COMP%]{border-radius:2px;height:8px;width:8px;top:12px;display:block;transform:rotate(45deg);position:absolute}.text[_ngcontent-%COMP%]{word-break:break-all}.message.left[_ngcontent-%COMP%]   .msg-detail[_ngcontent-%COMP%]   .msg-info[_ngcontent-%COMP%]{text-align:left}.message.left[_ngcontent-%COMP%]   .msg-detail[_ngcontent-%COMP%]{padding-left:65px}.message.left[_ngcontent-%COMP%]   .user-img[_ngcontent-%COMP%]{left:-5px;border:1px solid #f0f0f094}.message.left[_ngcontent-%COMP%]   .msg-detail[_ngcontent-%COMP%]   .msg-content[_ngcontent-%COMP%]{background-color:#f0f0f0;float:left}.message.left[_ngcontent-%COMP%]   .msg-detail[_ngcontent-%COMP%]   .msg-content[_ngcontent-%COMP%]   span.triangle[_ngcontent-%COMP%]{background-color:#f0f0f0;border-bottom-width:0;border-left-width:0;left:-5px}.message.right[_ngcontent-%COMP%]   .msg-detail[_ngcontent-%COMP%]   .msg-info[_ngcontent-%COMP%]{text-align:right}.message.right[_ngcontent-%COMP%]   .user-img[_ngcontent-%COMP%]{right:-5px;border:1px solid #c8ffe8ab}.message.right[_ngcontent-%COMP%]   .msg-detail[_ngcontent-%COMP%]   .msg-content[_ngcontent-%COMP%]{background-color:#c8ffe8;float:right}.message.right[_ngcontent-%COMP%]   .msg-detail[_ngcontent-%COMP%]   .msg-content[_ngcontent-%COMP%]   span.triangle[_ngcontent-%COMP%]{background-color:#c8ffe8;border-bottom-width:0;border-left-width:0;right:-5px}#messageInput[_ngcontent-%COMP%]{position:absolute;bottom:0;width:100%;background-color:#fff;text-align:center;padding:10px 0;height:30px;border-bottom-left-radius:6px;border-bottom-right-radius:6px}#messageInput[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:90%;height:100%;border:none;outline:0;font-size:14px;margin-left:-6%}#sendButton[_ngcontent-%COMP%]{background-color:#81e9b0;position:absolute;right:10px;top:0;bottom:0;margin:auto;border:1px solid #7ae2a9;box-shadow:none!important}#sendButton[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{margin-left:3px!important;margin-bottom:2px!important}[_ngcontent-%COMP%]::-webkit-scrollbar{width:8px}[_ngcontent-%COMP%]::-webkit-scrollbar-thumb{background-color:#6b6b6b}.chatComponentLight[_ngcontent-%COMP%]   [_ngcontent-%COMP%]::-webkit-scrollbar-thumb{background-color:#eee!important}"] });
ChatComponent.ctorParameters = () => [
    { type: ChatService }
];
__decorate([
    ViewChild('chatScroll'),
    __metadata("design:type", ElementRef)
], ChatComponent.prototype, "chatScroll", void 0);
__decorate([
    ViewChild('chatInput'),
    __metadata("design:type", ElementRef)
], ChatComponent.prototype, "chatInput", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], ChatComponent.prototype, "lightTheme", void 0);
__decorate([
    HostListener('document:keydown.escape', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [KeyboardEvent]),
    __metadata("design:returntype", void 0)
], ChatComponent.prototype, "onKeydownHandler", null);
ChatComponent = __decorate([ __metadata("design:paramtypes", [ChatService])
], ChatComponent);

class OvSettingsModel {
    constructor() {
        this.ovSettings = {
            chat: true,
            autopublish: false,
            toolbarButtons: {
                video: true,
                audio: true,
                fullscreen: true,
                screenShare: true,
                layoutSpeaking: true,
                exit: true
            }
        };
    }
    set(ovSettings) {
        this.ovSettings = ovSettings;
    }
    isAutoPublish() {
        return this.ovSettings.autopublish;
    }
    hasVideo() {
        return this.ovSettings.toolbarButtons.video;
    }
    hasScreenSharing() {
        return this.ovSettings.toolbarButtons.screenShare;
    }
    hasLayoutSpeaking() {
        return this.ovSettings.toolbarButtons.layoutSpeaking;
    }
    hasFullscreen() {
        return this.ovSettings.toolbarButtons.fullscreen;
    }
    hasAudio() {
        return this.ovSettings.toolbarButtons.audio;
    }
    hasChat() {
        return this.ovSettings.chat;
    }
    hasExit() {
        return this.ovSettings.toolbarButtons.exit;
    }
    setScreenSharing(screenShare) {
        this.ovSettings.toolbarButtons.screenShare = screenShare;
    }
}

var LayoutType;
(function (LayoutType) {
    LayoutType["ROOT_CLASS"] = "OT_root";
})(LayoutType || (LayoutType = {}));
var LayoutBigElement;
(function (LayoutBigElement) {
    LayoutBigElement["BIG_ELEMENT_CLASS"] = "OV_big";
})(LayoutBigElement || (LayoutBigElement = {}));

var Theme;
(function (Theme) {
    Theme["DARK"] = "dark";
    Theme["LIGHT"] = "light";
})(Theme || (Theme = {}));

class ExternalConfigModel {
    constructor() {
        this.theme = Theme.DARK;
        this.ovSettings = new OvSettingsModel();
    }
    getComponentName() { }
    getOvSettings() {
        return this.ovSettings;
    }
    getSessionName() {
        return this.sessionName;
    }
    getOvServerUrl() {
        return this.ovServerUrl;
    }
    getOvSecret() {
        return this.ovSecret;
    }
    getTheme() {
        return this.theme;
    }
    getNickname() {
        return this.nickname;
    }
    getTokens() {
        return this.tokens;
    }
    getScreenToken() {
        return this.tokens[1];
    }
    getWebcamToken() {
        return this.tokens[0];
    }
    setOvSettings(ovSettings) {
        if (!!ovSettings) {
            this.ovSettings.set(ovSettings);
        }
    }
    setSessionName(sessionName) {
        this.sessionName = sessionName;
    }
    setOvServerUrl(url) {
        this.ovServerUrl = url;
    }
    setOvSecret(secret) {
        this.ovSecret = secret;
    }
    setTheme(theme) {
        if (Object.values(Theme).includes(theme)) {
            this.theme = theme === Theme.DARK ? Theme.DARK : Theme.LIGHT;
        }
    }
    setNickname(nickname) {
        this.nickname = nickname;
    }
    setTokens(tokens) {
        this.tokens = tokens;
    }
    canJoinToSession() {
        return this.canOVCallGenerateToken() || this.hasReceivedToken();
    }
    hasTokens() {
        var _a;
        return ((_a = this.tokens) === null || _a === void 0 ? void 0 : _a.length) > 0;
    }
    canOVCallGenerateToken() {
        return !!this.sessionName && !!this.ovServerUrl && !!this.ovSecret && !!this.nickname;
    }
    hasReceivedToken() {
        return !!this.tokens && this.tokens.length > 0 && !!this.nickname;
    }
}

var CameraType;
(function (CameraType) {
    CameraType["FRONT"] = "FRONT";
    CameraType["BACK"] = "BACK";
})(CameraType || (CameraType = {}));

let DialogErrorComponent = class DialogErrorComponent {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
    }
    ngOnInit() { }
};
DialogErrorComponent.ɵfac = function DialogErrorComponent_Factory(t) { return new (t || DialogErrorComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc8.MatDialogRef), ɵngcc0.ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
DialogErrorComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DialogErrorComponent, selectors: [["app-dialog-error"]], decls: 5, vars: 2, consts: [["mat-dialog-title", ""]], template: function DialogErrorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "h1", 0);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "span");
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.data.header);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.data.message, " ");
    } }, directives: [ɵngcc8.MatDialogTitle], styles: ["h1[_ngcontent-%COMP%]{color:#a30101}"] });
DialogErrorComponent.ctorParameters = () => [
    { type: MatDialogRef },
    { type: undefined, decorators: [{ type: Inject, args: [MAT_DIALOG_DATA,] }] }
];
DialogErrorComponent = __decorate([ __param(1, Inject(MAT_DIALOG_DATA)),
    __metadata("design:paramtypes", [MatDialogRef, Object])
], DialogErrorComponent);

let UtilsService = class UtilsService {
    constructor(dialog) {
        this.dialog = dialog;
    }
    toggleFullscreen(elementId) {
        const document = window.document;
        const fs = document.getElementById(elementId);
        if (!document.fullscreenElement &&
            !document.mozFullScreenElement &&
            !document.webkitFullscreenElement &&
            !document.msFullscreenElement) {
            if (fs.requestFullscreen) {
                fs.requestFullscreen();
            }
            else if (fs.msRequestFullscreen) {
                fs.msRequestFullscreen();
            }
            else if (fs.mozRequestFullScreen) {
                fs.mozRequestFullScreen();
            }
            else if (fs.webkitRequestFullscreen) {
                fs.webkitRequestFullscreen();
            }
        }
        else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            }
            else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            }
            else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            }
            else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            }
        }
    }
    getOpenViduAvatar() {
        return 'https://openvidu.io/img/logos/openvidu_globe_bg_transp_cropped.png';
    }
    handlerScreenShareError(error) {
        if (error && error.name === 'SCREEN_SHARING_NOT_SUPPORTED') {
            alert('Your browser does not support screen sharing');
        }
        else if (error && error.name === 'SCREEN_EXTENSION_DISABLED') {
            alert('You need to enable screen sharing extension');
        }
        else if (error && error.name === 'SCREEN_CAPTURE_DENIED') {
            // alert('You need to choose a window or application to share');
        }
    }
    getOpenviduLayoutOptions() {
        const options = {
            maxRatio: 3 / 2,
            minRatio: 9 / 15,
            fixedRatio: false /* If this is true then the aspect ratio of the video is maintained
      and minRatio and maxRatio are ignored (default false) */,
            bigClass: LayoutBigElement.BIG_ELEMENT_CLASS,
            bigPercentage: 0.85,
            bigFixedRatio: false,
            bigMaxRatio: 3 / 2,
            bigMinRatio: 9 / 16,
            bigFirst: true,
            animate: true // Whether you want to animate the transitions
        };
        return options;
    }
    generateNickname() {
        return 'OpenVidu_User' + Math.floor(Math.random() * 100);
    }
    isFF() {
        return /Firefox[\/\s](\d+\.\d+)/.test(navigator.userAgent);
    }
    isMobile() {
        return this.isAndroid() || this.isIos();
    }
    showErrorMessage(header, message, disableClose = false) {
        this.dialogRef = this.dialog.open(DialogErrorComponent, {
            data: { header: header, message: message },
            disableClose
        });
    }
    closeDialog() {
        this.dialogRef.close();
    }
    getHTMLElementByClassName(element, className) {
        while (!!element && element !== document.body) {
            if (element.className.includes(className)) {
                return element;
            }
            element = element.parentElement;
        }
        return null;
    }
    toggleBigElementClass(element) {
        var _a, _b;
        if ((_a = element) === null || _a === void 0 ? void 0 : _a.className.includes(LayoutBigElement.BIG_ELEMENT_CLASS)) {
            (_b = element) === null || _b === void 0 ? void 0 : _b.classList.remove(LayoutBigElement.BIG_ELEMENT_CLASS);
        }
        else {
            element.classList.add(LayoutBigElement.BIG_ELEMENT_CLASS);
        }
    }
    removeAllBigElementClass() {
        const elements = document.getElementsByClassName(LayoutBigElement.BIG_ELEMENT_CLASS);
        while (elements.length > 0) {
            this.toggleBigElementClass(elements[0]);
        }
    }
    isAndroid() {
        return /\b(\w*Android\w*)\b/.test(navigator.userAgent) && /\b(\w*Mobile\w*)\b/.test(navigator.userAgent);
    }
    isIos() {
        return /\b(\w*iOS\w*)\b/.test(navigator.userAgent);
    }
};
UtilsService.ɵfac = function UtilsService_Factory(t) { return new (t || UtilsService)(ɵngcc0.ɵɵinject(ɵngcc8.MatDialog)); };
UtilsService.ctorParameters = () => [
    { type: MatDialog }
];
UtilsService.ɵprov = ɵɵdefineInjectable({ factory: function UtilsService_Factory() { return new UtilsService(ɵɵinject(MatDialog)); }, token: UtilsService, providedIn: "root" });
UtilsService = __decorate([ __metadata("design:paramtypes", [MatDialog])
], UtilsService);

let StorageService = class StorageService {
    constructor(loggerSrv) {
        this.loggerSrv = loggerSrv;
        this.storage = window.localStorage;
        this.log = this.loggerSrv.get('StorageService');
    }
    set(key, item) {
        const value = JSON.stringify({ item: item });
        this.log.d('Storing on localStorage "' + key + '" with value "' + value + '"');
        this.storage.setItem(key, value);
    }
    get(key) {
        var _a;
        const value = JSON.parse(this.storage.getItem(key));
        return ((_a = value) === null || _a === void 0 ? void 0 : _a.item) ? value.item : null;
    }
    clear() {
        this.log.d('Clearing localStorage');
        this.storage.clear();
    }
};
StorageService.ɵfac = function StorageService_Factory(t) { return new (t || StorageService)(ɵngcc0.ɵɵinject(LoggerService)); };
StorageService.ctorParameters = () => [
    { type: LoggerService }
];
StorageService.ɵprov = ɵɵdefineInjectable({ factory: function StorageService_Factory() { return new StorageService(ɵɵinject(LoggerService)); }, token: StorageService, providedIn: "root" });
StorageService = __decorate([ __metadata("design:paramtypes", [LoggerService])
], StorageService);

let DevicesService = class DevicesService {
    constructor(loggerSrv, utilSrv, storageSrv) {
        this.loggerSrv = loggerSrv;
        this.utilSrv = utilSrv;
        this.storageSrv = storageSrv;
        this.VIDEO_DEVICE = 'openviduCallVideoDevice';
        this.AUDIO_DEVICE = 'openviduCallAudioDevice';
        this.OV = null;
        this.cameras = [];
        this.microphones = [];
        this.log = this.loggerSrv.get('DevicesService');
        this.OV = new OpenVidu();
    }
    initDevices() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.initOpenViduDevices();
            this.devices.length > 0 ? this.log.d('Devices found: ', this.devices) : this.log.w('No devices found!');
            this.resetDevicesArray();
            if (this.hasAudioDeviceAvailable()) {
                this.initAudioDevices();
                this.micSelected = this.getMicSelected();
            }
            if (this.hasVideoDeviceAvailable()) {
                this.initVideoDevices();
                this.camSelected = this.cameras.find((device) => device.type === CameraType.FRONT);
            }
        });
    }
    initOpenViduDevices() {
        return __awaiter(this, void 0, void 0, function* () {
            this.devices = yield this.OV.getDevices();
        });
    }
    initAudioDevices() {
        const audioDevices = this.devices.filter((device) => device.kind === 'audioinput');
        audioDevices.forEach((device) => {
            this.microphones.push({ label: device.label, device: device.deviceId });
        });
    }
    initVideoDevices() {
        const FIRST_POSITION = 0;
        const videoDevices = this.devices.filter((device) => device.kind === 'videoinput');
        videoDevices.forEach((device, index) => {
            const myDevice = {
                label: device.label,
                device: device.deviceId,
                type: CameraType.BACK
            };
            if (this.utilSrv.isMobile()) {
                // We assume front video device has 'front' in its label in Mobile devices
                if (myDevice.label.toLowerCase().includes(CameraType.FRONT.toLowerCase())) {
                    myDevice.type = CameraType.FRONT;
                }
            }
            else {
                // We assume first device is web camera in Browser Desktop
                if (index === FIRST_POSITION) {
                    myDevice.type = CameraType.FRONT;
                }
            }
            this.cameras.push(myDevice);
        });
        this.log.d('Camera selected', this.camSelected);
    }
    getCamSelected() {
        if (this.cameras.length === 0) {
            this.log.e('No video devices found!');
            return;
        }
        const storageDevice = this.getCamFromStorage();
        if (storageDevice) {
            return storageDevice;
        }
        return this.camSelected || this.cameras[0];
    }
    getCamFromStorage() {
        var _a;
        let storageDevice = this.storageSrv.get(this.VIDEO_DEVICE);
        storageDevice = this.getCameraByDeviceField((_a = storageDevice) === null || _a === void 0 ? void 0 : _a.device);
        if (storageDevice) {
            return storageDevice;
        }
    }
    getMicSelected() {
        if (this.microphones.length === 0) {
            this.log.e('No audio devices found!');
            return;
        }
        const storageDevice = this.getMicFromStogare();
        if (storageDevice) {
            return storageDevice;
        }
        return this.micSelected || this.microphones[0];
    }
    getMicFromStogare() {
        var _a;
        let storageDevice = this.storageSrv.get(this.AUDIO_DEVICE);
        storageDevice = this.getMicrophoneByDeviceField((_a = storageDevice) === null || _a === void 0 ? void 0 : _a.device);
        if (storageDevice) {
            return storageDevice;
        }
    }
    setCamSelected(deviceField) {
        this.camSelected = this.getCameraByDeviceField(deviceField);
        this.saveCamToStorage(this.camSelected);
    }
    saveCamToStorage(cam) {
        this.storageSrv.set(this.VIDEO_DEVICE, cam);
    }
    setMicSelected(deviceField) {
        this.micSelected = this.getMicrophoneByDeviceField(deviceField);
        this.saveMicToStorage(this.micSelected);
    }
    saveMicToStorage(mic) {
        this.storageSrv.set(this.AUDIO_DEVICE, mic);
    }
    needUpdateVideoTrack(newVideoSource) {
        return this.getCamSelected().device !== newVideoSource;
    }
    needUpdateAudioTrack(newAudioSource) {
        return this.getMicSelected().device !== newAudioSource;
    }
    getCameras() {
        return this.cameras;
    }
    getMicrophones() {
        return this.microphones;
    }
    hasVideoDeviceAvailable() {
        var _a;
        return !!((_a = this.devices) === null || _a === void 0 ? void 0 : _a.find((device) => device.kind === 'videoinput'));
    }
    hasAudioDeviceAvailable() {
        var _a;
        return !!((_a = this.devices) === null || _a === void 0 ? void 0 : _a.find((device) => device.kind === 'audioinput'));
    }
    cameraNeedsMirror(deviceField) {
        var _a;
        return ((_a = this.getCameraByDeviceField(deviceField)) === null || _a === void 0 ? void 0 : _a.type) === CameraType.FRONT;
    }
    areEmptyLabels() {
        return !!this.cameras.find((device) => device.label === '') || !!this.microphones.find((device) => device.label === '');
    }
    getCameraByDeviceField(deviceField) {
        return this.cameras.find((opt) => opt.device === deviceField || opt.label === deviceField);
    }
    getMicrophoneByDeviceField(deviceField) {
        return this.microphones.find((opt) => opt.device === deviceField || opt.label === deviceField);
    }
    resetDevicesArray() {
        this.cameras = [{ label: 'None', device: null, type: null }];
        this.microphones = [{ label: 'None', device: null, type: null }];
    }
};
DevicesService.ɵfac = function DevicesService_Factory(t) { return new (t || DevicesService)(ɵngcc0.ɵɵinject(LoggerService), ɵngcc0.ɵɵinject(UtilsService), ɵngcc0.ɵɵinject(StorageService)); };
DevicesService.ctorParameters = () => [
    { type: LoggerService },
    { type: UtilsService },
    { type: StorageService }
];
DevicesService.ɵprov = ɵɵdefineInjectable({ factory: function DevicesService_Factory() { return new DevicesService(ɵɵinject(LoggerService), ɵɵinject(UtilsService), ɵɵinject(StorageService)); }, token: DevicesService, providedIn: "root" });
DevicesService = __decorate([ __metadata("design:paramtypes", [LoggerService, UtilsService, StorageService])
], DevicesService);

let NetworkService = class NetworkService {
    constructor(http, loggerSrv) {
        this.http = http;
        this.loggerSrv = loggerSrv;
        this.log = this.loggerSrv.get('NetworkService');
        this.baseHref = '/' + (!!window.location.pathname.split('/')[1] ? window.location.pathname.split('/')[1] + '/' : '');
    }
    getToken(sessionId, openviduServerUrl, openviduSecret) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!!openviduServerUrl && !!openviduSecret) {
                const _sessionId = yield this.createSession(sessionId, openviduServerUrl, openviduSecret);
                return yield this.createToken(_sessionId, openviduServerUrl, openviduSecret);
            }
            try {
                this.log.d('Getting token from backend');
                return yield this.http.post(this.baseHref + 'call', { sessionId }).toPromise();
            }
            catch (error) {
                if (error.status === 404) {
                    throw { status: error.status, message: 'Cannot connect with backend. ' + error.url + ' not found' };
                }
                throw error;
            }
        });
    }
    createSession(sessionId, openviduServerUrl, openviduSecret) {
        return new Promise((resolve, reject) => {
            const body = JSON.stringify({ customSessionId: sessionId });
            const options = {
                headers: new HttpHeaders({
                    Authorization: 'Basic ' + btoa('OPENVIDUAPP:' + openviduSecret),
                    'Content-Type': 'application/json'
                })
            };
            return this.http
                .post(openviduServerUrl + '/api/sessions', body, options)
                .pipe(catchError(error => {
                if (error.status === 409) {
                    resolve(sessionId);
                }
                if (error.statusText === 'Unknown Error') {
                    reject({ status: 401, message: 'ERR_CERT_AUTHORITY_INVALID' });
                }
                return throwError(error);
            }))
                .subscribe(response => {
                resolve(response.id);
            });
        });
    }
    createToken(sessionId, openviduServerUrl, openviduSecret) {
        return new Promise((resolve, reject) => {
            const body = JSON.stringify({ session: sessionId });
            const options = {
                headers: new HttpHeaders({
                    Authorization: 'Basic ' + btoa('OPENVIDUAPP:' + openviduSecret),
                    'Content-Type': 'application/json'
                })
            };
            return this.http
                .post(openviduServerUrl + '/api/tokens', body, options)
                .pipe(catchError(error => {
                reject(error);
                return throwError(error);
            }))
                .subscribe(response => {
                this.log.d(response);
                resolve(response.token);
            });
        });
    }
};
NetworkService.ɵfac = function NetworkService_Factory(t) { return new (t || NetworkService)(ɵngcc0.ɵɵinject(ɵngcc9.HttpClient), ɵngcc0.ɵɵinject(LoggerService)); };
NetworkService.ctorParameters = () => [
    { type: HttpClient },
    { type: LoggerService }
];
NetworkService.ɵprov = ɵɵdefineInjectable({ factory: function NetworkService_Factory() { return new NetworkService(ɵɵinject(HttpClient), ɵɵinject(LoggerService)); }, token: NetworkService, providedIn: "root" });
NetworkService = __decorate([ __metadata("design:paramtypes", [HttpClient, LoggerService])
], NetworkService);

let VideoRoomComponent = class VideoRoomComponent {
    constructor(networkSrv, router, utilsSrv, remoteUsersService, oVSessionService, oVDevicesService, loggerSrv, chatService) {
        this.networkSrv = networkSrv;
        this.router = router;
        this.utilsSrv = utilsSrv;
        this.remoteUsersService = remoteUsersService;
        this.oVSessionService = oVSessionService;
        this.oVDevicesService = oVDevicesService;
        this.loggerSrv = loggerSrv;
        this.chatService = chatService;
        this._session = new EventEmitter();
        this._publisher = new EventEmitter();
        this._error = new EventEmitter();
        // !Deprecated
        this._joinSession = new EventEmitter();
        // !Deprecated
        this._leaveSession = new EventEmitter();
        this.compact = false;
        this.sidenavMode = 'side';
        this.showConfigRoomCard = true;
        this.localUsers = [];
        this.remoteUsers = [];
        this.isAutoLayout = false;
        this.log = this.loggerSrv.get('VideoRoomComponent');
    }
    beforeunloadHandler() {
        this.leaveSession();
    }
    sizeChange() {
        if (this.openviduLayout) {
            this.updateOpenViduLayout();
            this.checkSizeComponent();
        }
    }
    ngOnInit() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this.lightTheme = ((_a = this.externalConfig) === null || _a === void 0 ? void 0 : _a.getTheme()) === Theme.LIGHT;
            this.ovSettings = !!this.externalConfig ? this.externalConfig.getOvSettings() : new OvSettingsModel();
            this.ovSettings.setScreenSharing(this.ovSettings.hasScreenSharing() && !this.utilsSrv.isMobile());
        });
    }
    ngOnDestroy() {
        var _a;
        // Reconnecting session is received in Firefox
        // To avoid 'Connection lost' message uses session.off()
        (_a = this.session) === null || _a === void 0 ? void 0 : _a.off('reconnecting');
        this.remoteUsersService.clean();
        this.session = null;
        this.sessionScreen = null;
        this.localUsers = [];
        this.remoteUsers = [];
        this.openviduLayout = null;
        if (this.oVUsersSubscription) {
            this.oVUsersSubscription.unsubscribe();
        }
        if (this.remoteUsersSubscription) {
            this.remoteUsersSubscription.unsubscribe();
        }
        if (this.chatSubscription) {
            this.chatSubscription.unsubscribe();
        }
    }
    onConfigRoomJoin() {
        this.hasVideoDevices = this.oVDevicesService.hasVideoDeviceAvailable();
        this.hasAudioDevices = this.oVDevicesService.hasAudioDeviceAvailable();
        this.showConfigRoomCard = false;
        this.subscribeToLocalUsers();
        this.subscribeToRemoteUsers();
        this.mySessionId = this.oVSessionService.getSessionId();
        setTimeout(() => {
            this.openviduLayout = new OpenViduLayout();
            this.openviduLayoutOptions = this.utilsSrv.getOpenviduLayoutOptions();
            this.openviduLayout.initLayoutContainer(document.getElementById('layout'), this.openviduLayoutOptions);
            this.checkSizeComponent();
            this.joinToSession();
        }, 50);
    }
    joinToSession() {
        this.oVSessionService.initSessions();
        this.session = this.oVSessionService.getWebcamSession();
        this._session.emit(this.session);
        this.sessionScreen = this.oVSessionService.getScreenSession();
        this.subscribeToStreamCreated();
        this.subscribeToStreamDestroyed();
        this.subscribeToStreamPropertyChange();
        this.subscribeToNicknameChanged();
        this.chatService.setChatComponent(this.chatSidenav);
        this.chatService.subscribeToChat();
        this.subscribeToChatComponent();
        this.subscribeToReconnection();
        this.connectToSession();
    }
    leaveSession() {
        this.log.d('Leaving session...');
        this.oVSessionService.disconnect();
        this._leaveSession.emit();
    }
    onNicknameUpdate(nickname) {
        this.oVSessionService.setWebcamName(nickname);
        this.sendNicknameSignal(nickname);
    }
    toggleMic() {
        if (this.oVSessionService.isWebCamEnabled()) {
            this.oVSessionService.publishWebcamAudio(!this.oVSessionService.hasWebcamAudioActive());
            return;
        }
        this.oVSessionService.publishScreenAudio(!this.oVSessionService.hasScreenAudioActive());
    }
    toggleCam() {
        return __awaiter(this, void 0, void 0, function* () {
            const isVideoActive = !this.oVSessionService.hasWebcamVideoActive();
            // Disabling webcam
            if (this.oVSessionService.areBothConnected()) {
                this.oVSessionService.publishVideo(isVideoActive);
                this.oVSessionService.disableWebcamUser();
                this.oVSessionService.unpublishWebcam();
                return;
            }
            // Enabling webcam
            if (this.oVSessionService.isOnlyScreenConnected()) {
                const hasAudio = this.oVSessionService.hasScreenAudioActive();
                yield this.oVSessionService.publishWebcam();
                this.oVSessionService.publishScreenAudio(false);
                this.oVSessionService.publishWebcamAudio(hasAudio);
                this.oVSessionService.enableWebcamUser();
            }
            // Muting/unmuting webcam
            this.oVSessionService.publishVideo(isVideoActive);
        });
    }
    toggleScreenShare() {
        return __awaiter(this, void 0, void 0, function* () {
            // Disabling screenShare
            if (this.oVSessionService.areBothConnected()) {
                this.removeScreen();
                return;
            }
            // Enabling screenShare
            if (this.oVSessionService.isOnlyWebcamConnected()) {
                const screenPublisher = this.initScreenPublisher();
                screenPublisher.once('accessAllowed', (event) => {
                    // Listen to event fired when native stop button is clicked
                    screenPublisher.stream.getMediaStream().getVideoTracks()[0].addEventListener('ended', () => {
                        this.log.d('Clicked native stop button. Stopping screen sharing');
                        this.toggleScreenShare();
                    });
                    this.log.d('ACCESS ALOWED screenPublisher');
                    this.oVSessionService.enableScreenUser(screenPublisher);
                    this.oVSessionService.publishScreen();
                    if (!this.oVSessionService.hasWebcamVideoActive()) {
                        // Disabling webcam
                        this.oVSessionService.disableWebcamUser();
                        this.oVSessionService.unpublishWebcam();
                    }
                });
                screenPublisher.once('accessDenied', (event) => {
                    this.log.w('ScreenShare: Access Denied');
                });
                return;
            }
            // Disabling screnShare and enabling webcam
            const hasAudio = this.oVSessionService.hasScreenAudioActive();
            yield this.oVSessionService.publishWebcam();
            this.oVSessionService.publishScreenAudio(false);
            this.oVSessionService.publishWebcamAudio(hasAudio);
            this.oVSessionService.enableWebcamUser();
            this.removeScreen();
        });
    }
    toggleSpeakerLayout() {
        if (!this.oVSessionService.isScreenShareEnabled()) {
            this.isAutoLayout = !this.isAutoLayout;
            this.log.d('Automatic Layout ', this.isAutoLayout ? 'Disabled' : 'Enabled');
            if (this.isAutoLayout) {
                this.subscribeToSpeechDetection();
                return;
            }
            this.log.d('Unsubscribe to speech detection');
            this.session.off('publisherStartSpeaking');
            this.resetAllBigElements();
            this.updateOpenViduLayout();
            return;
        }
        this.log.w('Screen is enabled. Speech detection has been rejected');
    }
    onReplaceScreenTrack(event) {
        this.oVSessionService.replaceScreenTrack();
    }
    checkSizeComponent() {
        var _a;
        this.compact = ((_a = document.getElementById('room-container')) === null || _a === void 0 ? void 0 : _a.offsetWidth) <= 790;
        this.sidenavMode = this.compact ? 'over' : 'side';
    }
    onToggleVideoSize(event) {
        var _a;
        const element = event.element;
        if (!!event.resetAll) {
            this.resetAllBigElements();
        }
        this.utilsSrv.toggleBigElementClass(element);
        // Has been mandatory change the user zoom property here because of
        // zoom icons and cannot handle publisherStartSpeaking event in other component
        if (!!((_a = event) === null || _a === void 0 ? void 0 : _a.connectionId)) {
            if (this.oVSessionService.isMyOwnConnection(event.connectionId)) {
                this.oVSessionService.toggleZoom(event.connectionId);
            }
            else {
                this.remoteUsersService.toggleUserZoom(event.connectionId);
            }
        }
        this.updateOpenViduLayout();
    }
    toolbarMicIconEnabled() {
        if (this.oVSessionService.isWebCamEnabled()) {
            return this.oVSessionService.hasWebcamAudioActive();
        }
        return this.oVSessionService.hasScreenAudioActive();
    }
    connectToSession() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            let webcamToken;
            let screenToken;
            // Webcomponent or Angular Library
            if (!!this.externalConfig) {
                if (this.externalConfig.hasTokens()) {
                    this.log.d('Received external tokens from ' + this.externalConfig.getComponentName());
                    webcamToken = this.externalConfig.getWebcamToken();
                    // Only connect screen if screen sharing feature is available
                    screenToken = ((_a = this.ovSettings) === null || _a === void 0 ? void 0 : _a.hasScreenSharing()) ? this.externalConfig.getScreenToken() : undefined;
                }
            }
            webcamToken = webcamToken ? webcamToken : yield this.getToken();
            // Only get screentoken if screen sharing feature is available
            if (!screenToken && ((_b = this.ovSettings) === null || _b === void 0 ? void 0 : _b.hasScreenSharing())) {
                screenToken = yield this.getToken();
            }
            if (webcamToken || screenToken) {
                yield this.connectBothSessions(webcamToken, screenToken);
                if (this.oVSessionService.areBothConnected()) {
                    this.oVSessionService.publishWebcam();
                    this.oVSessionService.publishScreen();
                }
                else if (this.oVSessionService.isOnlyScreenConnected()) {
                    this.oVSessionService.publishScreen();
                }
                else {
                    this.oVSessionService.publishWebcam();
                }
                // !Deprecated
                this._joinSession.emit();
                this.updateOpenViduLayout();
            }
        });
    }
    connectBothSessions(webcamToken, screenToken) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.oVSessionService.connectWebcamSession(webcamToken);
                yield this.oVSessionService.connectScreenSession(screenToken);
                this.localUsers[0].getStreamManager().on('streamPlaying', () => {
                    this.localUsers[0].getStreamManager().videos[0].video.parentElement.classList.remove('custom-class');
                });
            }
            catch (error) {
                this._error.emit({ error: error.error, messgae: error.message, code: error.code, status: error.status });
                this.log.e('There was an error connecting to the session:', error.code, error.message);
                this.utilsSrv.showErrorMessage('There was an error connecting to the session:', ((_a = error) === null || _a === void 0 ? void 0 : _a.error) || ((_b = error) === null || _b === void 0 ? void 0 : _b.message));
            }
        });
    }
    subscribeToStreamCreated() {
        this.session.on('streamCreated', (event) => {
            const connectionId = event.stream.connection.connectionId;
            if (this.oVSessionService.isMyOwnConnection(connectionId)) {
                return;
            }
            const subscriber = this.session.subscribe(event.stream, undefined);
            this.remoteUsersService.add(event, subscriber);
            this.sendNicknameSignal(this.oVSessionService.getWebcamUserName(), event.stream.connection);
        });
    }
    subscribeToStreamDestroyed() {
        this.session.on('streamDestroyed', (event) => {
            const connectionId = event.stream.connection.connectionId;
            this.remoteUsersService.removeUserByConnectionId(connectionId);
            // event.preventDefault();
        });
    }
    // Emit publisher to webcomponent
    emitPublisher(publisher) {
        this._publisher.emit(publisher);
    }
    subscribeToStreamPropertyChange() {
        this.session.on('streamPropertyChanged', (event) => {
            const connectionId = event.stream.connection.connectionId;
            if (this.oVSessionService.isMyOwnConnection(connectionId)) {
                return;
            }
            if (event.changedProperty === 'videoActive') {
                this.remoteUsersService.updateUsers();
            }
        });
    }
    subscribeToNicknameChanged() {
        this.session.on('signal:nicknameChanged', (event) => {
            const connectionId = event.from.connectionId;
            if (this.oVSessionService.isMyOwnConnection(connectionId)) {
                return;
            }
            const nickname = JSON.parse(event.data).nickname;
            this.remoteUsersService.updateNickname(connectionId, nickname);
        });
    }
    subscribeToSpeechDetection() {
        this.log.d('Subscribe to speech detection', this.session);
        // Has been mandatory change the user zoom property here because of
        // zoom icons and cannot handle publisherStartSpeaking event in other component
        this.session.on('publisherStartSpeaking', (event) => {
            const someoneIsSharingScreen = this.remoteUsersService.someoneIsSharingScreen();
            if (!this.oVSessionService.isScreenShareEnabled() && !someoneIsSharingScreen) {
                const elem = event.connection.stream.streamManager.videos[0].video;
                const element = this.utilsSrv.getHTMLElementByClassName(elem, LayoutType.ROOT_CLASS);
                this.resetAllBigElements();
                this.remoteUsersService.setUserZoom(event.connection.connectionId, true);
                this.onToggleVideoSize({ element });
            }
        });
    }
    removeScreen() {
        this.oVSessionService.disableScreenUser();
        this.oVSessionService.unpublishScreen();
    }
    subscribeToChatComponent() {
        this.chatSubscription = this.chatService.toggleChatObs.subscribe((opened) => {
            const timeout = this.externalConfig ? 300 : 0;
            this.updateOpenViduLayout(timeout);
        });
    }
    subscribeToReconnection() {
        this.session.on('reconnecting', () => {
            this.log.w('Connection lost: Reconnecting');
            this.isConnectionLost = true;
            this.utilsSrv.showErrorMessage('Connection Problem', 'Oops! Trying to reconnect to the session ...', true);
        });
        this.session.on('reconnected', () => {
            this.log.w('Connection lost: Reconnected');
            this.isConnectionLost = false;
            this.utilsSrv.closeDialog();
        });
        this.session.on('sessionDisconnected', (event) => {
            if (event.reason === 'networkDisconnect') {
                this.utilsSrv.closeDialog();
                this.leaveSession();
            }
        });
    }
    initScreenPublisher() {
        const videoSource = ScreenType.SCREEN;
        const willThereBeWebcam = this.oVSessionService.isWebCamEnabled() && this.oVSessionService.hasWebcamVideoActive();
        const hasAudio = willThereBeWebcam ? false : this.oVSessionService.hasWebcamAudioActive();
        const properties = this.oVSessionService.createProperties(videoSource, undefined, true, hasAudio, false);
        try {
            return this.oVSessionService.initScreenPublisher(undefined, properties);
        }
        catch (error) {
            this.log.e(error);
            this.utilsSrv.handlerScreenShareError(error);
        }
    }
    getToken() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            this.log.d('Generating tokens...');
            try {
                return yield this.networkSrv.getToken(this.mySessionId, (_a = this.externalConfig) === null || _a === void 0 ? void 0 : _a.getOvServerUrl(), (_b = this.externalConfig) === null || _b === void 0 ? void 0 : _b.getOvSecret());
            }
            catch (error) {
                this._error.emit({ error: error.error, messgae: error.message, code: error.code, status: error.status });
                this.log.e('There was an error getting the token:', error.status, error.message);
                this.utilsSrv.showErrorMessage('There was an error getting the token:', error.error || error.message);
            }
        });
    }
    sendNicknameSignal(nickname, connection) {
        const signalOptions = {
            data: JSON.stringify({ nickname }),
            type: 'nicknameChanged',
            to: connection ? [connection] : undefined
        };
        this.session.signal(signalOptions);
    }
    updateOpenViduLayout(timeout) {
        if (!!this.openviduLayout) {
            if (!timeout) {
                this.openviduLayout.updateLayout();
                return;
            }
            setTimeout(() => {
                this.openviduLayout.updateLayout();
            }, timeout);
        }
    }
    resetAllBigElements() {
        this.utilsSrv.removeAllBigElementClass();
        this.remoteUsersService.resetUsersZoom();
        this.oVSessionService.resetUsersZoom();
    }
    subscribeToLocalUsers() {
        this.oVUsersSubscription = this.oVSessionService.OVUsers.subscribe((users) => {
            this.localUsers = users;
            this.updateOpenViduLayout();
        });
    }
    subscribeToRemoteUsers() {
        this.remoteUsersSubscription = this.remoteUsersService.remoteUsers.subscribe((users) => {
            this.remoteUsers = [...users];
            this.updateOpenViduLayout();
        });
    }
};
VideoRoomComponent.ɵfac = function VideoRoomComponent_Factory(t) { return new (t || VideoRoomComponent)(ɵngcc0.ɵɵdirectiveInject(NetworkService), ɵngcc0.ɵɵdirectiveInject(ɵngcc10.Router), ɵngcc0.ɵɵdirectiveInject(UtilsService), ɵngcc0.ɵɵdirectiveInject(RemoteUsersService), ɵngcc0.ɵɵdirectiveInject(OpenViduSessionService), ɵngcc0.ɵɵdirectiveInject(DevicesService), ɵngcc0.ɵɵdirectiveInject(LoggerService), ɵngcc0.ɵɵdirectiveInject(ChatService)); };
VideoRoomComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: VideoRoomComponent, selectors: [["app-video-room"]], viewQuery: function VideoRoomComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c2, true);
        ɵngcc0.ɵɵviewQuery(_c3, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.chatComponent = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.chatSidenav = _t.first);
    } }, hostBindings: function VideoRoomComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("beforeunload", function VideoRoomComponent_beforeunload_HostBindingHandler() { return ctx.beforeunloadHandler(); }, false, ɵngcc0.ɵɵresolveWindow)("resize", function VideoRoomComponent_resize_HostBindingHandler() { return ctx.sizeChange(); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { externalConfig: "externalConfig" }, outputs: { _session: "_session", _publisher: "_publisher", _error: "_error", _joinSession: "_joinSession", _leaveSession: "_leaveSession" }, decls: 1, vars: 1, consts: [["id", "videoRoomNavBar", 3, "boundsLight", 4, "ngIf"], ["id", "videoRoomNavBar"], [3, "ovSettings", "externalConfig", "join", "leaveSession", "publisherCreated", 4, "ngIf"], [4, "ngIf"], [3, "ovSettings", "externalConfig", "join", "leaveSession", "publisherCreated"], ["class", "reconnecting-container", 4, "ngIf"], [3, "lightTheme", "compact", "mySessionId", "ovSettings", "hasVideoDevices", "hasAudioDevices", "isWebcamVideoEnabled", "isWebcamAudioEnabled", "isScreenEnabled", "isAutoLayout", "isConnectionLost", "camButtonClicked", "micButtonClicked", "screenShareClicked", "layoutButtonClicked", "leaveSessionButtonClicked"], ["id", "room-container", "fullscreen", "", 1, "sidenav-container"], ["position", "end", "class", "sidenav-chat", "fixedInViewport", "true", "fixedTopGap", "40", "fixedBottomGap", "0", 3, "mode", "boundsLight", 4, "ngIf"], [1, "sidenav-main"], ["id", "layout", 1, "bounds"], ["class", "OT_root OT_publisher custom-class", "id", "localUser", 3, "display", 4, "ngFor", "ngForOf"], ["class", "OT_root OT_publisher custom-class", "id", "remoteUsers", 3, "display", 4, "ngFor", "ngForOf"], [3, "lightTheme", "participants"], [1, "reconnecting-container"], ["position", "end", "fixedInViewport", "true", "fixedTopGap", "40", "fixedBottomGap", "0", 1, "sidenav-chat", 3, "mode"], ["sidenav", ""], [3, "lightTheme"], ["chatComponent", ""], ["id", "localUser", 1, "OT_root", "OT_publisher", "custom-class"], [3, "user", "videoSizeBig", "nicknameClicked", "replaceScreenTrackClicked", "toggleVideoSizeClicked"], ["id", "remoteUsers", 1, "OT_root", "OT_publisher", "custom-class"], [3, "user", "videoSizeBig", "toggleVideoSizeClicked"]], template: function VideoRoomComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, VideoRoomComponent_div_0_Template, 3, 4, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !!ctx.ovSettings);
    } }, directives: function () { return [ɵngcc5.NgIf, RoomConfigComponent,
        ToolbarComponent, ɵngcc11.MatSidenavContainer, ɵngcc11.MatSidenavContent, ɵngcc5.NgForOf, FooterComponent, ɵngcc11.MatSidenav, ChatComponent,
        StreamComponent]; }, pipes: function () { return [HasChatPipe]; }, styles: ["#videoRoomNavBar[_ngcontent-%COMP%]{min-width:400px;background-color:#494949;height:100%}.stream-container[_ngcontent-%COMP%]{padding:0}.reconnecting-container[_ngcontent-%COMP%]{width:100%;height:100%;z-index:1000;background-color:#000;opacity:80%;position:absolute}.sidenav-container[_ngcontent-%COMP%]{position:relative;width:100%;height:100%;min-height:-webkit-fill-available;overflow:hidden}.sidenav-chat[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;width:450px;background-color:#494949;border-left:none;position:absolute}.mat-drawer-container[_ngcontent-%COMP%]{background-color:#494949}.sidenav-main[_ngcontent-%COMP%]{height:100%;overflow:hidden;min-height:-webkit-fill-available;min-height:-moz-available}.bounds[_ngcontent-%COMP%]{background-color:#494949;position:absolute;left:0;right:0;top:40px;bottom:25px;min-width:400px!important;width:inherit}.boundsLight[_ngcontent-%COMP%]{background-color:#dfdfdf!important}.custom-class[_ngcontent-%COMP%]{min-height:0!important}.OT_root[_ngcontent-%COMP%], .OT_root[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]{color:#fff;margin:0;padding:0;border:0;font-size:100%;font-family:Ubuntu,sans-serif;vertical-align:baseline}.OT_dialog-centering[_ngcontent-%COMP%]{display:table;width:100%;height:100%}.OT_dialog-centering-child[_ngcontent-%COMP%]{display:table-cell;vertical-align:middle}.OT_dialog[_ngcontent-%COMP%]{position:relative;box-sizing:border-box;margin-right:auto;margin-left:auto;color:#fff;font-family:Ubuntu,sans-serif;font-size:13px;line-height:1.4}.OT_dialog[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]{font-family:inherit;box-sizing:inherit}.OT_closeButton[_ngcontent-%COMP%]{color:#999;cursor:pointer;font-size:32px;line-height:36px;position:absolute;right:18px;top:0}.OT_dialog-messages[_ngcontent-%COMP%]{text-align:center}.OT_dialog-messages-main[_ngcontent-%COMP%]{margin-bottom:36px;line-height:36px;font-weight:300;font-size:24px}.OT_dialog-messages-minor[_ngcontent-%COMP%]{margin-bottom:18px;font-size:13px;line-height:18px;color:#a4a4a4}.OT_dialog-messages-minor[_ngcontent-%COMP%]   strong[_ngcontent-%COMP%]{color:#fff}.OT_dialog-actions-card[_ngcontent-%COMP%]{display:inline-block}.OT_dialog-button-title[_ngcontent-%COMP%]{margin-bottom:18px;line-height:18px;font-weight:300;text-align:center;font-size:14px;color:#999}.OT_dialog-button-title[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{color:#999}.OT_dialog-button-title[_ngcontent-%COMP%]   a[_ngcontent-%COMP%], .OT_dialog-button-title[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:active, .OT_dialog-button-title[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:link{color:#02a1de}.OT_dialog-button-title[_ngcontent-%COMP%]   strong[_ngcontent-%COMP%]{color:#fff;font-weight:100;display:block}.OT_dialog-button[_ngcontent-%COMP%]{display:inline-block;margin-bottom:18px;padding:0 1em;background-color:#1ca3dc;text-align:center;cursor:pointer}.OT_dialog-button[_ngcontent-%COMP%]:disabled{cursor:not-allowed;opacity:.5}.OT_dialog-button-large[_ngcontent-%COMP%]{line-height:36px;padding-top:9px;padding-bottom:9px;font-weight:100;font-size:24px}.OT_dialog-button-small[_ngcontent-%COMP%]{line-height:18px;padding-top:9px;padding-bottom:9px;background-color:#444;color:#999;font-size:16px}.OT_dialog-progress-bar[_ngcontent-%COMP%]{display:inline-block;width:100%;margin-top:5px;margin-bottom:41px;border:1px solid #4e4e4e;height:8px}.OT_dialog-progress-bar-fill[_ngcontent-%COMP%]{height:100%;background-color:#29a4da}.OT_dialog-plugin-upgrading[_ngcontent-%COMP%]   .OT_dialog-plugin-upgrade-percentage[_ngcontent-%COMP%]{line-height:54px;font-size:48px;font-weight:100}.OT_centered[_ngcontent-%COMP%]{position:fixed;left:50%;top:50%;margin:0}.OT_dialog-hidden[_ngcontent-%COMP%]{display:none}.OT_dialog-button-block[_ngcontent-%COMP%]{display:block}.OT_dialog-no-natural-margin[_ngcontent-%COMP%]{margin-bottom:0}.OT_publisher[_ngcontent-%COMP%], .OT_subscriber[_ngcontent-%COMP%]{position:relative;min-width:48px;min-height:48px}.OT_publisher[_ngcontent-%COMP%]   .OT_video-element[_ngcontent-%COMP%], .OT_subscriber[_ngcontent-%COMP%]   .OT_video-element[_ngcontent-%COMP%]{display:block;position:absolute;width:100%;height:100%;transform-origin:0 0}.OT_publisher.OT_mirrored[_ngcontent-%COMP%]   .OT_video-element[_ngcontent-%COMP%]{transform:scale(-1,1);transform-origin:50% 50%}.OT_subscriber_error[_ngcontent-%COMP%]{background-color:#000;color:#fff;text-align:center}.OT_subscriber_error[_ngcontent-%COMP%] > p[_ngcontent-%COMP%]{padding:20px}.OT_publisher[_ngcontent-%COMP%]   .OT_archiving[_ngcontent-%COMP%], .OT_publisher[_ngcontent-%COMP%]   .OT_archiving-light-box[_ngcontent-%COMP%], .OT_publisher[_ngcontent-%COMP%]   .OT_archiving-status[_ngcontent-%COMP%], .OT_publisher[_ngcontent-%COMP%]   .OT_bar[_ngcontent-%COMP%], .OT_publisher[_ngcontent-%COMP%]   .OT_name[_ngcontent-%COMP%], .OT_subscriber[_ngcontent-%COMP%]   .OT_archiving[_ngcontent-%COMP%], .OT_subscriber[_ngcontent-%COMP%]   .OT_archiving-light-box[_ngcontent-%COMP%], .OT_subscriber[_ngcontent-%COMP%]   .OT_archiving-status[_ngcontent-%COMP%], .OT_subscriber[_ngcontent-%COMP%]   .OT_bar[_ngcontent-%COMP%], .OT_subscriber[_ngcontent-%COMP%]   .OT_name[_ngcontent-%COMP%]{-ms-box-sizing:border-box;box-sizing:border-box;top:0;left:0;right:0;display:block;height:34px;position:absolute}.OT_publisher[_ngcontent-%COMP%]   .OT_bar[_ngcontent-%COMP%], .OT_subscriber[_ngcontent-%COMP%]   .OT_bar[_ngcontent-%COMP%]{background:rgba(0,0,0,.4)}.OT_publisher[_ngcontent-%COMP%]   .OT_edge-bar-item[_ngcontent-%COMP%], .OT_subscriber[_ngcontent-%COMP%]   .OT_edge-bar-item[_ngcontent-%COMP%]{z-index:1;transition-property:top,bottom,opacity;transition-duration:.5s;transition-timing-function:ease-in}.OT_publisher[_ngcontent-%COMP%]   .OT_name[_ngcontent-%COMP%], .OT_subscriber[_ngcontent-%COMP%]   .OT_name[_ngcontent-%COMP%]{background-color:transparent;color:#fff;font-size:15px;line-height:34px;font-weight:400;padding:0 4px 0 36px}.OT_publisher[_ngcontent-%COMP%]   .OT_archiving-status[_ngcontent-%COMP%], .OT_subscriber[_ngcontent-%COMP%]   .OT_archiving-status[_ngcontent-%COMP%]{background:rgba(0,0,0,.4);top:auto;bottom:0;left:34px;padding:0 4px;color:rgba(255,255,255,.8);font-size:15px;line-height:34px;font-weight:400}.OT_micro[_ngcontent-%COMP%]   .OT_archiving-status[_ngcontent-%COMP%], .OT_micro[_ngcontent-%COMP%]:hover   .OT_archiving-status[_ngcontent-%COMP%], .OT_mini[_ngcontent-%COMP%]   .OT_archiving-status[_ngcontent-%COMP%], .OT_mini[_ngcontent-%COMP%]:hover   .OT_archiving-status[_ngcontent-%COMP%]{display:none}.OT_publisher[_ngcontent-%COMP%]   .OT_archiving-light-box[_ngcontent-%COMP%], .OT_subscriber[_ngcontent-%COMP%]   .OT_archiving-light-box[_ngcontent-%COMP%]{background:rgba(0,0,0,.4);top:auto;bottom:0;right:auto;width:34px;height:34px}.OT_archiving-light[_ngcontent-%COMP%]{width:7px;height:7px;border-radius:30px;position:absolute;top:14px;left:14px;background-color:#575757;box-shadow:0 0 5px 1px #575757}.OT_archiving-light.OT_active[_ngcontent-%COMP%]{background-color:#970d13;animation:1.3s ease-in infinite OT_pulse;-webkit-animation:1.3s ease-in OT_pulse;-moz-animation:1.3s ease-in infinite OT_pulse;-webkit-animation-iteration-count:infinite}@-webkit-keyframes OT_pulse{0%,100%,80%{box-shadow:0 0 0 0 #c70019}30%,50%{box-shadow:0 0 5px 1px #c70019}}.OT_bar.OT_mode-mini[_ngcontent-%COMP%], .OT_bar.OT_mode-mini-auto[_ngcontent-%COMP%], .OT_mini[_ngcontent-%COMP%]   .OT_bar[_ngcontent-%COMP%]{bottom:0;height:auto}.OT_mini[_ngcontent-%COMP%]   .OT_name.OT_mode-auto[_ngcontent-%COMP%], .OT_mini[_ngcontent-%COMP%]   .OT_name.OT_mode-off[_ngcontent-%COMP%], .OT_mini[_ngcontent-%COMP%]   .OT_name.OT_mode-on[_ngcontent-%COMP%], .OT_mini[_ngcontent-%COMP%]:hover   .OT_name.OT_mode-auto[_ngcontent-%COMP%]{display:none}.OT_publisher[_ngcontent-%COMP%]   .OT_name[_ngcontent-%COMP%], .OT_subscriber[_ngcontent-%COMP%]   .OT_name[_ngcontent-%COMP%]{left:10px;right:37px;height:34px;padding-left:0}.OT_publisher[_ngcontent-%COMP%]   .OT_mute[_ngcontent-%COMP%], .OT_subscriber[_ngcontent-%COMP%]   .OT_mute[_ngcontent-%COMP%]{border:none;cursor:pointer;display:block;position:absolute;text-align:center;text-indent:-9999em;background-color:transparent;background-repeat:no-repeat;right:0;top:0;border-left:1px solid rgba(255,255,255,.2);height:36px;width:37px}.OT_mini[_ngcontent-%COMP%]   .OT_mute[_ngcontent-%COMP%], .OT_publisher.OT_mini[_ngcontent-%COMP%]   .OT_mute.OT_mode-auto.OT_mode-on-hold[_ngcontent-%COMP%], .OT_subscriber.OT_mini[_ngcontent-%COMP%]   .OT_mute.OT_mode-auto.OT_mode-on-hold[_ngcontent-%COMP%]{top:50%;left:50%;right:auto;margin-top:-18px;margin-left:-18.5px;border-left:none}.OT_publisher[_ngcontent-%COMP%]   .OT_mute[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAcCAMAAAC02HQrAAAA1VBMVEUAAAD3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pn3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pn3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj39/j3+Pj3+Pn4+Pk/JRMlAAAAQ3RSTlMABAUHCQoLDhAQERwdHiAjLjAxOD9ASFBRVl1mbnZ6fH2LjI+QkaWqrrC1uLzAwcXJycrL1NXj5Ofo6u3w9fr7/P3+d4M3+QAAAQBJREFUGBlVwYdCglAABdCLlr5Unijm3hMUtBzlBLSr//9JgUToOQgVJgceJgU8aHgMeA38K50ZOpcQmTPwcyXn+JM8M3JJIqQypiIkeXelTyIkGZPwKS1NMia1lgKTVkaE3oQQGYsmHNqSMWnTgUFbMiZtGlD2dpaxrL1XgM0i4ZK8MeAmFhsAs29MGZniawagS63oMOQUNXYB5D0D1RMDpyoMLw/fiE2og/V+PVDR5AiBl0/2Uwik+vx4xV3a5G5Ye68Nd1czjUjZckm6VhmPciRzeCZICjwTJAViQq+3e+St167rAoHK8sLYZVkBYPCZAZ/eGa+2R5LH7Wrc0YFf/O9J3yBDFaoAAAAASUVORK5CYII=);background-position:9px 5px}.OT_publisher[_ngcontent-%COMP%]   .OT_mute.OT_active[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAdCAYAAABFRCf7AAADcElEQVRIiaWVXWhcRRTHf7NNd2aDtUKMIjTpg4ufFIuiUOmDEWm0Vi3VYhXRqIggQh4sWJFSig9+oOhTKSpIRUWMIBIr2kptoTbgU6ooxCiIjR+14kcJmf9sNceHnd3ebnc3Uv9wuXfOzPzmnDMz5zozGwdWAbc65w5RUJQ8cC2wDJgFJioh/MJCMrNxq2vOzK4HmIvRRemxKP0RJWt53o7S+d2Yzsx6gQ+AIUDAnUqpBLzXZd4RYFUlhB/bdZacc3PAOmAcCMC7wfvFwLNdoAPAyx09bXyYWRl4E7gDmAdGlNKFwLYu8GolhO9O87RJd64GbMrgEvB68P4osMWdXLtVV7czlooNpVRWSs8DO7NpR/B+3rBHsvetCgtCMTxwQCm9BbyQrc8F7/uBex3uRCeXO0PrUZ4NfKyUPgWeyj3bg/crDNsIRGwBaJQGorQ3Svdn2wHgc2BUKb0DPJHtjwfvbwRucc7tz+N+i9LFUdoXpfVN36I0CVwBTFI/q9e1LPxT8P4qYEdu70q12mYzWw1MYQzjeJF6zq+shHC4B7jklOBPP/TzSunh4P0DwKvAfb5c9krpe+CcwsEoZdbhEvBM9wxRAl5RShcA9wAngE3B+8tLpdLuwrhp4MNmK0pfRWkySr7NXS8+L5nZbWZWy/Vin1IaitJnUTqvwevJ71lgSSWEFKUfHG7Q2m/xqFJaGry/GXgfGPLl8mJgrXPur2JoUC8Qy3OpG+sAbGhEKT0ErAWOA6uBPWbW1wr9BOgFbgKezot0kAPYqJQA1gC/A9cA+82svzksSn1R+jNKX0SpnM/e1x3yqig92JhrZivM7FjO8bSZLSuCR/Ok16K0KMNHojQWpYko7Y7S1igN5PE3ROl4lNaZ2UVmNpPBU01orvZvZPCeKFXbBR+lEKVtUapFaSZKg9njqpl9aWYTrmXCImA7sCWb9lK/jj9TrwkrgA1AH3AQuKsSwkzbrLfxpgpsBtYDxf/R3xm2ExirhNCuHHZXTsmRwiat+S/zSt06eysVA/4pmGr/G3qm6ik28v29FKgCg8BS6pvS0KNRGgZ+Bb4FpsxsOkfUlMuwDcBWYOUZOHYM2AU8WQmhBifDv70O7PjX7KZ+4G7g3FM8zd6uBIaBy4AqxnIcZwFLCovPAhE4Sj38b4BDwEeVEFKD9S94Khjn486v3QAAAABJRU5ErkJggg==);background-position:9px 4px}.OT_subscriber[_ngcontent-%COMP%]   .OT_mute[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAATCAYAAAB7u5a2AAABx0lEQVQ4jaWUv48NURiGn3ONmCs32ZBd28ht1gqyZAkF21ylQkEiSp2ehpDlD1BoFGqqVdJohYKI7MaPxMoVNghCWMF+7ybLUewnOXfcMWO9yeQ857zne8+XmZOBGjJpr0kvTIomvTZpS526UCO4DUwD64FjwCFgqZnnR+oc8LfgzKQ73vGsr42ZtGjSQFV9o8KfBCacZwCaef4YmAf2rzjcpN3A2WSpm/AssKcqPDNpDBjs410CViXzTwk/A7b1C4wxDgOngAsZcAXY2buDfp/6S4F3lDS8DjgBzDWAjX/Y/e/QgYS/AhsKHa+OMQ6GEJ4Cj4BOAxgq6aCowyZtdf4OtAr+FHDO+R4wWnVbihr3cQnICt4boO38GWj9a/icjwOACt4m4K3zEPA+AxaAtTWCnwN3lzHkEL8V/OPAGud9wK2GF9XR1Wae/1zG2AI+pGYI4VUIoRtjHAc2A9cz4LRPevYCZ+i9/4sJt4GXJU10gaPAzdI2TTro/5Tfz8XEe2LSZGmxq/SDNvP8BnA5WRrx4BwYBe6vONx1EnjovGvBLAAd4Adwuyq8UiaNmDTvr+a8SQ9MuvbfwckBHZPe+QEfTdpep+4XZmPBHiHgz74AAAAASUVORK5CYII=);background-position:8px 7px}.OT_subscriber[_ngcontent-%COMP%]   .OT_mute.OT_active[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAUCAYAAACXtf2DAAACtklEQVQ4jZ2VSYiURxTHf+/T9Nc9iRrBuYySmIsXUU9iFMEFERRBvAjJLUQi5ioiHvSScfTmgqC4XAT1ZIgLuJHkICaaQAgKI2hAUBT30bjUq7bbv4eukXK029F3+eqtv/fqK6qQdEnSNUmT6CDB/bvgfjO4N9zj2RD8007xg1IABkwEzkma0qb4PGAPMBZYLtSD8eNwAEjqTlNI0gNJM4YU7w7ut4O7gvuhZFsR3C8NC5BBLiTIY0mzM8AvqbiC++pk+zLpE95XuwAws3vAQuBPYDRwWtL84P4tsDSLv5oaug4EYOawAMF9jMdoLxqNZcDvQA04UVYqL4G/svj7AF21mhJscrvCksYBFO7xc2AAGGg2mrdjvf4rcAyomNn+slLZmUEGBgsYdh945xZJmgvckDSrEJpK6ySBgV6q12O8ABwGPjGzfWWlsjdN9rpjoSfA+DYDXARGAksK4Is3XC1Ub4z1f4CDQGFmu6tleQSYk0U+p7WVeefLJc00s4fAeWB6Qeunvj0m2ugx9gO7kmlrtSxvBfcy6fXUZS6rgG/S+jLQUwCVNmMC9HqM14EtSe+rluWazN8YEv8IqKZ1E1qnaIDO0ucx3gX6kv6TpM3AM+D/IbGjgP60/gq4WQA33gMA2OQxPgHWJX1ttSwL4FAeZGYLgB2SasBs4A8L7qOBf9M0uXQB3a+TMYSmVctyDrA9mfcBK82smSdKWgCcAaa1bTm4fxbc/8uuCQX3RanAD5Ka6Wo5IGnE0HxJPZ03pQX5Org3MsD3AO5xXLPZXJ9BjkrqdFg6QjZkgG3Jtsw93pG0VFI9QU5K6voYQBHcTydAfwheBI9HgvvPAJIWS3qeIL9JGvUxkO7gfi1BrqTvwkG/pPmSnibIqTzXPgAyEVgBjAEu1qrVPbk/PVTHgb/NbPGg/RVIzOQqzSTBaQAAAABJRU5ErkJggg==);background-position:7px 7px}.OT_publisher[_ngcontent-%COMP%]   .OT_edge-bar-item.OT_mode-auto[_ngcontent-%COMP%], .OT_publisher[_ngcontent-%COMP%]   .OT_edge-bar-item.OT_mode-mini-auto[_ngcontent-%COMP%], .OT_publisher[_ngcontent-%COMP%]   .OT_edge-bar-item.OT_mode-off[_ngcontent-%COMP%], .OT_subscriber[_ngcontent-%COMP%]   .OT_edge-bar-item.OT_mode-auto[_ngcontent-%COMP%], .OT_subscriber[_ngcontent-%COMP%]   .OT_edge-bar-item.OT_mode-mini-auto[_ngcontent-%COMP%], .OT_subscriber[_ngcontent-%COMP%]   .OT_edge-bar-item.OT_mode-off[_ngcontent-%COMP%]{top:-25px;opacity:0}.OT_publisher[_ngcontent-%COMP%]   .OT_edge-bar-item.OT_mode-off[_ngcontent-%COMP%], .OT_subscriber[_ngcontent-%COMP%]   .OT_edge-bar-item.OT_mode-off[_ngcontent-%COMP%]{display:none}.OT_mini[_ngcontent-%COMP%]   .OT_mute.OT_mode-auto[_ngcontent-%COMP%], .OT_publisher[_ngcontent-%COMP%]   .OT_mute.OT_mode-mini-auto[_ngcontent-%COMP%], .OT_subscriber[_ngcontent-%COMP%]   .OT_mute.OT_mode-mini-auto[_ngcontent-%COMP%]{top:50%}.OT_publisher[_ngcontent-%COMP%]   .OT_edge-bar-item.OT_edge-bottom.OT_mode-auto[_ngcontent-%COMP%], .OT_publisher[_ngcontent-%COMP%]   .OT_edge-bar-item.OT_edge-bottom.OT_mode-mini-auto[_ngcontent-%COMP%], .OT_publisher[_ngcontent-%COMP%]   .OT_edge-bar-item.OT_edge-bottom.OT_mode-off[_ngcontent-%COMP%], .OT_subscriber[_ngcontent-%COMP%]   .OT_edge-bar-item.OT_edge-bottom.OT_mode-auto[_ngcontent-%COMP%], .OT_subscriber[_ngcontent-%COMP%]   .OT_edge-bar-item.OT_edge-bottom.OT_mode-mini-auto[_ngcontent-%COMP%], .OT_subscriber[_ngcontent-%COMP%]   .OT_edge-bar-item.OT_edge-bottom.OT_mode-off[_ngcontent-%COMP%]{top:auto;bottom:-25px}.OT_publisher[_ngcontent-%COMP%]   .OT_edge-bar-item.OT_mode-auto.OT_mode-on-hold[_ngcontent-%COMP%], .OT_publisher[_ngcontent-%COMP%]   .OT_edge-bar-item.OT_mode-on[_ngcontent-%COMP%], .OT_publisher[_ngcontent-%COMP%]:hover   .OT_edge-bar-item.OT_mode-auto[_ngcontent-%COMP%], .OT_publisher[_ngcontent-%COMP%]:hover   .OT_edge-bar-item.OT_mode-mini-auto[_ngcontent-%COMP%], .OT_subscriber[_ngcontent-%COMP%]   .OT_edge-bar-item.OT_mode-auto.OT_mode-on-hold[_ngcontent-%COMP%], .OT_subscriber[_ngcontent-%COMP%]   .OT_edge-bar-item.OT_mode-on[_ngcontent-%COMP%], .OT_subscriber[_ngcontent-%COMP%]:hover   .OT_edge-bar-item.OT_mode-auto[_ngcontent-%COMP%], .OT_subscriber[_ngcontent-%COMP%]:hover   .OT_edge-bar-item.OT_mode-mini-auto[_ngcontent-%COMP%]{top:0;opacity:1}.OT_mini[_ngcontent-%COMP%]   .OT_mute.OT_mode-on[_ngcontent-%COMP%], .OT_mini[_ngcontent-%COMP%]:hover   .OT_mute.OT_mode-auto[_ngcontent-%COMP%], .OT_mute.OT_mode-mini[_ngcontent-%COMP%], .OT_root[_ngcontent-%COMP%]:hover   .OT_mute.OT_mode-mini-auto[_ngcontent-%COMP%]{top:50%}.OT_publisher[_ngcontent-%COMP%]   .OT_edge-bar-item.OT_edge-bottom.OT_mode-on[_ngcontent-%COMP%], .OT_publisher[_ngcontent-%COMP%]:hover   .OT_edge-bar-item.OT_edge-bottom.OT_mode-auto[_ngcontent-%COMP%], .OT_subscriber[_ngcontent-%COMP%]   .OT_edge-bar-item.OT_edge-bottom.OT_mode-on[_ngcontent-%COMP%], .OT_subscriber[_ngcontent-%COMP%]:hover   .OT_edge-bar-item.OT_edge-bottom.OT_mode-auto[_ngcontent-%COMP%]{top:auto;bottom:0;opacity:1}.OT_root[_ngcontent-%COMP%]   .OT_video-loading[_ngcontent-%COMP%]{position:absolute;z-index:1;width:100%;height:100%;display:none;background-color:rgba(0,0,0,.75)}.OT_root[_ngcontent-%COMP%]   .OT_video-loading[_ngcontent-%COMP%]   .OT_video-loading-spinner[_ngcontent-%COMP%]{background:url(data:image/svg+xml;base64,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) no-repeat;position:absolute;width:32px;height:32px;left:50%;top:50%;margin-left:-16px;margin-top:-16px;-webkit-animation:2s linear infinite OT_spin;animation:2s linear infinite OT_spin}@-webkit-keyframes OT_spin{100%{-webkit-transform:rotate(360deg)}}@keyframes OT_spin{100%{transform:rotate(360deg)}}.OT_publisher.OT_loading[_ngcontent-%COMP%]   .OT_video-loading[_ngcontent-%COMP%], .OT_subscriber.OT_loading[_ngcontent-%COMP%]   .OT_video-loading[_ngcontent-%COMP%]{display:block}.OT_video-centering[_ngcontent-%COMP%]{display:table;width:100%;height:100%}.OT_video-container[_ngcontent-%COMP%]{display:table-cell;vertical-align:middle}.OT_video-poster[_ngcontent-%COMP%]{position:absolute;z-index:1;width:100%;height:100%;display:none;opacity:.25;background-repeat:no-repeat;background-image:url(data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNDcxIDQ2NCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48bGluZWFyR3JhZGllbnQgaWQ9ImEiIHgyPSIwIiB5Mj0iMSI+PHN0b3Agb2Zmc2V0PSI2Ni42NiUiIHN0b3AtY29sb3I9IiNmZmYiLz48c3RvcCBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9IiNmZmYiIHN0b3Atb3BhY2l0eT0iMCIvPjwvbGluZWFyR3JhZGllbnQ+PHBhdGggZmlsbD0idXJsKCNhKSIgZD0iTTc5IDMwOGMxNC4yNS02LjUgNTQuMjUtMTkuNzUgNzEtMjkgOS0zLjI1IDI1LTIxIDI1LTIxczMuNzUtMTMgMy0yMmMtMS43NS02Ljc1LTE1LTQzLTE1LTQzLTIuNSAzLTQuNzQxIDMuMjU5LTcgMS0zLjI1LTcuNS0yMC41LTQ0LjUtMTYtNTcgMS4yNS03LjUgMTAtNiAxMC02LTExLjI1LTMzLjc1LTgtNjctOC02N3MuMDczLTcuMzQ2IDYtMTVjLTMuNDguNjM3LTkgNC05IDQgMi41NjMtMTEuNzI3IDE1LTIxIDE1LTIxIC4xNDgtLjMxMi0xLjMyMS0xLjQ1NC0xMCAxIDEuNS0yLjc4IDE2LjY3NS04LjY1NCAzMC0xMSAzLjc4Ny05LjM2MSAxMi43ODItMTcuMzk4IDIyLTIyLTIuMzY1IDMuMTMzLTMgNi0zIDZzMTUuNjQ3LTguMDg4IDQxLTZjLTE5Ljc1IDItMjQgNi0yNCA2czc0LjUtMTAuNzUgMTA0IDM3YzcuNSA5LjUgMjQuNzUgNTUuNzUgMTAgODkgMy43NS0xLjUgNC41LTQuNSA5IDEgLjI1IDE0Ljc1LTExLjUgNjMtMTkgNjItMi43NSAxLTQtMy00LTMtMTAuNzUgMjkuNS0xNCAzOC0xNCAzOC0yIDQuMjUtMy43NSAxOC41LTEgMjIgMS4yNSA0LjUgMjMgMjMgMjMgMjNsMTI3IDUzYzM3IDM1IDIzIDEzNSAyMyAxMzVMMCA0NjRzLTMtOTYuNzUgMTQtMTIwYzUuMjUtNi4yNSAyMS43NS0xOS43NSA2NS0zNnoiLz48L3N2Zz4=);background-size:auto 76%}.OT_fit-mode-cover[_ngcontent-%COMP%]   .OT_video-element[_ngcontent-%COMP%]{-o-object-fit:cover;object-fit:cover}@media only screen and (orientation:portrait){.OT_subscriber.OT_ForceContain.OT_fit-mode-cover[_ngcontent-%COMP%]   .OT_video-element[_ngcontent-%COMP%]{-o-object-fit:contain!important;object-fit:contain!important}}.OT_fit-mode-contain[_ngcontent-%COMP%]   .OT_video-element[_ngcontent-%COMP%]{-o-object-fit:contain;object-fit:contain}.OT_fit-mode-cover[_ngcontent-%COMP%]   .OT_video-poster[_ngcontent-%COMP%]{background-position:center bottom}.OT_fit-mode-contain[_ngcontent-%COMP%]   .OT_video-poster[_ngcontent-%COMP%]{background-position:center}.OT_audio-level-meter[_ngcontent-%COMP%]{position:absolute;width:25%;max-width:224px;min-width:21px;top:0;right:0;overflow:hidden}.OT_audio-level-meter[_ngcontent-%COMP%]:before{content:'';display:block;padding-top:100%}.OT_audio-level-meter__bar[_ngcontent-%COMP%]{position:absolute;width:192%;height:192%;top:-96%;right:-96%;border-radius:50%;background-color:rgba(0,0,0,.8)}.OT_audio-level-meter__audio-only-img[_ngcontent-%COMP%]{position:absolute;top:22%;right:15%;width:40%;opacity:.7;background:url(data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNzkgODYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iI2ZmZiI+PHBhdGggZD0iTTkuNzU3IDQwLjkyNGMzLjczOC01LjE5MSAxMi43MTEtNC4zMDggMTIuNzExLTQuMzA4IDIuMjIzIDMuMDE0IDUuMTI2IDI0LjU4NiAzLjYyNCAyOC43MTgtMS40MDEgMS4zMDEtMTEuNjExIDEuNjI5LTEzLjM4LTEuNDM2LTEuMjI2LTguODA0LTIuOTU1LTIyLjk3NS0yLjk1NS0yMi45NzV6bTU4Ljc4NSAwYy0zLjczNy01LjE5MS0xMi43MTEtNC4zMDgtMTIuNzExLTQuMzA4LTIuMjIzIDMuMDE0LTUuMTI2IDI0LjU4Ni0zLjYyNCAyOC43MTggMS40MDEgMS4zMDEgMTEuNjExIDEuNjI5IDEzLjM4LTEuNDM2IDEuMjI2LTguODA0IDIuOTU1LTIyLjk3NSAyLjk1NS0yMi45NzV6Ii8+PHBhdGggZD0iTTY4LjY0NyA1OC42Yy43MjktNC43NTMgMi4zOC05LjU2MSAyLjM4LTE0LjgwNCAwLTIxLjQxMi0xNC4xMTUtMzguNzctMzEuNTI4LTM4Ljc3LTE3LjQxMiAwLTMxLjUyNyAxNy4zNTgtMzEuNTI3IDM4Ljc3IDAgNC41NDEuNTE1IDguOTM2IDEuODAyIDEyLjk1IDEuNjk4IDUuMjk1LTUuNTQyIDYuOTkxLTYuNjE2IDIuMDczQzIuNDEgNTUuMzk0IDAgNTEuNzg3IDAgNDguMTAzIDAgMjEuNTM2IDE3LjY4NSAwIDM5LjUgMCA2MS4zMTYgMCA3OSAyMS41MzYgNzkgNDguMTAzYzAgLjcxOC0yLjg5OSA5LjY5My0zLjI5MiAxMS40MDgtLjc1NCAzLjI5My03Ljc1MSAzLjU4OS03LjA2MS0uOTEyeiIvPjxwYXRoIGQ9Ik01LjA4NCA1MS4zODVjLS44MDQtMy43ODIuNTY5LTcuMzM1IDMuMTM0LTcuOTIxIDIuNjM2LS42MDMgNS40ODUgMi4xNSA2LjI4OSA2LjEzMi43OTcgMy45NDgtLjc1MiA3LjQ1Ny0zLjM4OCA3Ljg1OS0yLjU2Ni4zOTEtNS4yMzctMi4zMTgtNi4wMzQtNi4wN3ptNjguODM0IDBjLjgwNC0zLjc4Mi0uNTY4LTcuMzM1LTMuMTMzLTcuOTIxLTIuNjM2LS42MDMtNS40ODUgMi4xNS02LjI4OSA2LjEzMi0uNzk3IDMuOTQ4Ljc1MiA3LjQ1NyAzLjM4OSA3Ljg1OSAyLjU2NS4zOTEgNS4yMzctMi4zMTggNi4wMzQtNi4wN3ptLTIuMDM4IDguMjg4Yy0uOTI2IDE5LjY1OS0xNS4xMTIgMjQuNzU5LTI1Ljg1OSAyMC40NzUtNS40MDUtLjYwNi0zLjAzNCAxLjI2Mi0zLjAzNCAxLjI2MiAxMy42NjEgMy41NjIgMjYuMTY4IDMuNDk3IDMxLjI3My0yMC41NDktLjU4NS00LjUxMS0yLjM3OS0xLjE4Ny0yLjM3OS0xLjE4N3oiLz48cGF0aCBkPSJNNDEuNjYyIDc4LjQyMmw3LjU1My41NWMxLjE5Mi4xMDcgMi4xMiAxLjE1MyAyLjA3MiAyLjMzNWwtLjEwOSAyLjczOGMtLjA0NyAxLjE4Mi0xLjA1MSAyLjA1NC0yLjI0MyAxLjk0NmwtNy41NTMtLjU1Yy0xLjE5MS0uMTA3LTIuMTE5LTEuMTUzLTIuMDcyLTIuMzM1bC4xMDktMi43MzdjLjA0Ny0xLjE4MiAxLjA1Mi0yLjA1NCAyLjI0My0xLjk0N3oiLz48L2c+PC9zdmc+) center no-repeat}.OT_audio-level-meter__audio-only-img[_ngcontent-%COMP%]:before{content:'';display:block;padding-top:100%}.OT_audio-level-meter__value[_ngcontent-%COMP%]{position:absolute;border-radius:50%;background-image:radial-gradient(circle,#97ce00 0,rgba(151,206,0,0) 100%)}.OT_audio-level-meter.OT_mode-off[_ngcontent-%COMP%]{display:none}.OT_audio-level-meter.OT_mode-on[_ngcontent-%COMP%], .OT_audio-only[_ngcontent-%COMP%]   .OT_audio-level-meter.OT_mode-auto[_ngcontent-%COMP%]{display:block}.OT_audio-only.OT_publisher[_ngcontent-%COMP%]   .OT_video-element[_ngcontent-%COMP%], .OT_audio-only.OT_subscriber[_ngcontent-%COMP%]   .OT_video-element[_ngcontent-%COMP%]{display:none}.OT_video-disabled-indicator[_ngcontent-%COMP%]{opacity:1;border:none;display:none;position:absolute;background-color:transparent;background-repeat:no-repeat;background-position:bottom right;pointer-events:none;top:0;left:0;bottom:3px;right:3px}.OT_video-disabled[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,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);background-size:33px auto}.OT_video-disabled-warning[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,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);background-size:33px auto}.OT_video-disabled-indicator.OT_active[_ngcontent-%COMP%]{display:block}.OT_audio-blocked-indicator[_ngcontent-%COMP%]{opacity:1;border:none;display:none;position:absolute;background-color:transparent;background-repeat:no-repeat;background-position:center;pointer-events:none;top:0;left:0;bottom:0;right:0}.OT_audio-blocked[_ngcontent-%COMP%]{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTUwIiBoZWlnaHQ9IjkwIj48ZGVmcz48cGF0aCBkPSJNNjcgMTJMNi40NDggNzIuNTUyIDAgMzFWMThMMjYgMGw0MSAxMnptMyA3bDYgNDctMjkgMTgtMzUuNTAyLTYuNDk4TDcwIDE5eiIgaWQ9ImEiLz48L2RlZnM+PHJlY3Qgd2lkdGg9IjE1MCIgaGVpZ2h0PSI5MCIgcng9IjM1IiByeT0iNDUiIG9wYWNpdHk9Ii41Ii8+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzNikiPjxtYXNrIGlkPSJiIiBmaWxsPSIjZmZmIj48dXNlIHhsaW5rOmhyZWY9IiNhIi8+PC9tYXNrPjxwYXRoIGQ9Ik0zOS4yNDkgNTEuMzEyYy42OTcgMTAuMzcgMi43ODUgMTcuODk3IDUuMjUxIDE3Ljg5NyAzLjAzOCAwIDUuNS0xMS40MTcgNS41LTI1LjVzLTIuNDYyLTI1LjUtNS41LTI1LjVjLTIuNTEgMC00LjYyOCA3Ljc5Ny01LjI4NyAxOC40NTNBOC45ODkgOC45ODkgMCAwIDEgNDMgNDRhOC45ODggOC45ODggMCAwIDEtMy43NTEgNy4zMTJ6TTIwLjk4NSAzMi4yMjRsMTUuNzQ2LTE2Ljg3N2E3LjM4NSA3LjM4NSAwIDAgMSAxMC4zNzQtLjQyQzUxLjcwMiAxOS4xMTQgNTQgMjkuMjA4IDU0IDQ1LjIwOGMwIDE0LjUyNy0yLjM0MyAyMy44OC03LjAzIDI4LjA1OGE3LjI4IDcuMjggMCAwIDEtMTAuMTY4LS40NjhMMjAuNDA1IDU1LjIyNEgxMmE1IDUgMCAwIDEtNS01di0xM2E1IDUgMCAwIDEgNS01aDguOTg1eiIgZmlsbD0iI0ZGRiIgbWFzaz0idXJsKCNiKSIvPjwvZz48cGF0aCBkPSJNMTA2LjUgMTMuNUw0NC45OTggNzUuMDAyIiBzdHJva2U9IiNGRkYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+PC9nPjwvc3ZnPg==);background-size:90px auto}.OT_container-audio-blocked[_ngcontent-%COMP%]{cursor:pointer}.OT_container-audio-blocked[_ngcontent-%COMP%]   .OT_mute[_ngcontent-%COMP%], .OT_container-audio-blocked.OT_mini[_ngcontent-%COMP%]   .OT_edge-bar-item[_ngcontent-%COMP%]{display:none}.OT_audio-blocked-indicator.OT_active[_ngcontent-%COMP%]{display:block}.OT_video-unsupported[_ngcontent-%COMP%]{opacity:1;border:none;display:none;position:absolute;background-color:transparent;background-repeat:no-repeat;background-position:center;background-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTciIGhlaWdodD0iOTAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxkZWZzPjxwYXRoIGQ9Ik03MCAxMkw5LjQ0OCA3Mi41NTIgMCA2MmwzLTQ0TDI5IDBsNDEgMTJ6bTggMmwxIDUyLTI5IDE4LTM1LjUwMi02LjQ5OEw3OCAxNHoiIGlkPSJhIi8+PC9kZWZzPjxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOCAzKSI+PG1hc2sgaWQ9ImIiIGZpbGw9IiNmZmYiPjx1c2UgeGxpbms6aHJlZj0iI2EiLz48L21hc2s+PHBhdGggZD0iTTkuMTEgMjAuOTY4SDQ4LjFhNSA1IDAgMCAxIDUgNVY1OC4xOGE1IDUgMCAwIDEtNSA1SDkuMTFhNSA1IDAgMCAxLTUtNVYyNS45N2E1IDUgMCAwIDEgNS01em00Ny4wOCAxMy4zOTRjMC0uMzQ1IDUuNDcyLTMuMTU5IDE2LjQxNS04LjQ0M2EzIDMgMCAwIDEgNC4zMDQgMi43MDJ2MjYuODM1YTMgMyAwIDAgMS00LjMwNSAyLjcwMWMtMTAuOTQyLTUuMjg2LTE2LjQxMy04LjEtMTYuNDEzLTguNDQ2VjM0LjM2MnoiIGZpbGw9IiNGRkYiIG1hc2s9InVybCgjYikiLz48L2c+PHBhdGggZD0iTTgxLjUgMTYuNUwxOS45OTggNzguMDAyIiBzdHJva2U9IiNGRkYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+PC9nPjwvc3ZnPg==);background-size:58px auto;pointer-events:none;top:0;left:0;bottom:0;right:0;margin-top:-30px}.OT_video-unsupported-bar[_ngcontent-%COMP%]{display:none;position:absolute;width:192%;height:192%;top:-96%;left:-96%;border-radius:50%;background-color:rgba(0,0,0,.8)}.OT_video-unsupported-img[_ngcontent-%COMP%]{display:none;position:absolute;top:11%;left:15%;width:70%;opacity:.7;background-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTciIGhlaWdodD0iOTAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxkZWZzPjxwYXRoIGQ9Ik03MCAxMkw5LjQ0OCA3Mi41NTIgMCA2MmwzLTQ0TDI5IDBsNDEgMTJ6bTggMmwxIDUyLTI5IDE4LTM1LjUwMi02LjQ5OEw3OCAxNHoiIGlkPSJhIi8+PC9kZWZzPjxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOCAzKSI+PG1hc2sgaWQ9ImIiIGZpbGw9IiNmZmYiPjx1c2UgeGxpbms6aHJlZj0iI2EiLz48L21hc2s+PHBhdGggZD0iTTkuMTEgMjAuOTY4SDQ4LjFhNSA1IDAgMCAxIDUgNVY1OC4xOGE1IDUgMCAwIDEtNSA1SDkuMTFhNSA1IDAgMCAxLTUtNVYyNS45N2E1IDUgMCAwIDEgNS01em00Ny4wOCAxMy4zOTRjMC0uMzQ1IDUuNDcyLTMuMTU5IDE2LjQxNS04LjQ0M2EzIDMgMCAwIDEgNC4zMDQgMi43MDJ2MjYuODM1YTMgMyAwIDAgMS00LjMwNSAyLjcwMWMtMTAuOTQyLTUuMjg2LTE2LjQxMy04LjEtMTYuNDEzLTguNDQ2VjM0LjM2MnoiIGZpbGw9IiNGRkYiIG1hc2s9InVybCgjYikiLz48L2c+PHBhdGggZD0iTTgxLjUgMTYuNUwxOS45OTggNzguMDAyIiBzdHJva2U9IiNGRkYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+PC9nPjwvc3ZnPg==);background-repeat:no-repeat;background-position:center;background-size:100% auto}.OT_video-unsupported-img[_ngcontent-%COMP%]:before{content:'';display:block;padding-top:93%}.OT_video-unsupported-text[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center;text-align:center;height:100%;margin-top:40px}@media only screen and (max-width:600px){#videoRoomNavBar[_ngcontent-%COMP%]{width:100%}}"] });
VideoRoomComponent.ctorParameters = () => [
    { type: NetworkService },
    { type: Router },
    { type: UtilsService },
    { type: RemoteUsersService },
    { type: OpenViduSessionService },
    { type: DevicesService },
    { type: LoggerService },
    { type: ChatService }
];
__decorate([
    Input(),
    __metadata("design:type", ExternalConfigModel)
], VideoRoomComponent.prototype, "externalConfig", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], VideoRoomComponent.prototype, "_session", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], VideoRoomComponent.prototype, "_publisher", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], VideoRoomComponent.prototype, "_error", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], VideoRoomComponent.prototype, "_joinSession", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], VideoRoomComponent.prototype, "_leaveSession", void 0);
__decorate([
    ViewChild('chatComponent'),
    __metadata("design:type", ChatComponent)
], VideoRoomComponent.prototype, "chatComponent", void 0);
__decorate([
    ViewChild('sidenav'),
    __metadata("design:type", MatSidenav)
], VideoRoomComponent.prototype, "chatSidenav", void 0);
__decorate([
    HostListener('window:beforeunload'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], VideoRoomComponent.prototype, "beforeunloadHandler", null);
__decorate([
    HostListener('window:resize'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], VideoRoomComponent.prototype, "sizeChange", null);
VideoRoomComponent = __decorate([ __metadata("design:paramtypes", [NetworkService,
        Router,
        UtilsService,
        RemoteUsersService,
        OpenViduSessionService,
        DevicesService,
        LoggerService,
        ChatService])
], VideoRoomComponent);

class AngularLibraryModel extends ExternalConfigModel {
    constructor() {
        super();
        this.NAME = 'Angular Library';
    }
    setTokens(tokens) {
        var _a;
        if (tokens) {
            this.ovSettings.setScreenSharing(this.ovSettings.hasScreenSharing() && ((_a = tokens) === null || _a === void 0 ? void 0 : _a.length) > 1);
            super.setTokens(tokens);
        }
    }
    getComponentName() {
        return this.NAME;
    }
}

let OpenviduSessionComponent = class OpenviduSessionComponent {
    constructor(loggerSrv) {
        this.loggerSrv = loggerSrv;
        this.display = false;
        this.sessionCreated = new EventEmitter();
        this.publisherCreated = new EventEmitter();
        this.error = new EventEmitter();
        // !Deprecated
        this.joinSession = new EventEmitter();
        // !Deprecated
        this.leaveSession = new EventEmitter();
        this.log = this.loggerSrv.get('OpenviduSessionComponent');
    }
    ngOnInit() {
        this.angularLibrary = new AngularLibraryModel();
        this.angularLibrary.setOvSettings(this.ovSettings);
        this.angularLibrary.setSessionName(this.sessionName);
        this.angularLibrary.setOvServerUrl(this.openviduServerUrl);
        this.angularLibrary.setOvSecret(this.openviduSecret);
        this.angularLibrary.setTheme(this.theme);
        this.angularLibrary.setNickname(this.user);
        this.angularLibrary.setTokens(this.tokens);
        if (this.angularLibrary.canJoinToSession()) {
            this.display = true;
            return;
        }
        this.log.e('Cannot join to session.');
    }
    emitSession(session) {
        session.on('sessionDisconnected', (e) => (this.display = false));
        session.on('connectionCreated', (e) => {
            setTimeout(() => {
                var _a, _b, _c;
                if (!((_c = (_b = (_a = e.connection) === null || _a === void 0 ? void 0 : _a.stream) === null || _b === void 0 ? void 0 : _b.streamManager) === null || _c === void 0 ? void 0 : _c.remote)) {
                    this.videoRoom.checkSizeComponent();
                }
            }, 700);
        });
        this.sessionCreated.emit(session);
    }
    emitPublisher(publisher) {
        // publisher.on('streamPlaying', () => this.videoRoom.checkSizeComponent());
        this.publisherCreated.emit(publisher);
    }
    emitErrorEvent(event) {
        setTimeout(() => this.error.emit(event), 20);
    }
    // !Deprecated
    getSession() {
        this.log.w('getSession method is DEPRECATED. Please consider to use sessionCreated event');
        return this.videoRoom.session;
    }
    getLocalUsers() {
        return this.videoRoom.localUsers;
    }
    getOpenviduLayout() {
        return this.videoRoom.openviduLayout;
    }
    getOpenviduLayoutOptions() {
        return this.videoRoom.openviduLayoutOptions;
    }
    // !Deprecated
    emitJoinSessionEvent(event) {
        if (this.joinSession.observers.length > 0) {
            this.log.w('joinSession event is DEPRECATED. Please consider to use sessionCreated event');
        }
        this.joinSession.emit(event);
    }
    // !Deprecated
    emitLeaveSessionEvent(event) {
        if (this.leaveSession.observers.length > 0) {
            this.log.w('leaveSession event is DEPRECATED. Please consider to use sessionCreated event');
        }
        this.leaveSession.emit(event);
    }
};
OpenviduSessionComponent.ɵfac = function OpenviduSessionComponent_Factory(t) { return new (t || OpenviduSessionComponent)(ɵngcc0.ɵɵdirectiveInject(LoggerService)); };
OpenviduSessionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: OpenviduSessionComponent, selectors: [["opv-session"]], viewQuery: function OpenviduSessionComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c4, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.videoRoom = _t.first);
    } }, inputs: { ovSettings: "ovSettings", sessionName: "sessionName", user: "user", openviduServerUrl: "openviduServerUrl", openviduSecret: "openviduSecret", tokens: "tokens", theme: "theme" }, outputs: { sessionCreated: "sessionCreated", publisherCreated: "publisherCreated", error: "error", joinSession: "joinSession", leaveSession: "leaveSession" }, decls: 1, vars: 1, consts: [[3, "externalConfig", "_session", "_publisher", "_error", "_leaveSession", "_joinSession", 4, "ngIf"], [3, "externalConfig", "_session", "_publisher", "_error", "_leaveSession", "_joinSession"], ["videoRoom", ""]], template: function OpenviduSessionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, OpenviduSessionComponent_app_video_room_0_Template, 2, 1, "app-video-room", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.display);
    } }, directives: [ɵngcc5.NgIf, VideoRoomComponent], encapsulation: 2 });
OpenviduSessionComponent.ctorParameters = () => [
    { type: LoggerService }
];
__decorate([
    Input(),
    __metadata("design:type", Object)
], OpenviduSessionComponent.prototype, "ovSettings", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], OpenviduSessionComponent.prototype, "sessionName", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], OpenviduSessionComponent.prototype, "user", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], OpenviduSessionComponent.prototype, "openviduServerUrl", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], OpenviduSessionComponent.prototype, "openviduSecret", void 0);
__decorate([
    Input(),
    __metadata("design:type", Array)
], OpenviduSessionComponent.prototype, "tokens", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], OpenviduSessionComponent.prototype, "theme", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], OpenviduSessionComponent.prototype, "sessionCreated", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], OpenviduSessionComponent.prototype, "publisherCreated", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], OpenviduSessionComponent.prototype, "error", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], OpenviduSessionComponent.prototype, "joinSession", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], OpenviduSessionComponent.prototype, "leaveSession", void 0);
__decorate([
    ViewChild('videoRoom'),
    __metadata("design:type", VideoRoomComponent)
], OpenviduSessionComponent.prototype, "videoRoom", void 0);
OpenviduSessionComponent = __decorate([ __metadata("design:paramtypes", [LoggerService])
], OpenviduSessionComponent);

let LinkifyPipe = class LinkifyPipe {
    constructor(linkifyService) {
        this.linkifyService = linkifyService;
    }
    transform(str) {
        return str ? this.linkifyService.linkify(str) : str;
    }
};
LinkifyPipe.ɵfac = function LinkifyPipe_Factory(t) { return new (t || LinkifyPipe)(ɵngcc0.ɵɵdirectiveInject(ɵngcc12.NgxLinkifyjsService)); };
LinkifyPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "linkify", type: LinkifyPipe, pure: true });
LinkifyPipe.ctorParameters = () => [
    { type: NgxLinkifyjsService }
];
LinkifyPipe = __decorate([ __metadata("design:paramtypes", [NgxLinkifyjsService])
], LinkifyPipe);

let HasChatPipe = class HasChatPipe {
    constructor() { }
    transform(ovSettings) {
        return !ovSettings || ovSettings.hasChat();
    }
};
HasChatPipe.ɵfac = function HasChatPipe_Factory(t) { return new (t || HasChatPipe)(); };
HasChatPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "hasChat", type: HasChatPipe, pure: true });
HasChatPipe = __decorate([ __metadata("design:paramtypes", [])
], HasChatPipe);
let HasAudioPipe = class HasAudioPipe {
    constructor() { }
    transform(ovSettings) {
        return !ovSettings || ovSettings.hasAudio();
    }
};
HasAudioPipe.ɵfac = function HasAudioPipe_Factory(t) { return new (t || HasAudioPipe)(); };
HasAudioPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "hasAudio", type: HasAudioPipe, pure: true });
HasAudioPipe = __decorate([ __metadata("design:paramtypes", [])
], HasAudioPipe);
let HasVideoPipe = class HasVideoPipe {
    constructor() { }
    transform(ovSettings) {
        return !ovSettings || ovSettings.hasVideo();
    }
};
HasVideoPipe.ɵfac = function HasVideoPipe_Factory(t) { return new (t || HasVideoPipe)(); };
HasVideoPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "hasVideo", type: HasVideoPipe, pure: true });
HasVideoPipe = __decorate([ __metadata("design:paramtypes", [])
], HasVideoPipe);
let IsAutoPublishPipe = class IsAutoPublishPipe {
    constructor() { }
    transform(ovSettings) {
        return !ovSettings || ovSettings.isAutoPublish();
    }
};
IsAutoPublishPipe.ɵfac = function IsAutoPublishPipe_Factory(t) { return new (t || IsAutoPublishPipe)(); };
IsAutoPublishPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "isAutoPublish", type: IsAutoPublishPipe, pure: true });
IsAutoPublishPipe = __decorate([ __metadata("design:paramtypes", [])
], IsAutoPublishPipe);
let HasScreenSharingPipe = class HasScreenSharingPipe {
    constructor() { }
    transform(ovSettings) {
        return !ovSettings || ovSettings.hasScreenSharing();
    }
};
HasScreenSharingPipe.ɵfac = function HasScreenSharingPipe_Factory(t) { return new (t || HasScreenSharingPipe)(); };
HasScreenSharingPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "hasScreenSharing", type: HasScreenSharingPipe, pure: true });
HasScreenSharingPipe = __decorate([ __metadata("design:paramtypes", [])
], HasScreenSharingPipe);
let HasFullscreenPipe = class HasFullscreenPipe {
    constructor() { }
    transform(ovSettings) {
        return !ovSettings || ovSettings.hasFullscreen();
    }
};
HasFullscreenPipe.ɵfac = function HasFullscreenPipe_Factory(t) { return new (t || HasFullscreenPipe)(); };
HasFullscreenPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "hasFullscreen", type: HasFullscreenPipe, pure: true });
HasFullscreenPipe = __decorate([ __metadata("design:paramtypes", [])
], HasFullscreenPipe);
let HasLayoutSpeakingPipe = class HasLayoutSpeakingPipe {
    constructor() { }
    transform(ovSettings) {
        return !ovSettings || ovSettings.hasLayoutSpeaking();
    }
};
HasLayoutSpeakingPipe.ɵfac = function HasLayoutSpeakingPipe_Factory(t) { return new (t || HasLayoutSpeakingPipe)(); };
HasLayoutSpeakingPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "hasLayoutSpeaking", type: HasLayoutSpeakingPipe, pure: true });
HasLayoutSpeakingPipe = __decorate([ __metadata("design:paramtypes", [])
], HasLayoutSpeakingPipe);
let HasExitPipe = class HasExitPipe {
    constructor() { }
    transform(ovSettings) {
        return !ovSettings || ovSettings.hasExit();
    }
};
HasExitPipe.ɵfac = function HasExitPipe_Factory(t) { return new (t || HasExitPipe)(); };
HasExitPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "hasExit", type: HasExitPipe, pure: true });
HasExitPipe = __decorate([ __metadata("design:paramtypes", [])
], HasExitPipe);

let TooltipListPipe = class TooltipListPipe {
    transform(lines) {
        let list = '';
        lines.forEach((line) => {
            list += '• ' + line + '\n';
        });
        return list;
    }
};
TooltipListPipe.ɵfac = function TooltipListPipe_Factory(t) { return new (t || TooltipListPipe)(); };
TooltipListPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "tooltipList", type: TooltipListPipe, pure: true });

/** Error when invalid control is dirty, touched, or submitted. */
class NicknameMatcher {
    isErrorState(control, form) {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }
}

var VideoSizeIcon;
(function (VideoSizeIcon) {
    VideoSizeIcon["BIG"] = "zoom_in";
    VideoSizeIcon["NORMAL"] = "zoom_out";
})(VideoSizeIcon || (VideoSizeIcon = {}));
var VideoFullscreenIcon;
(function (VideoFullscreenIcon) {
    VideoFullscreenIcon["BIG"] = "fullscreen";
    VideoFullscreenIcon["NORMAL"] = "fullscreen_exit";
})(VideoFullscreenIcon || (VideoFullscreenIcon = {}));

let StreamComponent = class StreamComponent {
    constructor(utilsSrv) {
        this.utilsSrv = utilsSrv;
        this.videoSizeIcon = VideoSizeIcon.BIG;
        this.fullscreenIcon = VideoFullscreenIcon.BIG;
        this.nicknameClicked = new EventEmitter();
        this.replaceScreenTrackClicked = new EventEmitter();
        this.toggleVideoSizeClicked = new EventEmitter();
    }
    sizeChange(event) {
        const maxHeight = window.screen.height;
        const maxWidth = window.screen.width;
        const curHeight = window.innerHeight;
        const curWidth = window.innerWidth;
        if (maxWidth !== curWidth && maxHeight !== curHeight) {
            this.isFullscreen = false;
            this.videoSizeIcon = VideoSizeIcon.BIG;
        }
    }
    // Has been mandatory fullscreen Input because of Input user did not fire changing
    // the fullscreen user property in publisherStartSpeaking event in VideoRoom Component
    set videoSizeBig(videoSizeBig) {
        this.checkVideoSizeBigIcon(videoSizeBig);
    }
    set user(user) {
        this._user = user;
        this.nicknameFormControl = new FormControl(this._user.getNickname(), [Validators.maxLength(25), Validators.required]);
    }
    set nicknameInputElement(element) {
        setTimeout(() => {
            var _a;
            (_a = element) === null || _a === void 0 ? void 0 : _a.nativeElement.focus();
        });
    }
    ngOnInit() {
        this.matcher = new NicknameMatcher();
    }
    toggleVideoSize(resetAll) {
        const element = this.utilsSrv.getHTMLElementByClassName(this.streamComponent.element.nativeElement, LayoutType.ROOT_CLASS);
        this.toggleVideoSizeClicked.emit({ element, connectionId: this._user.getConnectionId(), resetAll });
    }
    toggleFullscreen() {
        this.utilsSrv.toggleFullscreen('container-' + this._user.getStreamManager().stream.streamId);
        this.toggleFullscreenIcon();
    }
    toggleSound() {
        this.mutedSound = !this.mutedSound;
    }
    toggleNicknameForm() {
        if (this._user.isLocal()) {
            this.toggleNickname = !this.toggleNickname;
        }
    }
    eventKeyPress(event) {
        if (event && event.keyCode === 13 && this.nicknameFormControl.valid) {
            this.nicknameClicked.emit(this.nicknameFormControl.value);
            this.toggleNicknameForm();
        }
    }
    replaceScreenTrack() {
        this.replaceScreenTrackClicked.emit();
    }
    checkVideoSizeBigIcon(videoSizeBig) {
        this.videoSizeIcon = videoSizeBig ? VideoSizeIcon.NORMAL : VideoSizeIcon.BIG;
    }
    toggleFullscreenIcon() {
        this.fullscreenIcon = this.fullscreenIcon === VideoFullscreenIcon.BIG ? VideoFullscreenIcon.NORMAL : VideoFullscreenIcon.BIG;
    }
};
StreamComponent.ɵfac = function StreamComponent_Factory(t) { return new (t || StreamComponent)(ɵngcc0.ɵɵdirectiveInject(UtilsService)); };
StreamComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: StreamComponent, selectors: [["stream-component"]], viewQuery: function StreamComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c5, true);
        ɵngcc0.ɵɵviewQuery(_c6, true, ViewContainerRef);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.nicknameInputElement = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.streamComponent = _t.first);
    } }, hostBindings: function StreamComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function StreamComponent_resize_HostBindingHandler($event) { return ctx.sizeChange($event); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { videoSizeBig: "videoSizeBig", user: "user" }, outputs: { nicknameClicked: "nicknameClicked", replaceScreenTrackClicked: "replaceScreenTrackClicked", toggleVideoSizeClicked: "toggleVideoSizeClicked" }, decls: 1, vars: 1, consts: [["class", "OT_widget-container", 3, "id", "dblclick", 4, "ngIf"], [1, "OT_widget-container", 3, "id", "dblclick"], ["streamComponent", ""], [1, "nickname"], ["class", "nicknameContainer", "selected", "", 3, "click", 4, "ngIf"], ["id", "dialogNickname", 3, "fullscreen", 4, "ngIf"], [3, "streamManager", "mutedSound", "toggleVideoSizeEvent"], [1, "statusIcons"], ["id", "statusMic", 4, "ngIf"], ["id", "statusCam", 4, "ngIf"], [1, "videoButtons"], ["mat-icon-button", "", "id", "videoZoomButton", 3, "click"], ["mat-icon-button", "", "id", "fullscreenButton", 3, "click"], ["mat-icon-button", "", "id", "volumeButton", 3, "click", 4, "ngIf"], ["mat-icon-button", "", "id", "changeScreenButton", 3, "click", 4, "ngIf"], ["selected", "", 1, "nicknameContainer", 3, "click"], ["id", "nickname"], [4, "ngIf"], ["id", "dialogNickname"], ["mat-icon-button", "", "id", "closeButton", 3, "click"], ["matTooltip", "Close"], ["id", "nicknameForm"], ["color", "primary"], ["matInput", "", "autocomplete", "off", 3, "placeholder", "formControl", "errorStateMatcher", "keypress"], ["nicknameInput", ""], ["id", "statusMic"], ["id", "statusCam"], ["mat-icon-button", "", "id", "volumeButton", 3, "click"], ["matTooltip", "Mute sound", 4, "ngIf"], ["color", "warn", "matTooltip", "Unmute sound", 4, "ngIf"], ["matTooltip", "Mute sound"], ["color", "warn", "matTooltip", "Unmute sound"], ["mat-icon-button", "", "id", "changeScreenButton", 3, "click"], ["matTooltip", "Choose screen"]], template: function StreamComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, StreamComponent_div_0_Template, 18, 13, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx._user);
    } }, directives: function () { return [ɵngcc5.NgIf, OpenViduVideoComponent, ɵngcc2.MatButton, ɵngcc3.MatIcon, ɵngcc4.MatTooltip, ɵngcc6.ɵangular_packages_forms_forms_y, ɵngcc6.NgControlStatusGroup, ɵngcc6.NgForm, ɵngcc13.MatFormField, ɵngcc14.MatInput, ɵngcc6.DefaultValueAccessor, ɵngcc6.NgControlStatus, ɵngcc6.FormControlDirective, ɵngcc13.MatError]; }, styles: [".nickname[_ngcontent-%COMP%]{padding:0;position:absolute;z-index:999;border-radius:5px;color:#fff;font-family:Ubuntu,sans-serif}.nicknameContainer[_ngcontent-%COMP%]{background-color:#424242;padding:5px;color:#fff;font-weight:700}#dialogNickname[_ngcontent-%COMP%]{background-color:#0000005e;border-radius:5px}#closeButton[_ngcontent-%COMP%]{position:absolute;top:-3px;right:0;z-index:999}#nicknameForm[_ngcontent-%COMP%]{padding:10px}.fullscreen[_ngcontent-%COMP%]{top:40px}mat-error[_ngcontent-%COMP%]{text-align:center;color:#353535}video[_ngcontent-%COMP%]{-o-object-fit:cover;object-fit:cover;width:100%;height:100%;color:#fff;margin:0;padding:0;border:0;font-size:100%}.statusIcons[_ngcontent-%COMP%]{bottom:0;left:5px;width:40px;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;position:absolute;color:#fff}.statusIcons[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{vertical-align:-webkit-baseline-middle;vertical-align:-moz-middle-with-baseline;font-size:20px}.videoButtons[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:24px}.videoButtons[_ngcontent-%COMP%]   .mat-icon-button[_ngcontent-%COMP%]{line-height:0}#camStatus[_ngcontent-%COMP%]{bottom:43px}#statusCam[_ngcontent-%COMP%], #statusMic[_ngcontent-%COMP%]{text-align:center;width:28px;height:28px;border-radius:50%;background:#c71100;margin:5px auto}.videoButtons[_ngcontent-%COMP%]{right:0;position:absolute;bottom:0;z-index:9999999;width:50px;text-align:center}.videoButtons[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{background-color:#000;width:30px;height:30px;margin:1px}.OT_widget-container[_ngcontent-%COMP%]{width:100%;height:100%;position:absolute;overflow:hidden}  .mat-focused .mat-form-field-label,   .mat-form-field-appearance-legacy .mat-form-field-label, mat-error[_ngcontent-%COMP%]{color:#cacaca!important}  .mat-form-field-appearance-legacy .mat-form-field-underline,   .mat-form-field.mat-focused .mat-form-field-ripple{background-color:#cacaca!important}input[_ngcontent-%COMP%]{caret-color:#fff!important}"] });
StreamComponent.ctorParameters = () => [
    { type: UtilsService }
];
__decorate([
    Output(),
    __metadata("design:type", Object)
], StreamComponent.prototype, "nicknameClicked", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], StreamComponent.prototype, "replaceScreenTrackClicked", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], StreamComponent.prototype, "toggleVideoSizeClicked", void 0);
__decorate([
    ViewChild('streamComponent', { read: ViewContainerRef }),
    __metadata("design:type", ViewContainerRef)
], StreamComponent.prototype, "streamComponent", void 0);
__decorate([
    HostListener('window:resize', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], StreamComponent.prototype, "sizeChange", null);
__decorate([
    Input(),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], StreamComponent.prototype, "videoSizeBig", null);
__decorate([
    Input(),
    __metadata("design:type", UserModel),
    __metadata("design:paramtypes", [UserModel])
], StreamComponent.prototype, "user", null);
__decorate([
    ViewChild('nicknameInput'),
    __metadata("design:type", ElementRef),
    __metadata("design:paramtypes", [ElementRef])
], StreamComponent.prototype, "nicknameInputElement", null);
StreamComponent = __decorate([ __metadata("design:paramtypes", [UtilsService])
], StreamComponent);

let OpenViduVideoComponent = class OpenViduVideoComponent {
    constructor() {
        this.toggleVideoSizeEvent = new EventEmitter();
    }
    ngAfterViewInit() {
        setTimeout(() => {
            if (this._streamManager && this._videoElement) {
                this._streamManager.addVideoElement(this._videoElement.nativeElement);
            }
        });
    }
    set videoElement(element) {
        this._videoElement = element;
    }
    set streamManager(streamManager) {
        setTimeout(() => {
            this._streamManager = streamManager;
            if (!!this._videoElement && this._streamManager) {
                if (this._streamManager.stream.typeOfVideo === VideoType.SCREEN) {
                    this._videoElement.nativeElement.style.objectFit = 'contain';
                    this._videoElement.nativeElement.style.background = '#272727';
                    this.enableVideoSizeBig();
                }
                else {
                    this._videoElement.nativeElement.style.objectFit = 'cover';
                }
                this._streamManager.addVideoElement(this._videoElement.nativeElement);
            }
        });
    }
    enableVideoSizeBig() {
        // Doing video size bigger.
        // Timeout because of connectionId is null and icon does not change
        setTimeout(() => {
            this.toggleVideoSizeEvent.emit(true);
        }, 590);
    }
};
OpenViduVideoComponent.ɵfac = function OpenViduVideoComponent_Factory(t) { return new (t || OpenViduVideoComponent)(); };
OpenViduVideoComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: OpenViduVideoComponent, selectors: [["ov-video"]], viewQuery: function OpenViduVideoComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c7, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.videoElement = _t.first);
    } }, inputs: { streamManager: "streamManager", mutedSound: "mutedSound" }, outputs: { toggleVideoSizeEvent: "toggleVideoSizeEvent" }, decls: 2, vars: 2, consts: [[3, "muted"], ["videoElement", ""]], template: function OpenViduVideoComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "video", 0, 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("muted", ctx.mutedSound);
        ɵngcc0.ɵɵattribute("id", ctx.streamManager && ctx._streamManager.stream ? "video-" + ctx._streamManager.stream.streamId : "video-undefined");
    } }, styles: [".nickname[_ngcontent-%COMP%]{padding:0;position:absolute;z-index:999;border-radius:5px;color:#fff;font-family:Ubuntu,sans-serif}.nicknameContainer[_ngcontent-%COMP%]{background-color:#424242;padding:5px;color:#fff;font-weight:700}#dialogNickname[_ngcontent-%COMP%]{background-color:#0000005e;border-radius:5px}#closeButton[_ngcontent-%COMP%]{position:absolute;top:-3px;right:0;z-index:999}#nicknameForm[_ngcontent-%COMP%]{padding:10px}.fullscreen[_ngcontent-%COMP%]{top:40px}mat-error[_ngcontent-%COMP%]{text-align:center;color:#353535}video[_ngcontent-%COMP%]{-o-object-fit:cover;object-fit:cover;width:100%;height:100%;color:#fff;margin:0;padding:0;border:0;font-size:100%}.statusIcons[_ngcontent-%COMP%]{bottom:0;left:5px;width:40px;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;position:absolute;color:#fff}.statusIcons[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{vertical-align:-webkit-baseline-middle;vertical-align:-moz-middle-with-baseline;font-size:20px}.videoButtons[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:24px}.videoButtons[_ngcontent-%COMP%]   .mat-icon-button[_ngcontent-%COMP%]{line-height:0}#camStatus[_ngcontent-%COMP%]{bottom:43px}#statusCam[_ngcontent-%COMP%], #statusMic[_ngcontent-%COMP%]{text-align:center;width:28px;height:28px;border-radius:50%;background:#c71100;margin:5px auto}.videoButtons[_ngcontent-%COMP%]{right:0;position:absolute;bottom:0;z-index:9999999;width:50px;text-align:center}.videoButtons[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{background-color:#000;width:30px;height:30px;margin:1px}.OT_widget-container[_ngcontent-%COMP%]{width:100%;height:100%;position:absolute;overflow:hidden}  .mat-focused .mat-form-field-label,   .mat-form-field-appearance-legacy .mat-form-field-label, mat-error[_ngcontent-%COMP%]{color:#cacaca!important}  .mat-form-field-appearance-legacy .mat-form-field-underline,   .mat-form-field.mat-focused .mat-form-field-ripple{background-color:#cacaca!important}input[_ngcontent-%COMP%]{caret-color:#fff!important}"] });
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], OpenViduVideoComponent.prototype, "mutedSound", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], OpenViduVideoComponent.prototype, "toggleVideoSizeEvent", void 0);
__decorate([
    ViewChild('videoElement'),
    __metadata("design:type", ElementRef),
    __metadata("design:paramtypes", [ElementRef])
], OpenViduVideoComponent.prototype, "videoElement", null);
__decorate([
    Input(),
    __metadata("design:type", StreamManager),
    __metadata("design:paramtypes", [StreamManager])
], OpenViduVideoComponent.prototype, "streamManager", null);

let ToolbarComponent = class ToolbarComponent {
    constructor(utilsSrv, chatService) {
        this.utilsSrv = utilsSrv;
        this.chatService = chatService;
        this.micButtonClicked = new EventEmitter();
        this.camButtonClicked = new EventEmitter();
        this.screenShareClicked = new EventEmitter();
        this.layoutButtonClicked = new EventEmitter();
        this.leaveSessionButtonClicked = new EventEmitter();
        this.fullscreenIcon = VideoFullscreenIcon.BIG;
        this.logoUrl = 'https://raw.githubusercontent.com/OpenVidu/openvidu-call/master/openvidu-call-front/src/assets/images/';
        this.participantsNames = [];
        this.chatServiceSubscription = this.chatService.messagesUnreadObs.subscribe((num) => {
            this.newMessagesNum = num;
        });
    }
    ngOnDestroy() {
        this.chatServiceSubscription.unsubscribe();
    }
    sizeChange(event) {
        const maxHeight = window.screen.height;
        const maxWidth = window.screen.width;
        const curHeight = window.innerHeight;
        const curWidth = window.innerWidth;
        if (maxWidth !== curWidth && maxHeight !== curHeight) {
            this.fullscreenIcon = VideoFullscreenIcon.BIG;
        }
    }
    ngOnInit() {
        if (this.lightTheme) {
            this.logoUrl += 'openvidu_logo_grey.png';
            return;
        }
        this.logoUrl += 'openvidu_logo.png';
    }
    toggleMicrophone() {
        this.micButtonClicked.emit();
    }
    toggleCamera() {
        this.camButtonClicked.emit();
    }
    toggleScreenShare() {
        this.screenShareClicked.emit();
    }
    toggleSpeakerLayout() {
        this.layoutButtonClicked.emit();
    }
    leaveSession() {
        this.leaveSessionButtonClicked.emit();
    }
    toggleChat() {
        this.chatService.toggleChat();
    }
    toggleFullscreen() {
        this.utilsSrv.toggleFullscreen('videoRoomNavBar');
        this.fullscreenIcon = this.fullscreenIcon === VideoFullscreenIcon.BIG ? VideoFullscreenIcon.NORMAL : VideoFullscreenIcon.BIG;
    }
};
ToolbarComponent.ɵfac = function ToolbarComponent_Factory(t) { return new (t || ToolbarComponent)(ɵngcc0.ɵɵdirectiveInject(UtilsService), ɵngcc0.ɵɵdirectiveInject(ChatService)); };
ToolbarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ToolbarComponent, selectors: [["app-toolbar"]], hostBindings: function ToolbarComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function ToolbarComponent_resize_HostBindingHandler($event) { return ctx.sizeChange($event); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { lightTheme: "lightTheme", mySessionId: "mySessionId", compact: "compact", showNotification: "showNotification", ovSettings: "ovSettings", isWebcamVideoEnabled: "isWebcamVideoEnabled", isWebcamAudioEnabled: "isWebcamAudioEnabled", isScreenEnabled: "isScreenEnabled", isAutoLayout: "isAutoLayout", isConnectionLost: "isConnectionLost", hasVideoDevices: "hasVideoDevices", hasAudioDevices: "hasAudioDevices" }, outputs: { micButtonClicked: "micButtonClicked", camButtonClicked: "camButtonClicked", screenShareClicked: "screenShareClicked", layoutButtonClicked: "layoutButtonClicked", leaveSessionButtonClicked: "leaveSessionButtonClicked" }, decls: 20, vars: 27, consts: [["id", "header", "role", "heading", "fxLayout", "", "fxLayoutAlign", "center", "fxLayoutGap", "10px", 1, "container"], ["fxFlex", "20%"], [3, "lightTheme", "sessionId", "compact", "logoUrl"], ["fxFlex", "70%", "fxFlexOrder", "2"], ["align", "center", 1, "buttonsContainer"], ["id", "navMicrophoneButton", "mat-icon-button", "", 3, "disabled", "click", 4, "ngIf"], ["id", "navCameraButton", "mat-icon-button", "", 3, "disabled", "click", 4, "ngIf"], ["id", "navScreenButton", "mat-icon-button", "", 3, "disabled", "click", 4, "ngIf"], ["mat-icon-button", "", 3, "disabled", "click", 4, "ngIf"], ["mat-icon-button", "", "id", "navLeaveButton", 3, "click", 4, "ngIf"], ["fxFlex", "10%", "fxFlexOrder", "3", "align", "end"], ["id", "navMicrophoneButton", "mat-icon-button", "", 3, "disabled", "click"], ["matTooltip", "Mute your audio", 4, "ngIf"], ["color", "warn", "matTooltip", "Unmute your audio", 4, "ngIf"], ["matTooltip", "Mute your audio"], ["color", "warn", "matTooltip", "Unmute your audio"], ["id", "navCameraButton", "mat-icon-button", "", 3, "disabled", "click"], ["matTooltip", "Mute your cam", 4, "ngIf"], ["color", "warn", "matTooltip", "Unmute your cam", 4, "ngIf"], ["matTooltip", "Mute your cam"], ["color", "warn", "matTooltip", "Unmute your cam"], ["id", "navScreenButton", "mat-icon-button", "", 3, "disabled", "click"], ["matTooltip", "Screen share", "color", "warn", 4, "ngIf"], ["matTooltip", "Stop sharing", 4, "ngIf"], ["matTooltip", "Screen share", "color", "warn"], ["matTooltip", "Stop sharing"], ["mat-icon-button", "", 3, "disabled", "click"], ["matTooltip", "Fullscreen"], ["matTooltip", "Enable speaker layout", "color", "warn", 4, "ngIf"], ["matTooltip", "Disable speaker layout", 4, "ngIf"], ["matTooltip", "Enable speaker layout", "color", "warn"], ["matTooltip", "Disable speaker layout"], ["mat-icon-button", "", "id", "navLeaveButton", 3, "click"], ["color", "warn", "matTooltip", "Leave the session"], ["matBadgePosition", "above before", "matTooltip", "Chat", "matBadgeColor", "accent", 3, "matBadge", "matBadgeHidden"]], template: function ToolbarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "mat-toolbar", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "app-toolbar-logo", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵtemplate(5, ToolbarComponent_button_5_Template, 3, 3, "button", 5);
        ɵngcc0.ɵɵpipe(6, "hasAudio");
        ɵngcc0.ɵɵtemplate(7, ToolbarComponent_button_7_Template, 3, 3, "button", 6);
        ɵngcc0.ɵɵpipe(8, "hasVideo");
        ɵngcc0.ɵɵtemplate(9, ToolbarComponent_button_9_Template, 3, 3, "button", 7);
        ɵngcc0.ɵɵpipe(10, "hasScreenSharing");
        ɵngcc0.ɵɵtemplate(11, ToolbarComponent_button_11_Template, 3, 2, "button", 8);
        ɵngcc0.ɵɵpipe(12, "hasFullscreen");
        ɵngcc0.ɵɵtemplate(13, ToolbarComponent_button_13_Template, 3, 3, "button", 8);
        ɵngcc0.ɵɵpipe(14, "hasLayoutSpeaking");
        ɵngcc0.ɵɵtemplate(15, ToolbarComponent_button_15_Template, 3, 0, "button", 9);
        ɵngcc0.ɵɵpipe(16, "hasExit");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "div", 10);
        ɵngcc0.ɵɵtemplate(18, ToolbarComponent_button_18_Template, 3, 3, "button", 8);
        ɵngcc0.ɵɵpipe(19, "hasChat");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("headerLight", ctx.lightTheme);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("lightTheme", ctx.lightTheme)("sessionId", ctx.mySessionId)("compact", ctx.compact)("logoUrl", ctx.logoUrl);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasAudioDevices && ɵngcc0.ɵɵpipeBind1(6, 13, ctx.ovSettings));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.ovSettings || ctx.hasVideoDevices && ɵngcc0.ɵɵpipeBind1(8, 15, ctx.ovSettings));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(10, 17, ctx.ovSettings));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(12, 19, ctx.ovSettings));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(14, 21, ctx.ovSettings));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(16, 23, ctx.ovSettings));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(19, 25, ctx.ovSettings));
    } }, directives: function () { return [ɵngcc15.MatToolbar, ɵngcc16.DefaultLayoutDirective, ɵngcc16.DefaultLayoutAlignDirective, ɵngcc16.DefaultLayoutGapDirective, ɵngcc16.DefaultFlexDirective, ToolbarLogoComponent, ɵngcc16.DefaultFlexOrderDirective, ɵngcc5.NgIf, ɵngcc2.MatButton, ɵngcc3.MatIcon, ɵngcc4.MatTooltip, ɵngcc17.MatBadge]; }, pipes: function () { return [HasAudioPipe,
        HasVideoPipe,
        HasScreenSharingPipe,
        HasFullscreenPipe,
        HasLayoutSpeakingPipe,
        HasExitPipe,
        HasChatPipe]; }, styles: ["#header[_ngcontent-%COMP%]{color:#fff;height:40px;background-color:#333;padding:0 14px 0 0;position:absolute;top:0;left:0;z-index:999999;min-width:400px!important}.buttonsContainer[_ngcontent-%COMP%]{position:absolute;left:0;right:0}.headerLight[_ngcontent-%COMP%]{color:#706969!important;background-color:#eee!important}#navSessionInfo[_ngcontent-%COMP%]{height:100%;display:inline-flex}#navChatButton[_ngcontent-%COMP%]   .mat-badge-medium.mat-badge-overlap.mat-badge-before[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{left:-17px}#navChatButton[_ngcontent-%COMP%]   .mat-badge-medium.mat-badge-above[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{top:-6px}.mat-icon-button[disabled][_ngcontent-%COMP%]{color:#fff}.titleContent[_ngcontent-%COMP%]{font-family:Ubuntu,sans-serif;max-width:100px;margin:5px -18px;padding:0 15px;font-size:16px;overflow:hidden;text-overflow:ellipsis}.titleContentDark[_ngcontent-%COMP%]{background-color:#494949;color:#fff}.titleContentLight[_ngcontent-%COMP%]{background-color:#dfdfdf!important;color:#000}#header_img[_ngcontent-%COMP%]{max-width:135px;margin-right:10px;margin-top:-3px}#point[_ngcontent-%COMP%]{width:10px;height:10px;position:absolute;top:12px;right:33px;border-radius:50%;background-color:#ffa600;border:1px solid #000;z-index:99999}.pointLight[_ngcontent-%COMP%]{border:1px solid #fff!important}.tooltipList[_ngcontent-%COMP%]{white-space:pre}@media (max-width:600px){#navSessionInfo[_ngcontent-%COMP%]{display:none}}"] });
ToolbarComponent.ctorParameters = () => [
    { type: UtilsService },
    { type: ChatService }
];
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], ToolbarComponent.prototype, "lightTheme", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], ToolbarComponent.prototype, "mySessionId", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], ToolbarComponent.prototype, "compact", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], ToolbarComponent.prototype, "showNotification", void 0);
__decorate([
    Input(),
    __metadata("design:type", OvSettingsModel)
], ToolbarComponent.prototype, "ovSettings", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], ToolbarComponent.prototype, "isWebcamVideoEnabled", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], ToolbarComponent.prototype, "isWebcamAudioEnabled", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], ToolbarComponent.prototype, "isScreenEnabled", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], ToolbarComponent.prototype, "isAutoLayout", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], ToolbarComponent.prototype, "isConnectionLost", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], ToolbarComponent.prototype, "hasVideoDevices", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], ToolbarComponent.prototype, "hasAudioDevices", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], ToolbarComponent.prototype, "micButtonClicked", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], ToolbarComponent.prototype, "camButtonClicked", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], ToolbarComponent.prototype, "screenShareClicked", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], ToolbarComponent.prototype, "layoutButtonClicked", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], ToolbarComponent.prototype, "leaveSessionButtonClicked", void 0);
__decorate([
    HostListener('window:resize', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ToolbarComponent.prototype, "sizeChange", null);
ToolbarComponent = __decorate([ __metadata("design:paramtypes", [UtilsService, ChatService])
], ToolbarComponent);

let ToolbarLogoComponent = class ToolbarLogoComponent {
    constructor() { }
};
ToolbarLogoComponent.ɵfac = function ToolbarLogoComponent_Factory(t) { return new (t || ToolbarLogoComponent)(); };
ToolbarLogoComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ToolbarLogoComponent, selectors: [["app-toolbar-logo"]], inputs: { lightTheme: "lightTheme", compact: "compact", sessionId: "sessionId", logoUrl: "logoUrl" }, decls: 4, vars: 2, consts: [["id", "navSessionInfo"], ["id", "header_img", "alt", "OpenVidu Logo", 3, "src"], [3, "ngClass", 4, "ngIf"], [3, "ngClass"], ["id", "session-title"]], template: function ToolbarLogoComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "a");
        ɵngcc0.ɵɵelement(2, "img", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, ToolbarLogoComponent_div_3_Template, 3, 5, "div", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("src", ctx.logoUrl, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.compact && ctx.sessionId);
    } }, directives: [ɵngcc5.NgIf, ɵngcc5.NgClass, ɵngcc7.DefaultClassDirective], styles: ["#header[_ngcontent-%COMP%]{color:#fff;height:40px;background-color:#333;padding:0 14px 0 0;position:absolute;top:0;left:0;z-index:999999;min-width:400px!important}.buttonsContainer[_ngcontent-%COMP%]{position:absolute;left:0;right:0}.headerLight[_ngcontent-%COMP%]{color:#706969!important;background-color:#eee!important}#navSessionInfo[_ngcontent-%COMP%]{height:100%;display:inline-flex}#navChatButton[_ngcontent-%COMP%]   .mat-badge-medium.mat-badge-overlap.mat-badge-before[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{left:-17px}#navChatButton[_ngcontent-%COMP%]   .mat-badge-medium.mat-badge-above[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{top:-6px}.mat-icon-button[disabled][_ngcontent-%COMP%]{color:#fff}.titleContent[_ngcontent-%COMP%]{font-family:Ubuntu,sans-serif;max-width:100px;margin:5px -18px;padding:0 15px;font-size:16px;overflow:hidden;text-overflow:ellipsis}.titleContentDark[_ngcontent-%COMP%]{background-color:#494949;color:#fff}.titleContentLight[_ngcontent-%COMP%]{background-color:#dfdfdf!important;color:#000}#header_img[_ngcontent-%COMP%]{max-width:135px;margin-right:10px;margin-top:-3px}#point[_ngcontent-%COMP%]{width:10px;height:10px;position:absolute;top:12px;right:33px;border-radius:50%;background-color:#ffa600;border:1px solid #000;z-index:99999}.pointLight[_ngcontent-%COMP%]{border:1px solid #fff!important}.tooltipList[_ngcontent-%COMP%]{white-space:pre}@media (max-width:600px){#navSessionInfo[_ngcontent-%COMP%]{display:none}}"] });
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], ToolbarLogoComponent.prototype, "lightTheme", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], ToolbarLogoComponent.prototype, "compact", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], ToolbarLogoComponent.prototype, "sessionId", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], ToolbarLogoComponent.prototype, "logoUrl", void 0);
ToolbarLogoComponent = __decorate([ __metadata("design:paramtypes", [])
], ToolbarLogoComponent);

let FooterComponent = class FooterComponent {
    constructor() {
        this.participantsNames = [];
    }
    sizeChange(event) { }
    ngOnInit() { }
    set participants(participants) {
        this.participantsNames = [];
        participants.forEach((user) => {
            if (user.isCamera()) {
                this.participantsNames.push(user.getNickname());
            }
        });
        this.participantsNames = [...this.participantsNames];
    }
};
FooterComponent.ɵfac = function FooterComponent_Factory(t) { return new (t || FooterComponent)(); };
FooterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FooterComponent, selectors: [["app-footer"]], hostBindings: function FooterComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function FooterComponent_resize_HostBindingHandler($event) { return ctx.sizeChange($event); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { participants: "participants", lightTheme: "lightTheme" }, decls: 9, vars: 6, consts: [["fxLayout", "", "fxLayout.xs", "row", "fxLayoutAlign", "center center", "fxLayoutGap", "2px", "id", "footer", "role", "heading", 1, "container"], [1, "participantsButtonContainer"], ["mat-icon-button", "", "matTooltip", "Remote participants", 1, ""], ["matBadgeSize", "small", "matBadgePosition", "above after", "matBadgeColor", "accent", 3, "matBadge"], ["fxFlex", "calc(100% - 40px)", "fxFlexOrder", "2"], [1, "participantNames"]], template: function FooterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "mat-toolbar", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "button", 2);
        ɵngcc0.ɵɵelementStart(3, "mat-icon", 3);
        ɵngcc0.ɵɵtext(4, "people");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵelementStart(6, "span", 5);
        ɵngcc0.ɵɵtext(7);
        ɵngcc0.ɵɵpipe(8, "tooltipList");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("headerLight", ctx.lightTheme);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵpropertyInterpolate("matBadge", ctx.participantsNames == null ? null : ctx.participantsNames.length);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(8, 4, ctx.participantsNames));
    } }, directives: [ɵngcc15.MatToolbar, ɵngcc16.DefaultLayoutDirective, ɵngcc16.DefaultLayoutAlignDirective, ɵngcc16.DefaultLayoutGapDirective, ɵngcc2.MatButton, ɵngcc4.MatTooltip, ɵngcc3.MatIcon, ɵngcc17.MatBadge, ɵngcc16.DefaultFlexDirective, ɵngcc16.DefaultFlexOrderDirective], pipes: [TooltipListPipe], styles: ["#footer[_ngcontent-%COMP%]{color:#fff;height:25px;background-color:#333;padding:0 14px 0 0;position:absolute;bottom:0;left:0;z-index:999999;min-width:400px!important}.footerLight[_ngcontent-%COMP%]{color:#706969!important;background-color:#eee!important}.participantNames[_ngcontent-%COMP%]{font-size:small;height:inherit}.participantsButton[_ngcontent-%COMP%]{position:absolute;left:5px;top:none;height:-webkit-fill-available;height:-moz-available}.participantsButtonContainer[_ngcontent-%COMP%]{height:-webkit-fill-available;height:-moz-available}.mat-icon-button[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%], .participantsButtonContainer[_ngcontent-%COMP%]   .mat-icon-button[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{line-height:18px}"] });
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], FooterComponent.prototype, "lightTheme", void 0);
__decorate([
    HostListener('window:resize', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], FooterComponent.prototype, "sizeChange", null);
__decorate([
    Input(),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [Array])
], FooterComponent.prototype, "participants", null);
FooterComponent = __decorate([ __metadata("design:paramtypes", [])
], FooterComponent);

let RoomConfigComponent = class RoomConfigComponent {
    constructor(route, utilsSrv, oVSessionService, oVDevicesService, loggerSrv, storageSrv) {
        this.route = route;
        this.utilsSrv = utilsSrv;
        this.oVSessionService = oVSessionService;
        this.oVDevicesService = oVDevicesService;
        this.loggerSrv = loggerSrv;
        this.storageSrv = storageSrv;
        this.USER_NICKNAME = 'openviduCallNickname';
        this.join = new EventEmitter();
        this.leaveSession = new EventEmitter();
        // Webcomponent event
        this.publisherCreated = new EventEmitter();
        this.isVideoActive = true;
        this.isAudioActive = true;
        this.localUsers = [];
        this.nicknameFormControl = new FormControl('', [Validators.maxLength(25), Validators.required]);
        this.matcher = new NicknameMatcher();
        this.log = this.loggerSrv.get('RoomConfigComponent');
    }
    beforeunloadHandler() {
        this.close();
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.subscribeToUsers();
            this.setNicknameForm();
            this.setRandomAvatar();
            this.columns = window.innerWidth > 900 ? 2 : 1;
            this.setSessionName();
            yield this.oVDevicesService.initDevices();
            this.setDevicesInfo();
            this.initwebcamPublisher();
            // publisher.on('streamAudioVolumeChange', (event: any) => {
            //   this.volumeValue = Math.round(Math.abs(event.value.newValue));
            // });
        });
    }
    ngOnDestroy() {
        this.oVUsersSubscription.unsubscribe();
    }
    onCameraSelected(event) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const videoSource = (_a = event) === null || _a === void 0 ? void 0 : _a.value;
            if (!!videoSource) {
                // Is New deviceId different from the old one?
                if (this.oVDevicesService.needUpdateVideoTrack(videoSource)) {
                    const mirror = this.oVDevicesService.cameraNeedsMirror(videoSource);
                    yield this.oVSessionService.replaceTrack(videoSource, null, mirror);
                    this.oVDevicesService.setCamSelected(videoSource);
                    this.camSelected = this.oVDevicesService.getCamSelected();
                }
                // Publish Webcam
                this.oVSessionService.publishVideo(true);
                this.isVideoActive = true;
                return;
            }
            // Unpublish webcam
            this.oVSessionService.publishVideo(false);
            this.isVideoActive = false;
        });
    }
    onMicrophoneSelected(event) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const audioSource = (_a = event) === null || _a === void 0 ? void 0 : _a.value;
            if (!!audioSource) {
                // Is New deviceId different than older?
                if (this.oVDevicesService.needUpdateAudioTrack(audioSource)) {
                    console.log(this.camSelected);
                    const mirror = this.oVDevicesService.cameraNeedsMirror(this.camSelected.device);
                    yield this.oVSessionService.replaceTrack(null, audioSource, mirror);
                    this.oVDevicesService.setMicSelected(audioSource);
                    this.micSelected = this.oVDevicesService.getMicSelected();
                }
                // Publish microphone
                this.publishAudio(true);
                this.isAudioActive = true;
                return;
            }
            // Unpublish microhpone
            this.publishAudio(false);
            this.isAudioActive = false;
        });
    }
    toggleCam() {
        this.isVideoActive = !this.isVideoActive;
        this.oVSessionService.publishVideo(this.isVideoActive);
        if (this.oVSessionService.areBothConnected()) {
            this.oVSessionService.disableWebcamUser();
            this.oVSessionService.publishScreenAudio(this.isAudioActive);
            // !this.subscribeToVolumeChange(<Publisher>this.localUsers[0].getStreamManager());
        }
        else if (this.oVSessionService.isOnlyScreenConnected()) {
            // (<Publisher>this.localUsers[0].getStreamManager()).off('streamAudioVolumeChange');
            this.oVSessionService.enableWebcamUser();
        }
    }
    toggleScreenShare() {
        if (this.oVSessionService.areBothConnected()) {
            this.oVSessionService.disableScreenUser();
            return;
        }
        if (this.oVSessionService.isOnlyWebcamConnected()) {
            const screenPublisher = this.initScreenPublisher();
            screenPublisher.on('accessAllowed', (event) => {
                screenPublisher.stream.getMediaStream().getVideoTracks()[0].addEventListener('ended', () => {
                    this.log.d('Clicked native stop button. Stopping screen sharing');
                    this.toggleScreenShare();
                });
                this.oVSessionService.enableScreenUser(screenPublisher);
                if (!this.oVSessionService.hasWebcamVideoActive()) {
                    this.oVSessionService.disableWebcamUser();
                }
            });
            screenPublisher.on('accessDenied', (event) => {
                this.log.w('ScreenShare: Access Denied');
            });
            return;
        }
        this.oVSessionService.enableWebcamUser();
        this.oVSessionService.disableScreenUser();
    }
    toggleMic() {
        this.isAudioActive = !this.isAudioActive;
        this.publishAudio(this.isAudioActive);
    }
    takePhoto() {
        this.oVSessionService.setWebcamAvatar();
        this.videoAvatar = this.oVSessionService.getWebCamAvatar();
        this.oVSessionService.setAvatar(AvatarType.VIDEO);
    }
    setNicknameForm() {
        if (this.externalConfig) {
            this.nicknameFormControl.setValue(this.externalConfig.getNickname());
            return;
        }
        const nickname = this.storageSrv.get(this.USER_NICKNAME) || this.utilsSrv.generateNickname();
        this.nicknameFormControl.setValue(nickname);
    }
    eventKeyPress(event) {
        if (event && event.keyCode === 13 && this.nicknameFormControl.valid) {
            this.joinSession();
        }
    }
    onResize(event) {
        this.columns = event.target.innerWidth > 900 ? 2 : 1;
    }
    // updateVolumeColor(): string {
    // 	// max = 0 / min = 100
    // 	if (this.volumeValue <= 20) {
    // 		return 'warn';
    // 	} else if (this.volumeValue > 20 && this.volumeValue <= 35) {
    // 		return 'accent';
    // 	} else if (this.volumeValue > 35) {
    // 		return 'primary';
    // 	}
    // }
    joinSession() {
        if (this.nicknameFormControl.valid) {
            // this.localUsers.forEach(user => {
            // 	user.getStreamManager().off('streamAudioVolumeChange');
            // });
            // if (this.avatarSelected === AVATAR_TYPE.RANDOM) {
            // 	this.localUsers[0].removeVideoAvatar();
            // }
            // if (this.localUsers[1]) {
            // 	this.localUsers[1].setUserAvatar(this.localUsers[0].getAvatar());
            // }
            this.oVSessionService.setWebcamName(this.nicknameFormControl.value);
            this.storageSrv.set(this.USER_NICKNAME, this.nicknameFormControl.value);
            this.join.emit();
        }
        this.scrollToBottom();
    }
    close() {
        this.leaveSession.emit();
        this.showConfigCard = false;
    }
    setAvatar(avatar) {
        // !! REFACTOR
        const avatarType = avatar === AvatarType.VIDEO ? AvatarType.VIDEO : AvatarType.RANDOM;
        if ((avatarType === AvatarType.RANDOM && this.randomAvatar) || (avatarType === AvatarType.VIDEO && this.videoAvatar)) {
            this.avatarSelected = avatarType;
            // if (avatarType === AVATAR_TYPE.RANDOM) {
            //   this.localUsers[0].setUserAvatar(this.randomAvatar);
            // }
        }
    }
    setDevicesInfo() {
        this.hasVideoDevices = this.oVDevicesService.hasVideoDeviceAvailable();
        this.hasAudioDevices = this.oVDevicesService.hasAudioDeviceAvailable();
        this.microphones = this.oVDevicesService.getMicrophones();
        this.cameras = this.oVDevicesService.getCameras();
        this.camSelected = this.oVDevicesService.getCamSelected();
        this.micSelected = this.oVDevicesService.getMicSelected();
    }
    setSessionName() {
        this.route.params.subscribe((params) => {
            this.mySessionId = this.externalConfig ? this.externalConfig.getSessionName() : params.roomName;
            this.oVSessionService.setSessionId(this.mySessionId);
        });
    }
    setRandomAvatar() {
        this.randomAvatar = this.utilsSrv.getOpenViduAvatar();
        this.oVSessionService.setAvatar(AvatarType.RANDOM, this.randomAvatar);
        this.avatarSelected = AvatarType.RANDOM;
    }
    scrollToBottom() {
        try {
            this.bodyCard.nativeElement.scrollTop = this.bodyCard.nativeElement.scrollHeight;
        }
        catch (err) {
        }
    }
    initScreenPublisher() {
        const videoSource = ScreenType.SCREEN;
        const willThereBeWebcam = this.oVSessionService.isWebCamEnabled() && this.oVSessionService.hasWebcamVideoActive();
        const hasAudio = willThereBeWebcam ? false : this.isAudioActive;
        const properties = this.oVSessionService.createProperties(videoSource, undefined, true, hasAudio, false);
        try {
            return this.oVSessionService.initScreenPublisher(undefined, properties);
        }
        catch (error) {
            this.log.e(error);
            this.utilsSrv.handlerScreenShareError(error);
        }
    }
    publishAudio(audio) {
        this.oVSessionService.isWebCamEnabled()
            ? this.oVSessionService.publishWebcamAudio(audio)
            : this.oVSessionService.publishScreenAudio(audio);
    }
    subscribeToUsers() {
        this.oVUsersSubscription = this.oVSessionService.OVUsers.subscribe((users) => {
            this.localUsers = users;
        });
    }
    initwebcamPublisher() {
        var _a, _b;
        const micStorageDevice = ((_a = this.micSelected) === null || _a === void 0 ? void 0 : _a.device) || undefined;
        const camStorageDevice = ((_b = this.camSelected) === null || _b === void 0 ? void 0 : _b.device) || undefined;
        const videoSource = this.hasVideoDevices ? camStorageDevice : false;
        const audioSource = this.hasAudioDevices ? micStorageDevice : false;
        const publishAudio = this.hasAudioDevices ? this.isAudioActive : false;
        const publishVideo = this.hasVideoDevices ? this.isVideoActive : false;
        const mirror = this.camSelected && this.camSelected.type === CameraType.FRONT;
        const properties = this.oVSessionService.createProperties(videoSource, audioSource, publishVideo, publishAudio, mirror);
        const publisher = this.oVSessionService.initCamPublisher(undefined, properties);
        this.handlePublisherSuccess(publisher);
        this.handlePublisherError(publisher);
    }
    emitPublisher(publisher) {
        this.publisherCreated.emit(publisher);
    }
    handlePublisherSuccess(publisher) {
        publisher.once('accessAllowed', () => __awaiter(this, void 0, void 0, function* () {
            if (this.oVDevicesService.areEmptyLabels()) {
                yield this.oVDevicesService.initDevices();
                if (this.hasAudioDevices) {
                    const audioLabel = publisher.stream.getMediaStream().getAudioTracks()[0].label;
                    this.oVDevicesService.setMicSelected(audioLabel);
                }
                if (this.hasVideoDevices) {
                    const videoLabel = publisher.stream.getMediaStream().getVideoTracks()[0].label;
                    this.oVDevicesService.setCamSelected(videoLabel);
                }
                this.setDevicesInfo();
            }
            // Emit publisher to webcomponent and angular-library
            this.emitPublisher(publisher);
            if (this.ovSettings.isAutoPublish()) {
                this.joinSession();
                return;
            }
            this.showConfigCard = true;
        }));
    }
    handlePublisherError(publisher) {
        publisher.once('accessDenied', (e) => {
            let message;
            if (e.name === 'DEVICE_ACCESS_DENIED') {
                message = 'Access to media devices was not allowed.';
            }
            if (e.name === 'NO_INPUT_SOURCE_SET') {
                message = 'No video or audio devices have been found. Please, connect at least one.';
            }
            this.utilsSrv.showErrorMessage(e.name.replace(/_/g, ' '), message, true);
            this.log.e(e.message);
        });
    }
};
RoomConfigComponent.ɵfac = function RoomConfigComponent_Factory(t) { return new (t || RoomConfigComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc10.ActivatedRoute), ɵngcc0.ɵɵdirectiveInject(UtilsService), ɵngcc0.ɵɵdirectiveInject(OpenViduSessionService), ɵngcc0.ɵɵdirectiveInject(DevicesService), ɵngcc0.ɵɵdirectiveInject(LoggerService), ɵngcc0.ɵɵdirectiveInject(StorageService)); };
RoomConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: RoomConfigComponent, selectors: [["app-room-config"]], viewQuery: function RoomConfigComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c9, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.bodyCard = _t.first);
    } }, hostBindings: function RoomConfigComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("beforeunload", function RoomConfigComponent_beforeunload_HostBindingHandler() { return ctx.beforeunloadHandler(); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { externalConfig: "externalConfig", ovSettings: "ovSettings" }, outputs: { join: "join", leaveSession: "leaveSession", publisherCreated: "publisherCreated" }, decls: 3, vars: 6, consts: [["id", "roomConfig", 3, "ngStyle"], ["class", "modal", 4, "ngIf"], [1, "modal"], [1, "modal-dialog", "modal-xl"], [1, "modal-content", "cardContainer"], [1, "modal-header", "cardHeader"], [1, "headerLogo"], ["id", "header_img", "alt", "OpenVidu Logo", "src", "https://raw.githubusercontent.com/OpenVidu/openvidu-call/master/openvidu-call-front/src/assets/images/openvidu_logo_grey.png"], [1, "headerTitle"], ["mat-mini-fab", "", "id", "closeButton", 1, "closeButton", 3, "click"], ["color", "warn", "matTooltip", "Close"], [1, "modal-body"], ["bodyCard", ""], [1, "row", "align-items-center"], [1, "col-sm-6", "col-md-6", "col-lg-6", "leftSection"], [1, "videoContainer"], [4, "ngFor", "ngForOf"], [1, "avatarButton"], ["mat-stroked-button", "", 3, "click"], ["matTooltip", "Take Photo"], [2, "margin-left", "5px"], [1, "col-sm-6", "col-md-6", "col-lg-6", "rightSection"], [1, "avatarContainer"], ["fxLayout", "row", "fxFill", "", "id", "avatarSection", 4, "ngIf"], ["fxLayout", "row", "fxFill", "", "id", "devicesSection"], ["fxLayout", "", "fxFlex", ""], ["fxFlex", "20", "fxLayoutAlign", "center center", 1, "one"], ["mat-mini-fab", "", 1, "deviceButton", 3, "click"], ["matTooltip", "Nickname"], ["fxFlex", "80", "fxLayoutAlign", "center center", 1, "two"], ["id", "nicknameForm", 1, "alternate-theme"], ["matInput", "", "placeholder", "Nickname", "autocomplete", "off", 3, "formControl", "errorStateMatcher", "keypress"], [4, "ngIf"], ["fxLayout", "row", "fxFill", "", "id", "devicesSection", 4, "ngIf"], [1, "modal-footer", 2, "justify-content", "center"], ["mat-flat-button", "", "color", "accent", "form", "nicknameForm", "id", "joinButton", 3, "click"], [3, "streamManager", "className", 4, "ngIf"], ["class", "cameraMessageContainer", 4, "ngIf"], [3, "streamManager", "className"], [1, "cameraMessageContainer"], ["fxLayout", "row", "fxFill", "", "id", "avatarSection"], ["fxFlex", "100", "fxLayoutAlign", "center center", 1, ""], ["id", "avatarContainer", 3, "click"], ["id", "imgText", 4, "ngIf"], ["id", "avatarImg", 3, "src", 4, "ngIf"], ["id", "imgText", "color", "accent", 3, "diameter", 4, "ngIf"], ["id", "imgText"], ["id", "avatarImg", 3, "src"], ["id", "imgText", "color", "accent", 3, "diameter"], ["mat-mini-fab", "", "id", "configCardMicrophoneButton", 1, "deviceButton", 3, "click"], ["matTooltip", "Microphone Enabled", 4, "ngIf"], ["color", "warn", "matTooltip", "Microphone Disabled", 4, "ngIf"], [1, "alternate-theme"], ["placeholder", "Microphone Options", 3, "ngModel", "selectionChange"], [3, "value", 4, "ngFor", "ngForOf"], ["matTooltip", "Microphone Enabled"], ["color", "warn", "matTooltip", "Microphone Disabled"], [3, "value"], ["mat-mini-fab", "", "id", "configCardCameraButton", 1, "deviceButton", 3, "click"], ["matTooltip", "Camera Enabled", 4, "ngIf"], ["color", "warn", "matTooltip", "Camera Disabled", 4, "ngIf"], ["placeholder", "Camera Options", 3, "ngModel", "selectionChange"], ["matTooltip", "Camera Enabled"], ["color", "warn", "matTooltip", "Camera Disabled"], ["mat-mini-fab", "", "id", "configCardScreenButton", 1, "deviceButton", 3, "click"], ["matTooltip", "Screen Share Enabled", 4, "ngIf"], ["color", "warn", "matTooltip", "Screen Share Disabled", 4, "ngIf"], ["matInput", "", "disabled", "", "placeholder", "Screen", 3, "ngModel"], ["matTooltip", "Screen Share Enabled"], ["color", "warn", "matTooltip", "Screen Share Disabled"]], template: function RoomConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵpipe(1, "isAutoPublish");
        ɵngcc0.ɵɵtemplate(2, RoomConfigComponent_div_2_Template, 49, 16, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(4, _c10, ɵngcc0.ɵɵpipeBind1(1, 2, ctx.ovSettings) ? "none" : "block"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showConfigCard);
    } }, directives: [ɵngcc5.NgStyle, ɵngcc7.DefaultStyleDirective, ɵngcc5.NgIf, ɵngcc2.MatButton, ɵngcc3.MatIcon, ɵngcc4.MatTooltip, ɵngcc5.NgForOf, ɵngcc16.DefaultLayoutDirective, ɵngcc16.FlexFillDirective, ɵngcc16.DefaultFlexDirective, ɵngcc16.DefaultLayoutAlignDirective, ɵngcc6.ɵangular_packages_forms_forms_y, ɵngcc6.NgControlStatusGroup, ɵngcc6.NgForm, ɵngcc13.MatFormField, ɵngcc14.MatInput, ɵngcc6.DefaultValueAccessor, ɵngcc6.NgControlStatus, ɵngcc6.FormControlDirective, OpenViduVideoComponent, ɵngcc18.MatSpinner, ɵngcc13.MatError, ɵngcc19.MatSelect, ɵngcc6.NgModel, ɵngcc20.MatOption], pipes: [IsAutoPublishPipe,
        HasAudioPipe,
        HasVideoPipe,
        HasScreenSharingPipe], styles: [".cardHeader[_ngcontent-%COMP%]{background-color:#ccc;border-radius:14px 14px 0 0;text-align:center;height:50px}.headerLogo[_ngcontent-%COMP%]{position:absolute;top:0;left:0;height:inherit}.headerTitle[_ngcontent-%COMP%]{font-size:large;margin:auto}.videoContainer[_ngcontent-%COMP%]{width:100%;height:calc(100% - 50px);text-align:center;margin:auto}.avatarButton[_ngcontent-%COMP%]{text-align:center;margin-top:10px}.videoContainer[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{display:inline}.ovVideoSmall[_ngcontent-%COMP%]{position:absolute;width:30%;left:15px;bottom:46px}.cameraMessageContainer[_ngcontent-%COMP%]{height:100%;width:100%;text-align:center;border:2px solid;font-size:large;display:table}.cameraMessageContainer[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{display:table-cell;vertical-align:middle}.deviceButton[_ngcontent-%COMP%]{box-shadow:none;background-color:#f5f5f5}.rightSection[_ngcontent-%COMP%]{padding-left:0!important;text-align:center}.avatarContainer[_ngcontent-%COMP%]{background-color:#f5f5f5;height:40px;text-align:center;display:flex}.avatarContainer[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{margin:auto}.closeButton[_ngcontent-%COMP%]{position:absolute;top:5px;right:7px;box-shadow:none;background-color:transparent}#roomConfig[_ngcontent-%COMP%]{position:absolute;width:100%;height:100%}#header_img[_ngcontent-%COMP%]{max-width:150px}#sessionInfo[_ngcontent-%COMP%]{margin-top:0}#joinButton[_ngcontent-%COMP%]{margin:15px;width:80%}#photoButton[_ngcontent-%COMP%]{margin:10px;text-align:center}#avatarContainer[_ngcontent-%COMP%]{border:1px solid #b6b6b6;width:100px;height:100px;margin:10px;position:relative;cursor:pointer;display:inline-block}#devicesSection[_ngcontent-%COMP%]{margin:15px 0}#avatarSection[_ngcontent-%COMP%], #devicesSection[_ngcontent-%COMP%]{height:-webkit-fit-content!important;height:-moz-fit-content!important;height:fit-content!important;min-height:auto!important}#imgText[_ngcontent-%COMP%]{display:table}#avatarImg[_ngcontent-%COMP%], #imgText[_ngcontent-%COMP%]{text-align:center;position:absolute;margin:auto;top:25%;left:0;right:0;bottom:25%}#avatarImg[_ngcontent-%COMP%]{height:83%;width:83%}#avatarContainer[_ngcontent-%COMP%], #avatarImg[_ngcontent-%COMP%]{border-radius:25%}#optionsContent[_ngcontent-%COMP%]{position:initial}#nicknameForm[_ngcontent-%COMP%], mat-form-field[_ngcontent-%COMP%]{width:100%}mat-card[_ngcontent-%COMP%]{max-width:85%!important;position:absolute;top:0;bottom:0;left:0;right:0;max-height:90%;margin:auto;padding:20px;overflow:auto;border:2px solid #fff;border-right:4px solid #fff}@media only screen and (max-width:959px){mat-card[_ngcontent-%COMP%]{max-width:80%!important;max-height:80%!important}}  .mat-option-text{color:#000!important}  .mat-slider-thumb{visibility:hidden}  .mat-slider-vertical .mat-slider-track-background,   .mat-slider-vertical .mat-slider-track-fill,   .mat-slider-vertical .mat-slider-track-wrapper{width:10px!important}[_ngcontent-%COMP%]::-webkit-scrollbar{width:8px}[_ngcontent-%COMP%]::-webkit-scrollbar-thumb{background:#b8afaf;border-radius:4px}[_ngcontent-%COMP%]::-webkit-scrollbar-thumb:hover{background:#888}[_ngcontent-%COMP%]::-webkit-scrollbar-track{background:#e1e1e1;border-radius:4px}*[_ngcontent-%COMP%], [_ngcontent-%COMP%]:after, [_ngcontent-%COMP%]:before{box-sizing:border-box}.container[_ngcontent-%COMP%]{padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}@media (min-width:768px){.container[_ngcontent-%COMP%]{width:750px}}@media (min-width:992px){.container[_ngcontent-%COMP%]{width:970px}}@media (min-width:1200px){.container[_ngcontent-%COMP%]{width:1170px}}.container-fluid[_ngcontent-%COMP%]{padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}.row[_ngcontent-%COMP%]{margin-right:-15px;margin-left:-15px}.row-no-gutters[_ngcontent-%COMP%]{margin-right:0;margin-left:0}.row-no-gutters[_ngcontent-%COMP%]   [class*=col-][_ngcontent-%COMP%]{padding-right:0;padding-left:0}.col-lg-1[_ngcontent-%COMP%], .col-lg-10[_ngcontent-%COMP%], .col-lg-11[_ngcontent-%COMP%], .col-lg-12[_ngcontent-%COMP%], .col-lg-2[_ngcontent-%COMP%], .col-lg-3[_ngcontent-%COMP%], .col-lg-4[_ngcontent-%COMP%], .col-lg-5[_ngcontent-%COMP%], .col-lg-6[_ngcontent-%COMP%], .col-lg-7[_ngcontent-%COMP%], .col-lg-8[_ngcontent-%COMP%], .col-lg-9[_ngcontent-%COMP%], .col-md-1[_ngcontent-%COMP%], .col-md-10[_ngcontent-%COMP%], .col-md-11[_ngcontent-%COMP%], .col-md-12[_ngcontent-%COMP%], .col-md-2[_ngcontent-%COMP%], .col-md-3[_ngcontent-%COMP%], .col-md-4[_ngcontent-%COMP%], .col-md-5[_ngcontent-%COMP%], .col-md-6[_ngcontent-%COMP%], .col-md-7[_ngcontent-%COMP%], .col-md-8[_ngcontent-%COMP%], .col-md-9[_ngcontent-%COMP%], .col-sm-1[_ngcontent-%COMP%], .col-sm-10[_ngcontent-%COMP%], .col-sm-11[_ngcontent-%COMP%], .col-sm-12[_ngcontent-%COMP%], .col-sm-2[_ngcontent-%COMP%], .col-sm-3[_ngcontent-%COMP%], .col-sm-4[_ngcontent-%COMP%], .col-sm-5[_ngcontent-%COMP%], .col-sm-6[_ngcontent-%COMP%], .col-sm-7[_ngcontent-%COMP%], .col-sm-8[_ngcontent-%COMP%], .col-sm-9[_ngcontent-%COMP%], .col-xs-1[_ngcontent-%COMP%], .col-xs-10[_ngcontent-%COMP%], .col-xs-11[_ngcontent-%COMP%], .col-xs-12[_ngcontent-%COMP%], .col-xs-2[_ngcontent-%COMP%], .col-xs-3[_ngcontent-%COMP%], .col-xs-4[_ngcontent-%COMP%], .col-xs-5[_ngcontent-%COMP%], .col-xs-6[_ngcontent-%COMP%], .col-xs-7[_ngcontent-%COMP%], .col-xs-8[_ngcontent-%COMP%], .col-xs-9[_ngcontent-%COMP%]{position:relative;min-height:1px;padding-right:15px;padding-left:15px}.col-xs-1[_ngcontent-%COMP%], .col-xs-10[_ngcontent-%COMP%], .col-xs-11[_ngcontent-%COMP%], .col-xs-12[_ngcontent-%COMP%], .col-xs-2[_ngcontent-%COMP%], .col-xs-3[_ngcontent-%COMP%], .col-xs-4[_ngcontent-%COMP%], .col-xs-5[_ngcontent-%COMP%], .col-xs-6[_ngcontent-%COMP%], .col-xs-7[_ngcontent-%COMP%], .col-xs-8[_ngcontent-%COMP%], .col-xs-9[_ngcontent-%COMP%]{float:left}.col-xs-12[_ngcontent-%COMP%]{width:100%}.col-xs-11[_ngcontent-%COMP%]{width:91.66666667%}.col-xs-10[_ngcontent-%COMP%]{width:83.33333333%}.col-xs-9[_ngcontent-%COMP%]{width:75%}.col-xs-8[_ngcontent-%COMP%]{width:66.66666667%}.col-xs-7[_ngcontent-%COMP%]{width:58.33333333%}.col-xs-6[_ngcontent-%COMP%]{width:50%}.col-xs-5[_ngcontent-%COMP%]{width:41.66666667%}.col-xs-4[_ngcontent-%COMP%]{width:33.33333333%}.col-xs-3[_ngcontent-%COMP%]{width:25%}.col-xs-2[_ngcontent-%COMP%]{width:16.66666667%}.col-xs-1[_ngcontent-%COMP%]{width:8.33333333%}.col-xs-pull-12[_ngcontent-%COMP%]{right:100%}.col-xs-pull-11[_ngcontent-%COMP%]{right:91.66666667%}.col-xs-pull-10[_ngcontent-%COMP%]{right:83.33333333%}.col-xs-pull-9[_ngcontent-%COMP%]{right:75%}.col-xs-pull-8[_ngcontent-%COMP%]{right:66.66666667%}.col-xs-pull-7[_ngcontent-%COMP%]{right:58.33333333%}.col-xs-pull-6[_ngcontent-%COMP%]{right:50%}.col-xs-pull-5[_ngcontent-%COMP%]{right:41.66666667%}.col-xs-pull-4[_ngcontent-%COMP%]{right:33.33333333%}.col-xs-pull-3[_ngcontent-%COMP%]{right:25%}.col-xs-pull-2[_ngcontent-%COMP%]{right:16.66666667%}.col-xs-pull-1[_ngcontent-%COMP%]{right:8.33333333%}.col-xs-pull-0[_ngcontent-%COMP%]{right:auto}.col-xs-push-12[_ngcontent-%COMP%]{left:100%}.col-xs-push-11[_ngcontent-%COMP%]{left:91.66666667%}.col-xs-push-10[_ngcontent-%COMP%]{left:83.33333333%}.col-xs-push-9[_ngcontent-%COMP%]{left:75%}.col-xs-push-8[_ngcontent-%COMP%]{left:66.66666667%}.col-xs-push-7[_ngcontent-%COMP%]{left:58.33333333%}.col-xs-push-6[_ngcontent-%COMP%]{left:50%}.col-xs-push-5[_ngcontent-%COMP%]{left:41.66666667%}.col-xs-push-4[_ngcontent-%COMP%]{left:33.33333333%}.col-xs-push-3[_ngcontent-%COMP%]{left:25%}.col-xs-push-2[_ngcontent-%COMP%]{left:16.66666667%}.col-xs-push-1[_ngcontent-%COMP%]{left:8.33333333%}.col-xs-push-0[_ngcontent-%COMP%]{left:auto}.col-xs-offset-12[_ngcontent-%COMP%]{margin-left:100%}.col-xs-offset-11[_ngcontent-%COMP%]{margin-left:91.66666667%}.col-xs-offset-10[_ngcontent-%COMP%]{margin-left:83.33333333%}.col-xs-offset-9[_ngcontent-%COMP%]{margin-left:75%}.col-xs-offset-8[_ngcontent-%COMP%]{margin-left:66.66666667%}.col-xs-offset-7[_ngcontent-%COMP%]{margin-left:58.33333333%}.col-xs-offset-6[_ngcontent-%COMP%]{margin-left:50%}.col-xs-offset-5[_ngcontent-%COMP%]{margin-left:41.66666667%}.col-xs-offset-4[_ngcontent-%COMP%]{margin-left:33.33333333%}.col-xs-offset-3[_ngcontent-%COMP%]{margin-left:25%}.col-xs-offset-2[_ngcontent-%COMP%]{margin-left:16.66666667%}.col-xs-offset-1[_ngcontent-%COMP%]{margin-left:8.33333333%}.col-xs-offset-0[_ngcontent-%COMP%]{margin-left:0}@media (min-width:768px){.col-sm-1[_ngcontent-%COMP%], .col-sm-10[_ngcontent-%COMP%], .col-sm-11[_ngcontent-%COMP%], .col-sm-12[_ngcontent-%COMP%], .col-sm-2[_ngcontent-%COMP%], .col-sm-3[_ngcontent-%COMP%], .col-sm-4[_ngcontent-%COMP%], .col-sm-5[_ngcontent-%COMP%], .col-sm-6[_ngcontent-%COMP%], .col-sm-7[_ngcontent-%COMP%], .col-sm-8[_ngcontent-%COMP%], .col-sm-9[_ngcontent-%COMP%]{float:left}.col-sm-12[_ngcontent-%COMP%]{width:100%}.col-sm-11[_ngcontent-%COMP%]{width:91.66666667%}.col-sm-10[_ngcontent-%COMP%]{width:83.33333333%}.col-sm-9[_ngcontent-%COMP%]{width:75%}.col-sm-8[_ngcontent-%COMP%]{width:66.66666667%}.col-sm-7[_ngcontent-%COMP%]{width:58.33333333%}.col-sm-6[_ngcontent-%COMP%]{width:50%}.col-sm-5[_ngcontent-%COMP%]{width:41.66666667%}.col-sm-4[_ngcontent-%COMP%]{width:33.33333333%}.col-sm-3[_ngcontent-%COMP%]{width:25%}.col-sm-2[_ngcontent-%COMP%]{width:16.66666667%}.col-sm-1[_ngcontent-%COMP%]{width:8.33333333%}.col-sm-pull-12[_ngcontent-%COMP%]{right:100%}.col-sm-pull-11[_ngcontent-%COMP%]{right:91.66666667%}.col-sm-pull-10[_ngcontent-%COMP%]{right:83.33333333%}.col-sm-pull-9[_ngcontent-%COMP%]{right:75%}.col-sm-pull-8[_ngcontent-%COMP%]{right:66.66666667%}.col-sm-pull-7[_ngcontent-%COMP%]{right:58.33333333%}.col-sm-pull-6[_ngcontent-%COMP%]{right:50%}.col-sm-pull-5[_ngcontent-%COMP%]{right:41.66666667%}.col-sm-pull-4[_ngcontent-%COMP%]{right:33.33333333%}.col-sm-pull-3[_ngcontent-%COMP%]{right:25%}.col-sm-pull-2[_ngcontent-%COMP%]{right:16.66666667%}.col-sm-pull-1[_ngcontent-%COMP%]{right:8.33333333%}.col-sm-pull-0[_ngcontent-%COMP%]{right:auto}.col-sm-push-12[_ngcontent-%COMP%]{left:100%}.col-sm-push-11[_ngcontent-%COMP%]{left:91.66666667%}.col-sm-push-10[_ngcontent-%COMP%]{left:83.33333333%}.col-sm-push-9[_ngcontent-%COMP%]{left:75%}.col-sm-push-8[_ngcontent-%COMP%]{left:66.66666667%}.col-sm-push-7[_ngcontent-%COMP%]{left:58.33333333%}.col-sm-push-6[_ngcontent-%COMP%]{left:50%}.col-sm-push-5[_ngcontent-%COMP%]{left:41.66666667%}.col-sm-push-4[_ngcontent-%COMP%]{left:33.33333333%}.col-sm-push-3[_ngcontent-%COMP%]{left:25%}.col-sm-push-2[_ngcontent-%COMP%]{left:16.66666667%}.col-sm-push-1[_ngcontent-%COMP%]{left:8.33333333%}.col-sm-push-0[_ngcontent-%COMP%]{left:auto}.col-sm-offset-12[_ngcontent-%COMP%]{margin-left:100%}.col-sm-offset-11[_ngcontent-%COMP%]{margin-left:91.66666667%}.col-sm-offset-10[_ngcontent-%COMP%]{margin-left:83.33333333%}.col-sm-offset-9[_ngcontent-%COMP%]{margin-left:75%}.col-sm-offset-8[_ngcontent-%COMP%]{margin-left:66.66666667%}.col-sm-offset-7[_ngcontent-%COMP%]{margin-left:58.33333333%}.col-sm-offset-6[_ngcontent-%COMP%]{margin-left:50%}.col-sm-offset-5[_ngcontent-%COMP%]{margin-left:41.66666667%}.col-sm-offset-4[_ngcontent-%COMP%]{margin-left:33.33333333%}.col-sm-offset-3[_ngcontent-%COMP%]{margin-left:25%}.col-sm-offset-2[_ngcontent-%COMP%]{margin-left:16.66666667%}.col-sm-offset-1[_ngcontent-%COMP%]{margin-left:8.33333333%}.col-sm-offset-0[_ngcontent-%COMP%]{margin-left:0}}@media (min-width:992px){.col-md-1[_ngcontent-%COMP%], .col-md-10[_ngcontent-%COMP%], .col-md-11[_ngcontent-%COMP%], .col-md-12[_ngcontent-%COMP%], .col-md-2[_ngcontent-%COMP%], .col-md-3[_ngcontent-%COMP%], .col-md-4[_ngcontent-%COMP%], .col-md-5[_ngcontent-%COMP%], .col-md-6[_ngcontent-%COMP%], .col-md-7[_ngcontent-%COMP%], .col-md-8[_ngcontent-%COMP%], .col-md-9[_ngcontent-%COMP%]{float:left}.col-md-12[_ngcontent-%COMP%]{width:100%}.col-md-11[_ngcontent-%COMP%]{width:91.66666667%}.col-md-10[_ngcontent-%COMP%]{width:83.33333333%}.col-md-9[_ngcontent-%COMP%]{width:75%}.col-md-8[_ngcontent-%COMP%]{width:66.66666667%}.col-md-7[_ngcontent-%COMP%]{width:58.33333333%}.col-md-6[_ngcontent-%COMP%]{width:50%}.col-md-5[_ngcontent-%COMP%]{width:41.66666667%}.col-md-4[_ngcontent-%COMP%]{width:33.33333333%}.col-md-3[_ngcontent-%COMP%]{width:25%}.col-md-2[_ngcontent-%COMP%]{width:16.66666667%}.col-md-1[_ngcontent-%COMP%]{width:8.33333333%}.col-md-pull-12[_ngcontent-%COMP%]{right:100%}.col-md-pull-11[_ngcontent-%COMP%]{right:91.66666667%}.col-md-pull-10[_ngcontent-%COMP%]{right:83.33333333%}.col-md-pull-9[_ngcontent-%COMP%]{right:75%}.col-md-pull-8[_ngcontent-%COMP%]{right:66.66666667%}.col-md-pull-7[_ngcontent-%COMP%]{right:58.33333333%}.col-md-pull-6[_ngcontent-%COMP%]{right:50%}.col-md-pull-5[_ngcontent-%COMP%]{right:41.66666667%}.col-md-pull-4[_ngcontent-%COMP%]{right:33.33333333%}.col-md-pull-3[_ngcontent-%COMP%]{right:25%}.col-md-pull-2[_ngcontent-%COMP%]{right:16.66666667%}.col-md-pull-1[_ngcontent-%COMP%]{right:8.33333333%}.col-md-pull-0[_ngcontent-%COMP%]{right:auto}.col-md-push-12[_ngcontent-%COMP%]{left:100%}.col-md-push-11[_ngcontent-%COMP%]{left:91.66666667%}.col-md-push-10[_ngcontent-%COMP%]{left:83.33333333%}.col-md-push-9[_ngcontent-%COMP%]{left:75%}.col-md-push-8[_ngcontent-%COMP%]{left:66.66666667%}.col-md-push-7[_ngcontent-%COMP%]{left:58.33333333%}.col-md-push-6[_ngcontent-%COMP%]{left:50%}.col-md-push-5[_ngcontent-%COMP%]{left:41.66666667%}.col-md-push-4[_ngcontent-%COMP%]{left:33.33333333%}.col-md-push-3[_ngcontent-%COMP%]{left:25%}.col-md-push-2[_ngcontent-%COMP%]{left:16.66666667%}.col-md-push-1[_ngcontent-%COMP%]{left:8.33333333%}.col-md-push-0[_ngcontent-%COMP%]{left:auto}.col-md-offset-12[_ngcontent-%COMP%]{margin-left:100%}.col-md-offset-11[_ngcontent-%COMP%]{margin-left:91.66666667%}.col-md-offset-10[_ngcontent-%COMP%]{margin-left:83.33333333%}.col-md-offset-9[_ngcontent-%COMP%]{margin-left:75%}.col-md-offset-8[_ngcontent-%COMP%]{margin-left:66.66666667%}.col-md-offset-7[_ngcontent-%COMP%]{margin-left:58.33333333%}.col-md-offset-6[_ngcontent-%COMP%]{margin-left:50%}.col-md-offset-5[_ngcontent-%COMP%]{margin-left:41.66666667%}.col-md-offset-4[_ngcontent-%COMP%]{margin-left:33.33333333%}.col-md-offset-3[_ngcontent-%COMP%]{margin-left:25%}.col-md-offset-2[_ngcontent-%COMP%]{margin-left:16.66666667%}.col-md-offset-1[_ngcontent-%COMP%]{margin-left:8.33333333%}.col-md-offset-0[_ngcontent-%COMP%]{margin-left:0}}@media (min-width:1200px){.col-lg-1[_ngcontent-%COMP%], .col-lg-10[_ngcontent-%COMP%], .col-lg-11[_ngcontent-%COMP%], .col-lg-12[_ngcontent-%COMP%], .col-lg-2[_ngcontent-%COMP%], .col-lg-3[_ngcontent-%COMP%], .col-lg-4[_ngcontent-%COMP%], .col-lg-5[_ngcontent-%COMP%], .col-lg-6[_ngcontent-%COMP%], .col-lg-7[_ngcontent-%COMP%], .col-lg-8[_ngcontent-%COMP%], .col-lg-9[_ngcontent-%COMP%]{float:left}.col-lg-12[_ngcontent-%COMP%]{width:100%}.col-lg-11[_ngcontent-%COMP%]{width:91.66666667%}.col-lg-10[_ngcontent-%COMP%]{width:83.33333333%}.col-lg-9[_ngcontent-%COMP%]{width:75%}.col-lg-8[_ngcontent-%COMP%]{width:66.66666667%}.col-lg-7[_ngcontent-%COMP%]{width:58.33333333%}.col-lg-6[_ngcontent-%COMP%]{width:50%}.col-lg-5[_ngcontent-%COMP%]{width:41.66666667%}.col-lg-4[_ngcontent-%COMP%]{width:33.33333333%}.col-lg-3[_ngcontent-%COMP%]{width:25%}.col-lg-2[_ngcontent-%COMP%]{width:16.66666667%}.col-lg-1[_ngcontent-%COMP%]{width:8.33333333%}.col-lg-pull-12[_ngcontent-%COMP%]{right:100%}.col-lg-pull-11[_ngcontent-%COMP%]{right:91.66666667%}.col-lg-pull-10[_ngcontent-%COMP%]{right:83.33333333%}.col-lg-pull-9[_ngcontent-%COMP%]{right:75%}.col-lg-pull-8[_ngcontent-%COMP%]{right:66.66666667%}.col-lg-pull-7[_ngcontent-%COMP%]{right:58.33333333%}.col-lg-pull-6[_ngcontent-%COMP%]{right:50%}.col-lg-pull-5[_ngcontent-%COMP%]{right:41.66666667%}.col-lg-pull-4[_ngcontent-%COMP%]{right:33.33333333%}.col-lg-pull-3[_ngcontent-%COMP%]{right:25%}.col-lg-pull-2[_ngcontent-%COMP%]{right:16.66666667%}.col-lg-pull-1[_ngcontent-%COMP%]{right:8.33333333%}.col-lg-pull-0[_ngcontent-%COMP%]{right:auto}.col-lg-push-12[_ngcontent-%COMP%]{left:100%}.col-lg-push-11[_ngcontent-%COMP%]{left:91.66666667%}.col-lg-push-10[_ngcontent-%COMP%]{left:83.33333333%}.col-lg-push-9[_ngcontent-%COMP%]{left:75%}.col-lg-push-8[_ngcontent-%COMP%]{left:66.66666667%}.col-lg-push-7[_ngcontent-%COMP%]{left:58.33333333%}.col-lg-push-6[_ngcontent-%COMP%]{left:50%}.col-lg-push-5[_ngcontent-%COMP%]{left:41.66666667%}.col-lg-push-4[_ngcontent-%COMP%]{left:33.33333333%}.col-lg-push-3[_ngcontent-%COMP%]{left:25%}.col-lg-push-2[_ngcontent-%COMP%]{left:16.66666667%}.col-lg-push-1[_ngcontent-%COMP%]{left:8.33333333%}.col-lg-push-0[_ngcontent-%COMP%]{left:auto}.col-lg-offset-12[_ngcontent-%COMP%]{margin-left:100%}.col-lg-offset-11[_ngcontent-%COMP%]{margin-left:91.66666667%}.col-lg-offset-10[_ngcontent-%COMP%]{margin-left:83.33333333%}.col-lg-offset-9[_ngcontent-%COMP%]{margin-left:75%}.col-lg-offset-8[_ngcontent-%COMP%]{margin-left:66.66666667%}.col-lg-offset-7[_ngcontent-%COMP%]{margin-left:58.33333333%}.col-lg-offset-6[_ngcontent-%COMP%]{margin-left:50%}.col-lg-offset-5[_ngcontent-%COMP%]{margin-left:41.66666667%}.col-lg-offset-4[_ngcontent-%COMP%]{margin-left:33.33333333%}.col-lg-offset-3[_ngcontent-%COMP%]{margin-left:25%}.col-lg-offset-2[_ngcontent-%COMP%]{margin-left:16.66666667%}.col-lg-offset-1[_ngcontent-%COMP%]{margin-left:8.33333333%}.col-lg-offset-0[_ngcontent-%COMP%]{margin-left:0}}.modal-open[_ngcontent-%COMP%]{overflow:hidden}.modal[_ngcontent-%COMP%]{top:0;right:0;bottom:0;left:0;z-index:1050;overflow:hidden;-webkit-overflow-scrolling:touch;outline:0;display:block;height:100%}.modal.fade[_ngcontent-%COMP%]   .modal-dialog[_ngcontent-%COMP%]{transform:translate(0,-25%);transition:transform .3s ease-out}.modal.in[_ngcontent-%COMP%]   .modal-dialog[_ngcontent-%COMP%]{transform:translate(0,0)}.modal-open[_ngcontent-%COMP%]   .modal[_ngcontent-%COMP%]{overflow-x:hidden;overflow-y:auto}.modal-dialog[_ngcontent-%COMP%]{width:auto;margin:30px;padding:100px 0;position:absolute;top:40%;left:50%;transform:translate(-50%,-50%)}.modal-content[_ngcontent-%COMP%]{position:relative;background-color:#fff;-webkit-background-clip:padding-box;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:15px;box-shadow:0 3px 9px rgba(0,0,0,.5);outline:0}.modal-backdrop[_ngcontent-%COMP%]{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:#000}.modal-backdrop.fade[_ngcontent-%COMP%]{opacity:0}.modal-backdrop.in[_ngcontent-%COMP%]{opacity:.5}.modal-header[_ngcontent-%COMP%]{padding:15px;border-bottom:1px solid #e5e5e5}.modal-header[_ngcontent-%COMP%]   .close[_ngcontent-%COMP%]{margin-top:-2px}.modal-title[_ngcontent-%COMP%]{margin:0;line-height:1.42857143}.modal-body[_ngcontent-%COMP%]{position:relative;padding:15px}.modal-footer[_ngcontent-%COMP%]{padding:1px;text-align:center;border-top:1px solid #e5e5e5}.modal-footer[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%] + .btn[_ngcontent-%COMP%]{margin-bottom:0;margin-left:5px}.modal-footer[_ngcontent-%COMP%]   .btn-group[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%] + .btn[_ngcontent-%COMP%]{margin-left:-1px}.modal-footer[_ngcontent-%COMP%]   .btn-block[_ngcontent-%COMP%] + .btn-block[_ngcontent-%COMP%]{margin-left:0}.modal-scrollbar-measure[_ngcontent-%COMP%]{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (max-width:600px){.headerTitle[_ngcontent-%COMP%]{display:none}.headerLogo[_ngcontent-%COMP%]{right:0}}@media (max-width:767px){.row[_ngcontent-%COMP%]{height:100%}.leftSection[_ngcontent-%COMP%]{height:60%}.rightSection[_ngcontent-%COMP%]{padding-right:0!important}.headerTitle[_ngcontent-%COMP%]{font-size:medium}.modal-content[_ngcontent-%COMP%]{max-height:100%;height:100%}.modal-dialog[_ngcontent-%COMP%]{height:calc(100% - 10px);margin:5px;padding:0;position:relative;top:0;left:0;transform:none}.modal-body[_ngcontent-%COMP%]{padding:10px 20px;overflow:auto;height:calc(100% - 120px);overflow:-moz-scrollbars-vertical;overflow-x:hidden;overflow-y:scroll}.modal[_ngcontent-%COMP%]{max-height:100%}.videoContainer[_ngcontent-%COMP%]{width:60%}}@media (min-width:768px){.ovVideoSmall[_ngcontent-%COMP%]{width:40%}.row[_ngcontent-%COMP%]{display:flex!important}.modal-dialog[_ngcontent-%COMP%]{width:90%;margin:55px auto}.modal-content[_ngcontent-%COMP%]{box-shadow:0 5px 15px rgba(0,0,0,.5)}.modal-sm[_ngcontent-%COMP%]{width:300px}}@media (min-width:992px){.modal-lg[_ngcontent-%COMP%]{width:75%}}@media (min-width:1440px){.modal-xl[_ngcontent-%COMP%]{width:75%}}"] });
RoomConfigComponent.ctorParameters = () => [
    { type: ActivatedRoute },
    { type: UtilsService },
    { type: OpenViduSessionService },
    { type: DevicesService },
    { type: LoggerService },
    { type: StorageService }
];
__decorate([
    ViewChild('bodyCard'),
    __metadata("design:type", ElementRef)
], RoomConfigComponent.prototype, "bodyCard", void 0);
__decorate([
    Input(),
    __metadata("design:type", ExternalConfigModel)
], RoomConfigComponent.prototype, "externalConfig", void 0);
__decorate([
    Input(),
    __metadata("design:type", OvSettingsModel)
], RoomConfigComponent.prototype, "ovSettings", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], RoomConfigComponent.prototype, "join", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], RoomConfigComponent.prototype, "leaveSession", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], RoomConfigComponent.prototype, "publisherCreated", void 0);
__decorate([
    HostListener('window:beforeunload'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], RoomConfigComponent.prototype, "beforeunloadHandler", null);
RoomConfigComponent = __decorate([ __metadata("design:paramtypes", [ActivatedRoute,
        UtilsService,
        OpenViduSessionService,
        DevicesService,
        LoggerService,
        StorageService])
], RoomConfigComponent);

let OpenviduSessionModule = class OpenviduSessionModule {
};
OpenviduSessionModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: OpenviduSessionModule });
OpenviduSessionModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function OpenviduSessionModule_Factory(t) { return new (t || OpenviduSessionModule)(); }, providers: [
        NetworkService,
        OpenViduSessionService,
        UtilsService,
        RemoteUsersService,
        DevicesService,
        LoggerService,
        ChatService,
        NotificationService,
        StorageService
    ], imports: [[
            CommonModule,
            HttpClientModule,
            FormsModule,
            ReactiveFormsModule,
            MatButtonModule,
            MatCardModule,
            MatToolbarModule,
            MatIconModule,
            MatInputModule,
            MatFormFieldModule,
            MatDialogModule,
            MatTooltipModule,
            MatBadgeModule,
            MatGridListModule,
            MatSelectModule,
            MatOptionModule,
            MatProgressSpinnerModule,
            MatSliderModule,
            MatSidenavModule,
            MatSnackBarModule,
            FlexLayoutModule,
            NgxLinkifyjsModule.forRoot()
        ]] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LoggerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(OpenViduSessionService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: LoggerService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(RemoteUsersService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: LoggerService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NotificationService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.MatSnackBar }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ChatService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: LoggerService }, { type: OpenViduSessionService }, { type: RemoteUsersService }, { type: NotificationService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ChatComponent, [{
        type: Component,
        args: [{
                selector: 'chat-component',
                template: "<div id=\"chatContainer\">\n\t<div id=\"chatComponent\" [class.chatComponentLight]=\"lightTheme\">\n\t\t<div id=\"chatToolbar\">\n\t\t\t<span> CHAT</span>\n\t\t\t<button mat-icon-button (click)=\"close()\" id=\"closeButton\">\n\t\t\t\t<mat-icon matTooltip=\"Close\" color=\"warn\">highlight_off</mat-icon>\n\t\t\t</button>\n\t\t</div>\n\t\t<div class=\"message-wrap\" #chatScroll>\n\t\t\t<div *ngFor=\"let data of messageList\" class=\"message\" [ngClass]=\"data.isLocal ? 'right' : 'left'\">\n\t\t\t\t<img class=\"user-img\" [src]=\"data.userAvatar\" />\n\t\t\t\t<div class=\"msg-detail\">\n\t\t\t\t\t<div class=\"msg-info\">\n\t\t\t\t\t\t<p>{{ data.nickname }}</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"msg-content\">\n\t\t\t\t\t\t<span class=\"triangle\"></span>\n\t\t\t\t\t\t<p class=\"text\" [innerHTML]=\"data.message | linkify\"></p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div id=\"messageInput\">\n\t\t\t<input\n\t\t\t\t#chatInput\n\t\t\t\tplaceholder=\"Send a message\"\n\t\t\t\tautocomplete=\"off\"\n\t\t\t\t(keypress)=\"eventKeyPress($event)\"\n\t\t\t\t[(ngModel)]=\"message\"\n\t\t\t\tid=\"chatInput\"\n\t\t\t/>\n\t\t\t<button mat-mini-fab id=\"sendButton\" (click)=\"sendMessage()\">\n\t\t\t\t<mat-icon matTooltip=\"Send\">send</mat-icon>\n\t\t\t</button>\n\t\t</div>\n\t</div>\n</div>\n",
                styles: ["#chatContainer{position:absolute;z-index:0;width:100%;height:calc(100% - 20px)}input{font-family:Ubuntu,sans-serif}#chatToolbar{height:30px;background-color:#3d3d3d;box-sizing:border-box;font-weight:700;font-size:14px;text-align:center;padding-top:4px;border-top-left-radius:6px;border-top-right-radius:6px;color:#fff}#closeButton{position:absolute;right:0;top:-5px}#chatComponent{background-color:#b8b8b8;position:absolute;z-index:99999;top:0;left:0;right:0;bottom:0;margin:auto;height:calc(100% - 30px);width:calc(100% - 30px);border-radius:20px}.message-wrap{padding:0 15px;height:calc(100% - 80px);overflow:auto}.message{position:relative;padding:7px 0}.user-img{position:absolute;border-radius:45px;width:60px;height:60px;top:15px}.msg-detail{width:calc(100% - 65px);display:inline-block}.msg-detail p{margin:0;font-size:15px}.msg-info p{font-size:.8em;color:#000;font-style:italic}.msg-content{position:relative;margin-top:5px;border-radius:5px;padding:8px;color:#000;width:auto;max-width:95%}span.triangle{border-radius:2px;height:8px;width:8px;top:12px;display:block;transform:rotate(45deg);position:absolute}.text{word-break:break-all}.message.left .msg-detail .msg-info{text-align:left}.message.left .msg-detail{padding-left:65px}.message.left .user-img{left:-5px;border:1px solid #f0f0f094}.message.left .msg-detail .msg-content{background-color:#f0f0f0;float:left}.message.left .msg-detail .msg-content span.triangle{background-color:#f0f0f0;border-bottom-width:0;border-left-width:0;left:-5px}.message.right .msg-detail .msg-info{text-align:right}.message.right .user-img{right:-5px;border:1px solid #c8ffe8ab}.message.right .msg-detail .msg-content{background-color:#c8ffe8;float:right}.message.right .msg-detail .msg-content span.triangle{background-color:#c8ffe8;border-bottom-width:0;border-left-width:0;right:-5px}#messageInput{position:absolute;bottom:0;width:100%;background-color:#fff;text-align:center;padding:10px 0;height:30px;border-bottom-left-radius:6px;border-bottom-right-radius:6px}#messageInput input{width:90%;height:100%;border:none;outline:0;font-size:14px;margin-left:-6%}#sendButton{background-color:#81e9b0;position:absolute;right:10px;top:0;bottom:0;margin:auto;border:1px solid #7ae2a9;box-shadow:none!important}#sendButton mat-icon{margin-left:3px!important;margin-bottom:2px!important}::-webkit-scrollbar{width:8px}::-webkit-scrollbar-thumb{background-color:#6b6b6b}.chatComponentLight ::-webkit-scrollbar-thumb{background-color:#eee!important}"]
            }]
    }], function () { return [{ type: ChatService }]; }, { onKeydownHandler: [{
            type: HostListener,
            args: ['document:keydown.escape', ['$event']]
        }], chatScroll: [{
            type: ViewChild,
            args: ['chatScroll']
        }], chatInput: [{
            type: ViewChild,
            args: ['chatInput']
        }], lightTheme: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DialogErrorComponent, [{
        type: Component,
        args: [{
                selector: 'app-dialog-error',
                template: "\n<div>\n\t<h1 mat-dialog-title>{{ data.header }}</h1>\n\t<span> {{ data.message }} </span>\n</div>\n",
                styles: ["h1{color:#a30101}"]
            }]
    }], function () { return [{ type: ɵngcc8.MatDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(UtilsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc8.MatDialog }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(StorageService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: LoggerService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DevicesService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: LoggerService }, { type: UtilsService }, { type: StorageService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NetworkService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc9.HttpClient }, { type: LoggerService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VideoRoomComponent, [{
        type: Component,
        args: [{
                selector: 'app-video-room',
                template: "<div *ngIf=\"!!ovSettings\" id=\"videoRoomNavBar\" [class.boundsLight]=\"lightTheme\">\n  <app-room-config\n    *ngIf=\"showConfigRoomCard\"\n    [ovSettings]=\"ovSettings\"\n    [externalConfig]=\"externalConfig\"\n    (join)=\"onConfigRoomJoin()\"\n    (leaveSession)=\"leaveSession()\"\n    (publisherCreated)=\"emitPublisher($event)\"\n  ></app-room-config>\n\n  <div *ngIf=\"localUsers && localUsers.length > 0\">\n    <div *ngIf=\"isConnectionLost\" class=\"reconnecting-container\"></div>\n    <app-toolbar\n      [lightTheme]=\"lightTheme\"\n      [compact]=\"compact\"\n      [mySessionId]=\"mySessionId\"\n      [ovSettings]=\"ovSettings\"\n      [hasVideoDevices]=\"hasVideoDevices\"\n      [hasAudioDevices]=\"hasAudioDevices\"\n      [isWebcamVideoEnabled]=\"oVSessionService.hasWebcamVideoActive()\"\n      [isWebcamAudioEnabled]=\"toolbarMicIconEnabled()\"\n      [isScreenEnabled]=\"oVSessionService.isScreenShareEnabled()\"\n      [isAutoLayout]=\"isAutoLayout\"\n      [isConnectionLost]=\"isConnectionLost\"\n      (camButtonClicked)=\"toggleCam()\"\n      (micButtonClicked)=\"toggleMic()\"\n      (screenShareClicked)=\"toggleScreenShare()\"\n      (layoutButtonClicked)=\"toggleSpeakerLayout()\"\n      (leaveSessionButtonClicked)=\"leaveSession()\"\n    ></app-toolbar>\n\n    <mat-sidenav-container class=\"sidenav-container\" id=\"room-container\" [class.boundsLight]=\"lightTheme\" fullscreen>\n      <mat-sidenav\n        #sidenav\n        mode=\"{{sidenavMode}}\"\n        position=\"end\"\n        class=\"sidenav-chat\"\n        [class.boundsLight]=\"lightTheme\"\n        fixedInViewport=\"true\"\n        fixedTopGap=\"40\"\n        fixedBottomGap=\"0\"\n        *ngIf=\"ovSettings | hasChat\"\n      >\n        <chat-component\n          #chatComponent\n          [lightTheme]=\"lightTheme\"\n        ></chat-component>\n      </mat-sidenav>\n\n      <mat-sidenav-content class=\"sidenav-main\">\n        <div id=\"layout\" class=\"bounds\" [class.boundsLight]=\"lightTheme\">\n          <div\n            class=\"OT_root OT_publisher custom-class\"\n            id=\"localUser\"\n            *ngFor=\"let localUser of localUsers\"\n            [style.display]=\"!localUser.streamManager?.stream?.videoActive ? 'none' : 'block'\"\n          >\n          <!-- Only webcam video will be shown if webcamera is available -->\n            <stream-component\n              [user]=\"localUser\"\n              [videoSizeBig]=\"localUser.videoSizeBig\"\n              (nicknameClicked)=\"onNicknameUpdate($event)\"\n              (replaceScreenTrackClicked)=\"onReplaceScreenTrack($event)\"\n              (toggleVideoSizeClicked)=\"onToggleVideoSize($event)\"\n            ></stream-component>\n          </div>\n\n          <div\n            *ngFor=\"let user of remoteUsers\"\n            class=\"OT_root OT_publisher custom-class\"\n            id=\"remoteUsers\"\n            [style.display]=\"!user.streamManager?.stream?.videoActive ? 'none' : 'block'\"\n          >\n            <stream-component\n              [user]=\"user\"\n              [videoSizeBig]=\"user.videoSizeBig\"\n              (toggleVideoSizeClicked)=\"onToggleVideoSize($event)\"\n            ></stream-component>\n          </div>\n        </div>\n      </mat-sidenav-content>\n    </mat-sidenav-container>\n\n    <app-footer\n      [lightTheme]=\"lightTheme\"\n      [participants]=\"remoteUsers\"\n    ></app-footer>\n  </div>\n</div>\n",
                styles: ["#videoRoomNavBar{min-width:400px;background-color:#494949;height:100%}.stream-container{padding:0}.reconnecting-container{width:100%;height:100%;z-index:1000;background-color:#000;opacity:80%;position:absolute}.sidenav-container{position:relative;width:100%;height:100%;min-height:-webkit-fill-available;overflow:hidden}.sidenav-chat{display:flex;align-items:center;justify-content:center;width:450px;background-color:#494949;border-left:none;position:absolute}.mat-drawer-container{background-color:#494949}.sidenav-main{height:100%;overflow:hidden;min-height:-webkit-fill-available;min-height:-moz-available}.bounds{background-color:#494949;position:absolute;left:0;right:0;top:40px;bottom:25px;min-width:400px!important;width:inherit}.boundsLight{background-color:#dfdfdf!important}/*!\n * Copyright (c) 2017 TokBox, Inc.\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n */.custom-class{min-height:0!important}.OT_root,.OT_root *{color:#fff;margin:0;padding:0;border:0;font-size:100%;font-family:Ubuntu,sans-serif;vertical-align:baseline}.OT_dialog-centering{display:table;width:100%;height:100%}.OT_dialog-centering-child{display:table-cell;vertical-align:middle}.OT_dialog{position:relative;box-sizing:border-box;margin-right:auto;margin-left:auto;color:#fff;font-family:Ubuntu,sans-serif;font-size:13px;line-height:1.4}.OT_dialog *{font-family:inherit;box-sizing:inherit}.OT_closeButton{color:#999;cursor:pointer;font-size:32px;line-height:36px;position:absolute;right:18px;top:0}.OT_dialog-messages{text-align:center}.OT_dialog-messages-main{margin-bottom:36px;line-height:36px;font-weight:300;font-size:24px}.OT_dialog-messages-minor{margin-bottom:18px;font-size:13px;line-height:18px;color:#a4a4a4}.OT_dialog-messages-minor strong{color:#fff}.OT_dialog-actions-card{display:inline-block}.OT_dialog-button-title{margin-bottom:18px;line-height:18px;font-weight:300;text-align:center;font-size:14px;color:#999}.OT_dialog-button-title label{color:#999}.OT_dialog-button-title a,.OT_dialog-button-title a:active,.OT_dialog-button-title a:link{color:#02a1de}.OT_dialog-button-title strong{color:#fff;font-weight:100;display:block}.OT_dialog-button{display:inline-block;margin-bottom:18px;padding:0 1em;background-color:#1ca3dc;text-align:center;cursor:pointer}.OT_dialog-button:disabled{cursor:not-allowed;opacity:.5}.OT_dialog-button-large{line-height:36px;padding-top:9px;padding-bottom:9px;font-weight:100;font-size:24px}.OT_dialog-button-small{line-height:18px;padding-top:9px;padding-bottom:9px;background-color:#444;color:#999;font-size:16px}.OT_dialog-progress-bar{display:inline-block;width:100%;margin-top:5px;margin-bottom:41px;border:1px solid #4e4e4e;height:8px}.OT_dialog-progress-bar-fill{height:100%;background-color:#29a4da}.OT_dialog-plugin-upgrading .OT_dialog-plugin-upgrade-percentage{line-height:54px;font-size:48px;font-weight:100}.OT_centered{position:fixed;left:50%;top:50%;margin:0}.OT_dialog-hidden{display:none}.OT_dialog-button-block{display:block}.OT_dialog-no-natural-margin{margin-bottom:0}.OT_publisher,.OT_subscriber{position:relative;min-width:48px;min-height:48px}.OT_publisher .OT_video-element,.OT_subscriber .OT_video-element{display:block;position:absolute;width:100%;height:100%;transform-origin:0 0}.OT_publisher.OT_mirrored .OT_video-element{transform:scale(-1,1);transform-origin:50% 50%}.OT_subscriber_error{background-color:#000;color:#fff;text-align:center}.OT_subscriber_error>p{padding:20px}.OT_publisher .OT_archiving,.OT_publisher .OT_archiving-light-box,.OT_publisher .OT_archiving-status,.OT_publisher .OT_bar,.OT_publisher .OT_name,.OT_subscriber .OT_archiving,.OT_subscriber .OT_archiving-light-box,.OT_subscriber .OT_archiving-status,.OT_subscriber .OT_bar,.OT_subscriber .OT_name{-ms-box-sizing:border-box;box-sizing:border-box;top:0;left:0;right:0;display:block;height:34px;position:absolute}.OT_publisher .OT_bar,.OT_subscriber .OT_bar{background:rgba(0,0,0,.4)}.OT_publisher .OT_edge-bar-item,.OT_subscriber .OT_edge-bar-item{z-index:1;transition-property:top,bottom,opacity;transition-duration:.5s;transition-timing-function:ease-in}.OT_publisher .OT_name,.OT_subscriber .OT_name{background-color:transparent;color:#fff;font-size:15px;line-height:34px;font-weight:400;padding:0 4px 0 36px}.OT_publisher .OT_archiving-status,.OT_subscriber .OT_archiving-status{background:rgba(0,0,0,.4);top:auto;bottom:0;left:34px;padding:0 4px;color:rgba(255,255,255,.8);font-size:15px;line-height:34px;font-weight:400}.OT_micro .OT_archiving-status,.OT_micro:hover .OT_archiving-status,.OT_mini .OT_archiving-status,.OT_mini:hover .OT_archiving-status{display:none}.OT_publisher .OT_archiving-light-box,.OT_subscriber .OT_archiving-light-box{background:rgba(0,0,0,.4);top:auto;bottom:0;right:auto;width:34px;height:34px}.OT_archiving-light{width:7px;height:7px;border-radius:30px;position:absolute;top:14px;left:14px;background-color:#575757;box-shadow:0 0 5px 1px #575757}.OT_archiving-light.OT_active{background-color:#970d13;animation:1.3s ease-in infinite OT_pulse;-webkit-animation:1.3s ease-in OT_pulse;-moz-animation:1.3s ease-in infinite OT_pulse;-webkit-animation-iteration-count:infinite}@-webkit-keyframes OT_pulse{0%,100%,80%{box-shadow:0 0 0 0 #c70019}30%,50%{box-shadow:0 0 5px 1px #c70019}}.OT_bar.OT_mode-mini,.OT_bar.OT_mode-mini-auto,.OT_mini .OT_bar{bottom:0;height:auto}.OT_mini .OT_name.OT_mode-auto,.OT_mini .OT_name.OT_mode-off,.OT_mini .OT_name.OT_mode-on,.OT_mini:hover .OT_name.OT_mode-auto{display:none}.OT_publisher .OT_name,.OT_subscriber .OT_name{left:10px;right:37px;height:34px;padding-left:0}.OT_publisher .OT_mute,.OT_subscriber .OT_mute{border:none;cursor:pointer;display:block;position:absolute;text-align:center;text-indent:-9999em;background-color:transparent;background-repeat:no-repeat;right:0;top:0;border-left:1px solid rgba(255,255,255,.2);height:36px;width:37px}.OT_mini .OT_mute,.OT_publisher.OT_mini .OT_mute.OT_mode-auto.OT_mode-on-hold,.OT_subscriber.OT_mini .OT_mute.OT_mode-auto.OT_mode-on-hold{top:50%;left:50%;right:auto;margin-top:-18px;margin-left:-18.5px;border-left:none}.OT_publisher .OT_mute{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAcCAMAAAC02HQrAAAA1VBMVEUAAAD3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pn3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pn3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj39/j3+Pj3+Pn4+Pk/JRMlAAAAQ3RSTlMABAUHCQoLDhAQERwdHiAjLjAxOD9ASFBRVl1mbnZ6fH2LjI+QkaWqrrC1uLzAwcXJycrL1NXj5Ofo6u3w9fr7/P3+d4M3+QAAAQBJREFUGBlVwYdCglAABdCLlr5Unijm3hMUtBzlBLSr//9JgUToOQgVJgceJgU8aHgMeA38K50ZOpcQmTPwcyXn+JM8M3JJIqQypiIkeXelTyIkGZPwKS1NMia1lgKTVkaE3oQQGYsmHNqSMWnTgUFbMiZtGlD2dpaxrL1XgM0i4ZK8MeAmFhsAs29MGZniawagS63oMOQUNXYB5D0D1RMDpyoMLw/fiE2og/V+PVDR5AiBl0/2Uwik+vx4xV3a5G5Ye68Nd1czjUjZckm6VhmPciRzeCZICjwTJAViQq+3e+St167rAoHK8sLYZVkBYPCZAZ/eGa+2R5LH7Wrc0YFf/O9J3yBDFaoAAAAASUVORK5CYII=);background-position:9px 5px}.OT_publisher .OT_mute.OT_active{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAdCAYAAABFRCf7AAADcElEQVRIiaWVXWhcRRTHf7NNd2aDtUKMIjTpg4ufFIuiUOmDEWm0Vi3VYhXRqIggQh4sWJFSig9+oOhTKSpIRUWMIBIr2kptoTbgU6ooxCiIjR+14kcJmf9sNceHnd3ebnc3Uv9wuXfOzPzmnDMz5zozGwdWAbc65w5RUJQ8cC2wDJgFJioh/MJCMrNxq2vOzK4HmIvRRemxKP0RJWt53o7S+d2Yzsx6gQ+AIUDAnUqpBLzXZd4RYFUlhB/bdZacc3PAOmAcCMC7wfvFwLNdoAPAyx09bXyYWRl4E7gDmAdGlNKFwLYu8GolhO9O87RJd64GbMrgEvB68P4osMWdXLtVV7czlooNpVRWSs8DO7NpR/B+3rBHsvetCgtCMTxwQCm9BbyQrc8F7/uBex3uRCeXO0PrUZ4NfKyUPgWeyj3bg/crDNsIRGwBaJQGorQ3Svdn2wHgc2BUKb0DPJHtjwfvbwRucc7tz+N+i9LFUdoXpfVN36I0CVwBTFI/q9e1LPxT8P4qYEdu70q12mYzWw1MYQzjeJF6zq+shHC4B7jklOBPP/TzSunh4P0DwKvAfb5c9krpe+CcwsEoZdbhEvBM9wxRAl5RShcA9wAngE3B+8tLpdLuwrhp4MNmK0pfRWkySr7NXS8+L5nZbWZWy/Vin1IaitJnUTqvwevJ71lgSSWEFKUfHG7Q2m/xqFJaGry/GXgfGPLl8mJgrXPur2JoUC8Qy3OpG+sAbGhEKT0ErAWOA6uBPWbW1wr9BOgFbgKezot0kAPYqJQA1gC/A9cA+82svzksSn1R+jNKX0SpnM/e1x3yqig92JhrZivM7FjO8bSZLSuCR/Ok16K0KMNHojQWpYko7Y7S1igN5PE3ROl4lNaZ2UVmNpPBU01orvZvZPCeKFXbBR+lEKVtUapFaSZKg9njqpl9aWYTrmXCImA7sCWb9lK/jj9TrwkrgA1AH3AQuKsSwkzbrLfxpgpsBtYDxf/R3xm2ExirhNCuHHZXTsmRwiat+S/zSt06eysVA/4pmGr/G3qm6ik28v29FKgCg8BS6pvS0KNRGgZ+Bb4FpsxsOkfUlMuwDcBWYOUZOHYM2AU8WQmhBifDv70O7PjX7KZ+4G7g3FM8zd6uBIaBy4AqxnIcZwFLCovPAhE4Sj38b4BDwEeVEFKD9S94Khjn486v3QAAAABJRU5ErkJggg==);background-position:9px 4px}.OT_subscriber .OT_mute{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAATCAYAAAB7u5a2AAABx0lEQVQ4jaWUv48NURiGn3ONmCs32ZBd28ht1gqyZAkF21ylQkEiSp2ehpDlD1BoFGqqVdJohYKI7MaPxMoVNghCWMF+7ybLUewnOXfcMWO9yeQ857zne8+XmZOBGjJpr0kvTIomvTZpS526UCO4DUwD64FjwCFgqZnnR+oc8LfgzKQ73vGsr42ZtGjSQFV9o8KfBCacZwCaef4YmAf2rzjcpN3A2WSpm/AssKcqPDNpDBjs410CViXzTwk/A7b1C4wxDgOngAsZcAXY2buDfp/6S4F3lDS8DjgBzDWAjX/Y/e/QgYS/AhsKHa+OMQ6GEJ4Cj4BOAxgq6aCowyZtdf4OtAr+FHDO+R4wWnVbihr3cQnICt4boO38GWj9a/icjwOACt4m4K3zEPA+AxaAtTWCnwN3lzHkEL8V/OPAGud9wK2GF9XR1Wae/1zG2AI+pGYI4VUIoRtjHAc2A9cz4LRPevYCZ+i9/4sJt4GXJU10gaPAzdI2TTro/5Tfz8XEe2LSZGmxq/SDNvP8BnA5WRrx4BwYBe6vONx1EnjovGvBLAAd4Adwuyq8UiaNmDTvr+a8SQ9MuvbfwckBHZPe+QEfTdpep+4XZmPBHiHgz74AAAAASUVORK5CYII=);background-position:8px 7px}.OT_subscriber .OT_mute.OT_active{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAUCAYAAACXtf2DAAACtklEQVQ4jZ2VSYiURxTHf+/T9Nc9iRrBuYySmIsXUU9iFMEFERRBvAjJLUQi5ioiHvSScfTmgqC4XAT1ZIgLuJHkICaaQAgKI2hAUBT30bjUq7bbv4eukXK029F3+eqtv/fqK6qQdEnSNUmT6CDB/bvgfjO4N9zj2RD8007xg1IABkwEzkma0qb4PGAPMBZYLtSD8eNwAEjqTlNI0gNJM4YU7w7ut4O7gvuhZFsR3C8NC5BBLiTIY0mzM8AvqbiC++pk+zLpE95XuwAws3vAQuBPYDRwWtL84P4tsDSLv5oaug4EYOawAMF9jMdoLxqNZcDvQA04UVYqL4G/svj7AF21mhJscrvCksYBFO7xc2AAGGg2mrdjvf4rcAyomNn+slLZmUEGBgsYdh945xZJmgvckDSrEJpK6ySBgV6q12O8ABwGPjGzfWWlsjdN9rpjoSfA+DYDXARGAksK4Is3XC1Ub4z1f4CDQGFmu6tleQSYk0U+p7WVeefLJc00s4fAeWB6Qeunvj0m2ugx9gO7kmlrtSxvBfcy6fXUZS6rgG/S+jLQUwCVNmMC9HqM14EtSe+rluWazN8YEv8IqKZ1E1qnaIDO0ucx3gX6kv6TpM3AM+D/IbGjgP60/gq4WQA33gMA2OQxPgHWJX1ttSwL4FAeZGYLgB2SasBs4A8L7qOBf9M0uXQB3a+TMYSmVctyDrA9mfcBK82smSdKWgCcAaa1bTm4fxbc/8uuCQX3RanAD5Ka6Wo5IGnE0HxJPZ03pQX5Org3MsD3AO5xXLPZXJ9BjkrqdFg6QjZkgG3Jtsw93pG0VFI9QU5K6voYQBHcTydAfwheBI9HgvvPAJIWS3qeIL9JGvUxkO7gfi1BrqTvwkG/pPmSnibIqTzXPgAyEVgBjAEu1qrVPbk/PVTHgb/NbPGg/RVIzOQqzSTBaQAAAABJRU5ErkJggg==);background-position:7px 7px}.OT_publisher .OT_edge-bar-item.OT_mode-auto,.OT_publisher .OT_edge-bar-item.OT_mode-mini-auto,.OT_publisher .OT_edge-bar-item.OT_mode-off,.OT_subscriber .OT_edge-bar-item.OT_mode-auto,.OT_subscriber .OT_edge-bar-item.OT_mode-mini-auto,.OT_subscriber .OT_edge-bar-item.OT_mode-off{top:-25px;opacity:0}.OT_publisher .OT_edge-bar-item.OT_mode-off,.OT_subscriber .OT_edge-bar-item.OT_mode-off{display:none}.OT_mini .OT_mute.OT_mode-auto,.OT_publisher .OT_mute.OT_mode-mini-auto,.OT_subscriber .OT_mute.OT_mode-mini-auto{top:50%}.OT_publisher .OT_edge-bar-item.OT_edge-bottom.OT_mode-auto,.OT_publisher .OT_edge-bar-item.OT_edge-bottom.OT_mode-mini-auto,.OT_publisher .OT_edge-bar-item.OT_edge-bottom.OT_mode-off,.OT_subscriber .OT_edge-bar-item.OT_edge-bottom.OT_mode-auto,.OT_subscriber .OT_edge-bar-item.OT_edge-bottom.OT_mode-mini-auto,.OT_subscriber .OT_edge-bar-item.OT_edge-bottom.OT_mode-off{top:auto;bottom:-25px}.OT_publisher .OT_edge-bar-item.OT_mode-auto.OT_mode-on-hold,.OT_publisher .OT_edge-bar-item.OT_mode-on,.OT_publisher:hover .OT_edge-bar-item.OT_mode-auto,.OT_publisher:hover .OT_edge-bar-item.OT_mode-mini-auto,.OT_subscriber .OT_edge-bar-item.OT_mode-auto.OT_mode-on-hold,.OT_subscriber .OT_edge-bar-item.OT_mode-on,.OT_subscriber:hover .OT_edge-bar-item.OT_mode-auto,.OT_subscriber:hover .OT_edge-bar-item.OT_mode-mini-auto{top:0;opacity:1}.OT_mini .OT_mute.OT_mode-on,.OT_mini:hover .OT_mute.OT_mode-auto,.OT_mute.OT_mode-mini,.OT_root:hover .OT_mute.OT_mode-mini-auto{top:50%}.OT_publisher .OT_edge-bar-item.OT_edge-bottom.OT_mode-on,.OT_publisher:hover .OT_edge-bar-item.OT_edge-bottom.OT_mode-auto,.OT_subscriber .OT_edge-bar-item.OT_edge-bottom.OT_mode-on,.OT_subscriber:hover .OT_edge-bar-item.OT_edge-bottom.OT_mode-auto{top:auto;bottom:0;opacity:1}.OT_root .OT_video-loading{position:absolute;z-index:1;width:100%;height:100%;display:none;background-color:rgba(0,0,0,.75)}.OT_root .OT_video-loading .OT_video-loading-spinner{background:url(data:image/svg+xml;base64,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) no-repeat;position:absolute;width:32px;height:32px;left:50%;top:50%;margin-left:-16px;margin-top:-16px;-webkit-animation:2s linear infinite OT_spin;animation:2s linear infinite OT_spin}@-webkit-keyframes OT_spin{100%{-webkit-transform:rotate(360deg)}}@keyframes OT_spin{100%{transform:rotate(360deg)}}.OT_publisher.OT_loading .OT_video-loading,.OT_subscriber.OT_loading .OT_video-loading{display:block}.OT_video-centering{display:table;width:100%;height:100%}.OT_video-container{display:table-cell;vertical-align:middle}.OT_video-poster{position:absolute;z-index:1;width:100%;height:100%;display:none;opacity:.25;background-repeat:no-repeat;background-image:url(data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNDcxIDQ2NCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48bGluZWFyR3JhZGllbnQgaWQ9ImEiIHgyPSIwIiB5Mj0iMSI+PHN0b3Agb2Zmc2V0PSI2Ni42NiUiIHN0b3AtY29sb3I9IiNmZmYiLz48c3RvcCBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9IiNmZmYiIHN0b3Atb3BhY2l0eT0iMCIvPjwvbGluZWFyR3JhZGllbnQ+PHBhdGggZmlsbD0idXJsKCNhKSIgZD0iTTc5IDMwOGMxNC4yNS02LjUgNTQuMjUtMTkuNzUgNzEtMjkgOS0zLjI1IDI1LTIxIDI1LTIxczMuNzUtMTMgMy0yMmMtMS43NS02Ljc1LTE1LTQzLTE1LTQzLTIuNSAzLTQuNzQxIDMuMjU5LTcgMS0zLjI1LTcuNS0yMC41LTQ0LjUtMTYtNTcgMS4yNS03LjUgMTAtNiAxMC02LTExLjI1LTMzLjc1LTgtNjctOC02N3MuMDczLTcuMzQ2IDYtMTVjLTMuNDguNjM3LTkgNC05IDQgMi41NjMtMTEuNzI3IDE1LTIxIDE1LTIxIC4xNDgtLjMxMi0xLjMyMS0xLjQ1NC0xMCAxIDEuNS0yLjc4IDE2LjY3NS04LjY1NCAzMC0xMSAzLjc4Ny05LjM2MSAxMi43ODItMTcuMzk4IDIyLTIyLTIuMzY1IDMuMTMzLTMgNi0zIDZzMTUuNjQ3LTguMDg4IDQxLTZjLTE5Ljc1IDItMjQgNi0yNCA2czc0LjUtMTAuNzUgMTA0IDM3YzcuNSA5LjUgMjQuNzUgNTUuNzUgMTAgODkgMy43NS0xLjUgNC41LTQuNSA5IDEgLjI1IDE0Ljc1LTExLjUgNjMtMTkgNjItMi43NSAxLTQtMy00LTMtMTAuNzUgMjkuNS0xNCAzOC0xNCAzOC0yIDQuMjUtMy43NSAxOC41LTEgMjIgMS4yNSA0LjUgMjMgMjMgMjMgMjNsMTI3IDUzYzM3IDM1IDIzIDEzNSAyMyAxMzVMMCA0NjRzLTMtOTYuNzUgMTQtMTIwYzUuMjUtNi4yNSAyMS43NS0xOS43NSA2NS0zNnoiLz48L3N2Zz4=);background-size:auto 76%}.OT_fit-mode-cover .OT_video-element{-o-object-fit:cover;object-fit:cover}@media only screen and (orientation:portrait){.OT_subscriber.OT_ForceContain.OT_fit-mode-cover .OT_video-element{-o-object-fit:contain!important;object-fit:contain!important}}.OT_fit-mode-contain .OT_video-element{-o-object-fit:contain;object-fit:contain}.OT_fit-mode-cover .OT_video-poster{background-position:center bottom}.OT_fit-mode-contain .OT_video-poster{background-position:center}.OT_audio-level-meter{position:absolute;width:25%;max-width:224px;min-width:21px;top:0;right:0;overflow:hidden}.OT_audio-level-meter:before{content:'';display:block;padding-top:100%}.OT_audio-level-meter__bar{position:absolute;width:192%;height:192%;top:-96%;right:-96%;border-radius:50%;background-color:rgba(0,0,0,.8)}.OT_audio-level-meter__audio-only-img{position:absolute;top:22%;right:15%;width:40%;opacity:.7;background:url(data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNzkgODYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iI2ZmZiI+PHBhdGggZD0iTTkuNzU3IDQwLjkyNGMzLjczOC01LjE5MSAxMi43MTEtNC4zMDggMTIuNzExLTQuMzA4IDIuMjIzIDMuMDE0IDUuMTI2IDI0LjU4NiAzLjYyNCAyOC43MTgtMS40MDEgMS4zMDEtMTEuNjExIDEuNjI5LTEzLjM4LTEuNDM2LTEuMjI2LTguODA0LTIuOTU1LTIyLjk3NS0yLjk1NS0yMi45NzV6bTU4Ljc4NSAwYy0zLjczNy01LjE5MS0xMi43MTEtNC4zMDgtMTIuNzExLTQuMzA4LTIuMjIzIDMuMDE0LTUuMTI2IDI0LjU4Ni0zLjYyNCAyOC43MTggMS40MDEgMS4zMDEgMTEuNjExIDEuNjI5IDEzLjM4LTEuNDM2IDEuMjI2LTguODA0IDIuOTU1LTIyLjk3NSAyLjk1NS0yMi45NzV6Ii8+PHBhdGggZD0iTTY4LjY0NyA1OC42Yy43MjktNC43NTMgMi4zOC05LjU2MSAyLjM4LTE0LjgwNCAwLTIxLjQxMi0xNC4xMTUtMzguNzctMzEuNTI4LTM4Ljc3LTE3LjQxMiAwLTMxLjUyNyAxNy4zNTgtMzEuNTI3IDM4Ljc3IDAgNC41NDEuNTE1IDguOTM2IDEuODAyIDEyLjk1IDEuNjk4IDUuMjk1LTUuNTQyIDYuOTkxLTYuNjE2IDIuMDczQzIuNDEgNTUuMzk0IDAgNTEuNzg3IDAgNDguMTAzIDAgMjEuNTM2IDE3LjY4NSAwIDM5LjUgMCA2MS4zMTYgMCA3OSAyMS41MzYgNzkgNDguMTAzYzAgLjcxOC0yLjg5OSA5LjY5My0zLjI5MiAxMS40MDgtLjc1NCAzLjI5My03Ljc1MSAzLjU4OS03LjA2MS0uOTEyeiIvPjxwYXRoIGQ9Ik01LjA4NCA1MS4zODVjLS44MDQtMy43ODIuNTY5LTcuMzM1IDMuMTM0LTcuOTIxIDIuNjM2LS42MDMgNS40ODUgMi4xNSA2LjI4OSA2LjEzMi43OTcgMy45NDgtLjc1MiA3LjQ1Ny0zLjM4OCA3Ljg1OS0yLjU2Ni4zOTEtNS4yMzctMi4zMTgtNi4wMzQtNi4wN3ptNjguODM0IDBjLjgwNC0zLjc4Mi0uNTY4LTcuMzM1LTMuMTMzLTcuOTIxLTIuNjM2LS42MDMtNS40ODUgMi4xNS02LjI4OSA2LjEzMi0uNzk3IDMuOTQ4Ljc1MiA3LjQ1NyAzLjM4OSA3Ljg1OSAyLjU2NS4zOTEgNS4yMzctMi4zMTggNi4wMzQtNi4wN3ptLTIuMDM4IDguMjg4Yy0uOTI2IDE5LjY1OS0xNS4xMTIgMjQuNzU5LTI1Ljg1OSAyMC40NzUtNS40MDUtLjYwNi0zLjAzNCAxLjI2Mi0zLjAzNCAxLjI2MiAxMy42NjEgMy41NjIgMjYuMTY4IDMuNDk3IDMxLjI3My0yMC41NDktLjU4NS00LjUxMS0yLjM3OS0xLjE4Ny0yLjM3OS0xLjE4N3oiLz48cGF0aCBkPSJNNDEuNjYyIDc4LjQyMmw3LjU1My41NWMxLjE5Mi4xMDcgMi4xMiAxLjE1MyAyLjA3MiAyLjMzNWwtLjEwOSAyLjczOGMtLjA0NyAxLjE4Mi0xLjA1MSAyLjA1NC0yLjI0MyAxLjk0NmwtNy41NTMtLjU1Yy0xLjE5MS0uMTA3LTIuMTE5LTEuMTUzLTIuMDcyLTIuMzM1bC4xMDktMi43MzdjLjA0Ny0xLjE4MiAxLjA1Mi0yLjA1NCAyLjI0My0xLjk0N3oiLz48L2c+PC9zdmc+) center no-repeat}.OT_audio-level-meter__audio-only-img:before{content:'';display:block;padding-top:100%}.OT_audio-level-meter__value{position:absolute;border-radius:50%;background-image:radial-gradient(circle,#97ce00 0,rgba(151,206,0,0) 100%)}.OT_audio-level-meter.OT_mode-off{display:none}.OT_audio-level-meter.OT_mode-on,.OT_audio-only .OT_audio-level-meter.OT_mode-auto{display:block}.OT_audio-only.OT_publisher .OT_video-element,.OT_audio-only.OT_subscriber .OT_video-element{display:none}.OT_video-disabled-indicator{opacity:1;border:none;display:none;position:absolute;background-color:transparent;background-repeat:no-repeat;background-position:bottom right;pointer-events:none;top:0;left:0;bottom:3px;right:3px}.OT_video-disabled{background-image:url(data:image/png;base64,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);background-size:33px auto}.OT_video-disabled-warning{background-image:url(data:image/png;base64,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);background-size:33px auto}.OT_video-disabled-indicator.OT_active{display:block}.OT_audio-blocked-indicator{opacity:1;border:none;display:none;position:absolute;background-color:transparent;background-repeat:no-repeat;background-position:center;pointer-events:none;top:0;left:0;bottom:0;right:0}.OT_audio-blocked{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTUwIiBoZWlnaHQ9IjkwIj48ZGVmcz48cGF0aCBkPSJNNjcgMTJMNi40NDggNzIuNTUyIDAgMzFWMThMMjYgMGw0MSAxMnptMyA3bDYgNDctMjkgMTgtMzUuNTAyLTYuNDk4TDcwIDE5eiIgaWQ9ImEiLz48L2RlZnM+PHJlY3Qgd2lkdGg9IjE1MCIgaGVpZ2h0PSI5MCIgcng9IjM1IiByeT0iNDUiIG9wYWNpdHk9Ii41Ii8+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzNikiPjxtYXNrIGlkPSJiIiBmaWxsPSIjZmZmIj48dXNlIHhsaW5rOmhyZWY9IiNhIi8+PC9tYXNrPjxwYXRoIGQ9Ik0zOS4yNDkgNTEuMzEyYy42OTcgMTAuMzcgMi43ODUgMTcuODk3IDUuMjUxIDE3Ljg5NyAzLjAzOCAwIDUuNS0xMS40MTcgNS41LTI1LjVzLTIuNDYyLTI1LjUtNS41LTI1LjVjLTIuNTEgMC00LjYyOCA3Ljc5Ny01LjI4NyAxOC40NTNBOC45ODkgOC45ODkgMCAwIDEgNDMgNDRhOC45ODggOC45ODggMCAwIDEtMy43NTEgNy4zMTJ6TTIwLjk4NSAzMi4yMjRsMTUuNzQ2LTE2Ljg3N2E3LjM4NSA3LjM4NSAwIDAgMSAxMC4zNzQtLjQyQzUxLjcwMiAxOS4xMTQgNTQgMjkuMjA4IDU0IDQ1LjIwOGMwIDE0LjUyNy0yLjM0MyAyMy44OC03LjAzIDI4LjA1OGE3LjI4IDcuMjggMCAwIDEtMTAuMTY4LS40NjhMMjAuNDA1IDU1LjIyNEgxMmE1IDUgMCAwIDEtNS01di0xM2E1IDUgMCAwIDEgNS01aDguOTg1eiIgZmlsbD0iI0ZGRiIgbWFzaz0idXJsKCNiKSIvPjwvZz48cGF0aCBkPSJNMTA2LjUgMTMuNUw0NC45OTggNzUuMDAyIiBzdHJva2U9IiNGRkYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+PC9nPjwvc3ZnPg==);background-size:90px auto}.OT_container-audio-blocked{cursor:pointer}.OT_container-audio-blocked .OT_mute,.OT_container-audio-blocked.OT_mini .OT_edge-bar-item{display:none}.OT_audio-blocked-indicator.OT_active{display:block}.OT_video-unsupported{opacity:1;border:none;display:none;position:absolute;background-color:transparent;background-repeat:no-repeat;background-position:center;background-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTciIGhlaWdodD0iOTAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxkZWZzPjxwYXRoIGQ9Ik03MCAxMkw5LjQ0OCA3Mi41NTIgMCA2MmwzLTQ0TDI5IDBsNDEgMTJ6bTggMmwxIDUyLTI5IDE4LTM1LjUwMi02LjQ5OEw3OCAxNHoiIGlkPSJhIi8+PC9kZWZzPjxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOCAzKSI+PG1hc2sgaWQ9ImIiIGZpbGw9IiNmZmYiPjx1c2UgeGxpbms6aHJlZj0iI2EiLz48L21hc2s+PHBhdGggZD0iTTkuMTEgMjAuOTY4SDQ4LjFhNSA1IDAgMCAxIDUgNVY1OC4xOGE1IDUgMCAwIDEtNSA1SDkuMTFhNSA1IDAgMCAxLTUtNVYyNS45N2E1IDUgMCAwIDEgNS01em00Ny4wOCAxMy4zOTRjMC0uMzQ1IDUuNDcyLTMuMTU5IDE2LjQxNS04LjQ0M2EzIDMgMCAwIDEgNC4zMDQgMi43MDJ2MjYuODM1YTMgMyAwIDAgMS00LjMwNSAyLjcwMWMtMTAuOTQyLTUuMjg2LTE2LjQxMy04LjEtMTYuNDEzLTguNDQ2VjM0LjM2MnoiIGZpbGw9IiNGRkYiIG1hc2s9InVybCgjYikiLz48L2c+PHBhdGggZD0iTTgxLjUgMTYuNUwxOS45OTggNzguMDAyIiBzdHJva2U9IiNGRkYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+PC9nPjwvc3ZnPg==);background-size:58px auto;pointer-events:none;top:0;left:0;bottom:0;right:0;margin-top:-30px}.OT_video-unsupported-bar{display:none;position:absolute;width:192%;height:192%;top:-96%;left:-96%;border-radius:50%;background-color:rgba(0,0,0,.8)}.OT_video-unsupported-img{display:none;position:absolute;top:11%;left:15%;width:70%;opacity:.7;background-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTciIGhlaWdodD0iOTAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxkZWZzPjxwYXRoIGQ9Ik03MCAxMkw5LjQ0OCA3Mi41NTIgMCA2MmwzLTQ0TDI5IDBsNDEgMTJ6bTggMmwxIDUyLTI5IDE4LTM1LjUwMi02LjQ5OEw3OCAxNHoiIGlkPSJhIi8+PC9kZWZzPjxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOCAzKSI+PG1hc2sgaWQ9ImIiIGZpbGw9IiNmZmYiPjx1c2UgeGxpbms6aHJlZj0iI2EiLz48L21hc2s+PHBhdGggZD0iTTkuMTEgMjAuOTY4SDQ4LjFhNSA1IDAgMCAxIDUgNVY1OC4xOGE1IDUgMCAwIDEtNSA1SDkuMTFhNSA1IDAgMCAxLTUtNVYyNS45N2E1IDUgMCAwIDEgNS01em00Ny4wOCAxMy4zOTRjMC0uMzQ1IDUuNDcyLTMuMTU5IDE2LjQxNS04LjQ0M2EzIDMgMCAwIDEgNC4zMDQgMi43MDJ2MjYuODM1YTMgMyAwIDAgMS00LjMwNSAyLjcwMWMtMTAuOTQyLTUuMjg2LTE2LjQxMy04LjEtMTYuNDEzLTguNDQ2VjM0LjM2MnoiIGZpbGw9IiNGRkYiIG1hc2s9InVybCgjYikiLz48L2c+PHBhdGggZD0iTTgxLjUgMTYuNUwxOS45OTggNzguMDAyIiBzdHJva2U9IiNGRkYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+PC9nPjwvc3ZnPg==);background-repeat:no-repeat;background-position:center;background-size:100% auto}.OT_video-unsupported-img:before{content:'';display:block;padding-top:93%}.OT_video-unsupported-text{display:flex;justify-content:center;align-items:center;text-align:center;height:100%;margin-top:40px}@media only screen and (max-width:600px){#videoRoomNavBar{width:100%}}"]
            }]
    }], function () { return [{ type: NetworkService }, { type: ɵngcc10.Router }, { type: UtilsService }, { type: RemoteUsersService }, { type: OpenViduSessionService }, { type: DevicesService }, { type: LoggerService }, { type: ChatService }]; }, { _session: [{
            type: Output
        }], _publisher: [{
            type: Output
        }], _error: [{
            type: Output
        }], _joinSession: [{
            type: Output
        }], _leaveSession: [{
            type: Output
        }], beforeunloadHandler: [{
            type: HostListener,
            args: ['window:beforeunload']
        }], sizeChange: [{
            type: HostListener,
            args: ['window:resize']
        }], externalConfig: [{
            type: Input
        }], chatComponent: [{
            type: ViewChild,
            args: ['chatComponent']
        }], chatSidenav: [{
            type: ViewChild,
            args: ['sidenav']
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(OpenviduSessionComponent, [{
        type: Component,
        args: [{
                selector: 'opv-session',
                template: `
		<app-video-room
			#videoRoom
			*ngIf="display"
			[externalConfig]="angularLibrary"
			(_session)="emitSession($event)"
			(_publisher)="emitPublisher($event)"
			(_error)="emitErrorEvent($event)"
			(_leaveSession)="emitLeaveSessionEvent($event)"
			(_joinSession)="emitJoinSessionEvent($event)"
		>
		</app-video-room>
	`
            }]
    }], function () { return [{ type: LoggerService }]; }, { sessionCreated: [{
            type: Output
        }], publisherCreated: [{
            type: Output
        }], error: [{
            type: Output
        }], joinSession: [{
            type: Output
        }], leaveSession: [{
            type: Output
        }], ovSettings: [{
            type: Input
        }], sessionName: [{
            type: Input
        }], user: [{
            type: Input
        }], openviduServerUrl: [{
            type: Input
        }], openviduSecret: [{
            type: Input
        }], tokens: [{
            type: Input
        }], theme: [{
            type: Input
        }], videoRoom: [{
            type: ViewChild,
            args: ['videoRoom']
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LinkifyPipe, [{
        type: Pipe,
        args: [{ name: 'linkify' }]
    }], function () { return [{ type: ɵngcc12.NgxLinkifyjsService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HasChatPipe, [{
        type: Pipe,
        args: [{ name: 'hasChat', pure: true }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HasAudioPipe, [{
        type: Pipe,
        args: [{ name: 'hasAudio', pure: true }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HasVideoPipe, [{
        type: Pipe,
        args: [{ name: 'hasVideo', pure: true }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(IsAutoPublishPipe, [{
        type: Pipe,
        args: [{ name: 'isAutoPublish', pure: true }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HasScreenSharingPipe, [{
        type: Pipe,
        args: [{ name: 'hasScreenSharing', pure: true }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HasFullscreenPipe, [{
        type: Pipe,
        args: [{ name: 'hasFullscreen', pure: true }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HasLayoutSpeakingPipe, [{
        type: Pipe,
        args: [{ name: 'hasLayoutSpeaking', pure: true }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HasExitPipe, [{
        type: Pipe,
        args: [{ name: 'hasExit', pure: true }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TooltipListPipe, [{
        type: Pipe,
        args: [{ name: 'tooltipList', pure: true }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(StreamComponent, [{
        type: Component,
        args: [{
                selector: 'stream-component',
                template: "<div *ngIf=\"this._user\"\n\tclass=\"OT_widget-container\"\n\t[id]=\"'container-' + this._user.streamManager.stream.streamId\"\n\t#streamComponent\n\t(dblclick)=\"toggleVideoSize()\"\n>\n\t<div class=\"nickname\" [class.fullscreen]=\"isFullscreen\">\n\t\t<div (click)=\"toggleNicknameForm()\" class=\"nicknameContainer\" selected *ngIf=\"!toggleNickname\">\n\t\t\t<span id=\"nickname\">{{ this._user.nickname }}</span>\n\t\t\t<span *ngIf=\"!this._user.streamManager.remote\"> (edit)</span>\n\t\t</div>\n\t\t<div *ngIf=\"toggleNickname && !this._user.streamManager.remote\" [class.fullscreen]=\"isFullscreen\" id=\"dialogNickname\">\n\t\t\t<button mat-icon-button (click)=\"toggleNicknameForm()\" id=\"closeButton\">\n\t\t\t\t<mat-icon matTooltip=\"Close\">highlight_off</mat-icon>\n\t\t\t</button>\n\t\t\t<form id=\"nicknameForm\">\n\t\t\t\t<mat-form-field color=\"primary\">\n\t\t\t\t\t<input\n\t\t\t\t\t\tmatInput\n\t\t\t\t\t\t#nicknameInput\n\t\t\t\t\t\tplaceholder=\"Nick: {{ this._user.nickname }}\"\n\t\t\t\t\t\t[formControl]=\"nicknameFormControl\"\n\t\t\t\t\t\t[errorStateMatcher]=\"matcher\"\n\t\t\t\t\t\t(keypress)=\"eventKeyPress($event)\"\n\t\t\t\t\t\tautocomplete=\"off\"\n\t\t\t\t\t/>\n\t\t\t\t\t<mat-error *ngIf=\"nicknameFormControl.hasError('required')\"> Nickname is <strong>required</strong> </mat-error>\n\t\t\t\t\t<mat-error *ngIf=\"nicknameFormControl.hasError('maxlength')\"> Nickname is <strong>too long!</strong> </mat-error>\n\t\t\t\t</mat-form-field>\n\t\t\t</form>\n\t\t</div>\n\t</div>\n\n\t<ov-video\n\t\t[streamManager]=\"this._user.streamManager\"\n\t\t[mutedSound]=\"mutedSound\"\n\t\t(toggleVideoSizeEvent)=\"toggleVideoSize($event)\"\n\t></ov-video>\n\t<div class=\"statusIcons\">\n\t\t<div id=\"statusMic\" *ngIf=\"!this._user.streamManager.stream.audioActive\">\n\t\t\t<mat-icon>mic_off</mat-icon>\n\t\t</div>\n\t\t<div id=\"statusCam\" *ngIf=\"!this._user.streamManager.stream.videoActive\">\n\t\t\t<mat-icon>videocam_off</mat-icon>\n\t\t</div>\n\t</div>\n\n\t<div class=\"videoButtons\">\n\t\t<button mat-icon-button id=\"videoZoomButton\"  (click)=\"toggleVideoSize()\">\n\t\t\t<mat-icon>{{ this.videoSizeIcon }}</mat-icon>\n\t\t</button>\n\t\t<button mat-icon-button id=\"fullscreenButton\" (click)=\"toggleFullscreen()\">\n\t\t\t<mat-icon>{{ this.fullscreenIcon }}</mat-icon>\n\t\t</button>\n\t\t<button mat-icon-button id=\"volumeButton\" *ngIf=\"this._user.streamManager.remote\" (click)=\"toggleSound()\">\n\t\t\t<mat-icon *ngIf=\"!mutedSound\" matTooltip=\"Mute sound\">volume_up</mat-icon>\n\t\t\t<mat-icon *ngIf=\"mutedSound\" color=\"warn\" matTooltip=\"Unmute sound\">volume_off</mat-icon>\n\t\t</button>\n\t\t<button\n\t\t\tmat-icon-button\n\t\t\t(click)=\"replaceScreenTrack()\"\n\t\t\tid=\"changeScreenButton\"\n\t\t\t*ngIf=\"!this._user.streamManager.remote && this._user.isScreen()\"\n\t\t>\n\t\t\t<mat-icon matTooltip=\"Choose screen\">picture_in_picture</mat-icon>\n\t\t</button>\n\t</div>\n</div>\n",
                styles: [".nickname{padding:0;position:absolute;z-index:999;border-radius:5px;color:#fff;font-family:Ubuntu,sans-serif}.nicknameContainer{background-color:#424242;padding:5px;color:#fff;font-weight:700}#dialogNickname{background-color:#0000005e;border-radius:5px}#closeButton{position:absolute;top:-3px;right:0;z-index:999}#nicknameForm{padding:10px}.fullscreen{top:40px}mat-error{text-align:center;color:#353535}video{-o-object-fit:cover;object-fit:cover;width:100%;height:100%;color:#fff;margin:0;padding:0;border:0;font-size:100%}.statusIcons{bottom:0;left:5px;width:40px;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;position:absolute;color:#fff}.statusIcons mat-icon{vertical-align:-webkit-baseline-middle;vertical-align:-moz-middle-with-baseline;font-size:20px}.videoButtons mat-icon{font-size:24px}.videoButtons .mat-icon-button{line-height:0}#camStatus{bottom:43px}#statusCam,#statusMic{text-align:center;width:28px;height:28px;border-radius:50%;background:#c71100;margin:5px auto}.videoButtons{right:0;position:absolute;bottom:0;z-index:9999999;width:50px;text-align:center}.videoButtons button{background-color:#000;width:30px;height:30px;margin:1px}.OT_widget-container{width:100%;height:100%;position:absolute;overflow:hidden}::ng-deep .mat-focused .mat-form-field-label,::ng-deep .mat-form-field-appearance-legacy .mat-form-field-label,mat-error{color:#cacaca!important}::ng-deep .mat-form-field-appearance-legacy .mat-form-field-underline,::ng-deep .mat-form-field.mat-focused .mat-form-field-ripple{background-color:#cacaca!important}input{caret-color:#fff!important}"]
            }]
    }], function () { return [{ type: UtilsService }]; }, { nicknameClicked: [{
            type: Output
        }], replaceScreenTrackClicked: [{
            type: Output
        }], toggleVideoSizeClicked: [{
            type: Output
        }], sizeChange: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }], videoSizeBig: [{
            type: Input
        }], user: [{
            type: Input
        }], nicknameInputElement: [{
            type: ViewChild,
            args: ['nicknameInput']
        }], streamComponent: [{
            type: ViewChild,
            args: ['streamComponent', { read: ViewContainerRef }]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(OpenViduVideoComponent, [{
        type: Component,
        args: [{
                selector: 'ov-video',
                template: `
		<video
			#videoElement
			[attr.id]="streamManager && _streamManager.stream ? 'video-' + _streamManager.stream.streamId : 'video-undefined'"
			[muted]="mutedSound"
		></video>
	`,
                styles: [".nickname{padding:0;position:absolute;z-index:999;border-radius:5px;color:#fff;font-family:Ubuntu,sans-serif}.nicknameContainer{background-color:#424242;padding:5px;color:#fff;font-weight:700}#dialogNickname{background-color:#0000005e;border-radius:5px}#closeButton{position:absolute;top:-3px;right:0;z-index:999}#nicknameForm{padding:10px}.fullscreen{top:40px}mat-error{text-align:center;color:#353535}video{-o-object-fit:cover;object-fit:cover;width:100%;height:100%;color:#fff;margin:0;padding:0;border:0;font-size:100%}.statusIcons{bottom:0;left:5px;width:40px;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;position:absolute;color:#fff}.statusIcons mat-icon{vertical-align:-webkit-baseline-middle;vertical-align:-moz-middle-with-baseline;font-size:20px}.videoButtons mat-icon{font-size:24px}.videoButtons .mat-icon-button{line-height:0}#camStatus{bottom:43px}#statusCam,#statusMic{text-align:center;width:28px;height:28px;border-radius:50%;background:#c71100;margin:5px auto}.videoButtons{right:0;position:absolute;bottom:0;z-index:9999999;width:50px;text-align:center}.videoButtons button{background-color:#000;width:30px;height:30px;margin:1px}.OT_widget-container{width:100%;height:100%;position:absolute;overflow:hidden}::ng-deep .mat-focused .mat-form-field-label,::ng-deep .mat-form-field-appearance-legacy .mat-form-field-label,mat-error{color:#cacaca!important}::ng-deep .mat-form-field-appearance-legacy .mat-form-field-underline,::ng-deep .mat-form-field.mat-focused .mat-form-field-ripple{background-color:#cacaca!important}input{caret-color:#fff!important}"]
            }]
    }], function () { return []; }, { toggleVideoSizeEvent: [{
            type: Output
        }], videoElement: [{
            type: ViewChild,
            args: ['videoElement']
        }], streamManager: [{
            type: Input
        }], mutedSound: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ToolbarComponent, [{
        type: Component,
        args: [{
                selector: 'app-toolbar',
                template: "<mat-toolbar\n\tid=\"header\"\n\trole=\"heading\"\n\t[class.headerLight]=\"lightTheme\"\n\tclass=\"container\"\n\tfxLayout\n\tfxLayoutAlign=\"center\"\n\tfxLayoutGap=\"10px\"\n>\n\t<div fxFlex=\"20%\">\n\t\t<app-toolbar-logo [lightTheme]=\"lightTheme\" [sessionId]=\"mySessionId\" [compact]=\"compact\" [logoUrl]=\"logoUrl\"></app-toolbar-logo>\n\t</div>\n\t<div fxFlex=\"70%\" fxFlexOrder=\"2\">\n\t\t<div align=\"center\" class=\"buttonsContainer\">\n\t\t\t<button\n\t\t\t\tid=\"navMicrophoneButton\"\n\t\t\t\tmat-icon-button\n\t\t\t\t(click)=\"toggleMicrophone()\"\n\t\t\t\t[disabled]=\"isConnectionLost\"\n\t\t\t\t*ngIf=\"hasAudioDevices && (ovSettings | hasAudio)\"\n\t\t\t>\n\t\t\t\t<mat-icon *ngIf=\"isWebcamAudioEnabled\" matTooltip=\"Mute your audio\">mic</mat-icon>\n\t\t\t\t<mat-icon *ngIf=\"!isWebcamAudioEnabled\" color=\"warn\" matTooltip=\"Unmute your audio\">mic_off</mat-icon>\n\t\t\t</button>\n\n\t\t\t<!-- Camera button -->\n\t\t\t<button\n\t\t\t\tid=\"navCameraButton\"\n\t\t\t\tmat-icon-button\n\t\t\t\t(click)=\"toggleCamera()\"\n\t\t\t\t[disabled]=\"isConnectionLost\"\n\t\t\t\t*ngIf=\"!this.ovSettings || (hasVideoDevices && (this.ovSettings | hasVideo))\"\n\t\t\t>\n\t\t\t\t<mat-icon *ngIf=\"isWebcamVideoEnabled\" matTooltip=\"Mute your cam\">videocam</mat-icon>\n\t\t\t\t<mat-icon *ngIf=\"!isWebcamVideoEnabled\" color=\"warn\" matTooltip=\"Unmute your cam\">videocam_off</mat-icon>\n\t\t\t</button>\n\n\t\t\t<!-- Screenshare button -->\n\t\t\t<button\n\t\t\t\tid=\"navScreenButton\"\n\t\t\t\tmat-icon-button\n\t\t\t\t(click)=\"toggleScreenShare()\"\n\t\t\t\t[disabled]=\"isConnectionLost\"\n\t\t\t\t*ngIf=\"ovSettings | hasScreenSharing\"\n\t\t\t>\n\t\t\t\t<mat-icon *ngIf=\"!isScreenEnabled\" matTooltip=\"Screen share\" color=\"warn\">stop_screen_share</mat-icon>\n\t\t\t\t<mat-icon *ngIf=\"isScreenEnabled\" matTooltip=\"Stop sharing\">screen_share</mat-icon>\n\t\t\t</button>\n\n\t\t\t<!-- Fullscreen button -->\n\t\t\t<button mat-icon-button (click)=\"toggleFullscreen()\" [disabled]=\"isConnectionLost\" *ngIf=\"ovSettings | hasFullscreen\">\n\t\t\t\t<mat-icon matTooltip=\"Fullscreen\">{{ fullscreenIcon }}</mat-icon>\n\t\t\t</button>\n\n\t\t\t<!-- Automatic / grid layout button -->\n\t\t\t<button\n\t\t\t\tmat-icon-button\n\t\t\t\t(click)=\"toggleSpeakerLayout()\"\n\t\t\t\t[disabled]=\"isConnectionLost\"\n\t\t\t\t*ngIf=\"ovSettings | hasLayoutSpeaking\"\n\t\t\t>\n\t\t\t\t<mat-icon matTooltip=\"Enable speaker layout\" color=\"warn\" *ngIf=\"!isAutoLayout\">voice_over_off</mat-icon>\n\t\t\t\t<mat-icon matTooltip=\"Disable speaker layout\" *ngIf=\"isAutoLayout\">record_voice_over</mat-icon>\n\t\t\t</button>\n\n\t\t\t<!-- Leave seassion button -->\n\t\t\t<button mat-icon-button (click)=\"leaveSession()\" id=\"navLeaveButton\" *ngIf=\"ovSettings | hasExit\">\n\t\t\t\t<mat-icon color=\"warn\" matTooltip=\"Leave the session\">power_settings_new</mat-icon>\n\t\t\t</button>\n\t\t</div>\n\t</div>\n\t<div fxFlex=\"10%\" fxFlexOrder=\"3\" align=\"end\">\n\t\t<button mat-icon-button (click)=\"toggleChat()\" [disabled]=\"isConnectionLost\" *ngIf=\"ovSettings | hasChat\">\n\t\t\t<mat-icon\n\t\t\t\tmatBadge=\"{{ newMessagesNum }}\"\n\t\t\t\t[matBadgeHidden]=\"newMessagesNum === 0\"\n\t\t\t\tmatBadgePosition=\"above before\"\n\t\t\t\tmatTooltip=\"Chat\"\n\t\t\t\tmatBadgeColor=\"accent\"\n\t\t\t\t>chat</mat-icon\n\t\t\t>\n\t\t</button>\n\t</div>\n</mat-toolbar>\n",
                styles: ["#header{color:#fff;height:40px;background-color:#333;padding:0 14px 0 0;position:absolute;top:0;left:0;z-index:999999;min-width:400px!important}.buttonsContainer{position:absolute;left:0;right:0}.headerLight{color:#706969!important;background-color:#eee!important}#navSessionInfo{height:100%;display:inline-flex}#navChatButton .mat-badge-medium.mat-badge-overlap.mat-badge-before .mat-badge-content{left:-17px}#navChatButton .mat-badge-medium.mat-badge-above .mat-badge-content{top:-6px}.mat-icon-button[disabled]{color:#fff}.titleContent{font-family:Ubuntu,sans-serif;max-width:100px;margin:5px -18px;padding:0 15px;font-size:16px;overflow:hidden;text-overflow:ellipsis}.titleContentDark{background-color:#494949;color:#fff}.titleContentLight{background-color:#dfdfdf!important;color:#000}#header_img{max-width:135px;margin-right:10px;margin-top:-3px}#point{width:10px;height:10px;position:absolute;top:12px;right:33px;border-radius:50%;background-color:#ffa600;border:1px solid #000;z-index:99999}.pointLight{border:1px solid #fff!important}.tooltipList{white-space:pre}@media (max-width:600px){#navSessionInfo{display:none}}"]
            }]
    }], function () { return [{ type: UtilsService }, { type: ChatService }]; }, { micButtonClicked: [{
            type: Output
        }], camButtonClicked: [{
            type: Output
        }], screenShareClicked: [{
            type: Output
        }], layoutButtonClicked: [{
            type: Output
        }], leaveSessionButtonClicked: [{
            type: Output
        }], sizeChange: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }], lightTheme: [{
            type: Input
        }], mySessionId: [{
            type: Input
        }], compact: [{
            type: Input
        }], showNotification: [{
            type: Input
        }], ovSettings: [{
            type: Input
        }], isWebcamVideoEnabled: [{
            type: Input
        }], isWebcamAudioEnabled: [{
            type: Input
        }], isScreenEnabled: [{
            type: Input
        }], isAutoLayout: [{
            type: Input
        }], isConnectionLost: [{
            type: Input
        }], hasVideoDevices: [{
            type: Input
        }], hasAudioDevices: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ToolbarLogoComponent, [{
        type: Component,
        args: [{
                selector: 'app-toolbar-logo',
                template: `
		<div id="navSessionInfo">
			<a>
				<img id="header_img" alt="OpenVidu Logo" [src]="logoUrl" />
			</a>
			<div *ngIf="!compact && sessionId" [ngClass]="{'titleContent': true, 'titleContentLight': lightTheme, 'titleContentDark': !lightTheme}">
				<span id="session-title">{{ sessionId }}</span>
			</div>
		</div>
	`,
                styles: ["#header{color:#fff;height:40px;background-color:#333;padding:0 14px 0 0;position:absolute;top:0;left:0;z-index:999999;min-width:400px!important}.buttonsContainer{position:absolute;left:0;right:0}.headerLight{color:#706969!important;background-color:#eee!important}#navSessionInfo{height:100%;display:inline-flex}#navChatButton .mat-badge-medium.mat-badge-overlap.mat-badge-before .mat-badge-content{left:-17px}#navChatButton .mat-badge-medium.mat-badge-above .mat-badge-content{top:-6px}.mat-icon-button[disabled]{color:#fff}.titleContent{font-family:Ubuntu,sans-serif;max-width:100px;margin:5px -18px;padding:0 15px;font-size:16px;overflow:hidden;text-overflow:ellipsis}.titleContentDark{background-color:#494949;color:#fff}.titleContentLight{background-color:#dfdfdf!important;color:#000}#header_img{max-width:135px;margin-right:10px;margin-top:-3px}#point{width:10px;height:10px;position:absolute;top:12px;right:33px;border-radius:50%;background-color:#ffa600;border:1px solid #000;z-index:99999}.pointLight{border:1px solid #fff!important}.tooltipList{white-space:pre}@media (max-width:600px){#navSessionInfo{display:none}}"]
            }]
    }], function () { return []; }, { lightTheme: [{
            type: Input
        }], compact: [{
            type: Input
        }], sessionId: [{
            type: Input
        }], logoUrl: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FooterComponent, [{
        type: Component,
        args: [{
                selector: 'app-footer',
                template: "<mat-toolbar\n\tclass=\"container\"\n\tfxLayout\n\tfxLayout.xs=\"row\"\n\tfxLayoutAlign=\"center center\"\n\tfxLayoutGap=\"2px\"\n\tid=\"footer\"\n\trole=\"heading\"\n\t[class.headerLight]=\"lightTheme\"\n>\n\t<div class=\"participantsButtonContainer\">\n\t\t<button mat-icon-button class=\"\" matTooltip=\"Remote participants\">\n\t\t\t<mat-icon matBadge=\"{{ participantsNames?.length }}\" matBadgeSize=\"small\" matBadgePosition=\"above after\" matBadgeColor=\"accent\">people</mat-icon>\n\t\t</button>\n\t</div>\n\t<div fxFlex=\"calc(100% - 40px)\" fxFlexOrder=\"2\">\n\t\t<span class=\"participantNames\">{{ participantsNames | tooltipList }}</span>\n\t</div>\n</mat-toolbar>\n",
                styles: ["#footer{color:#fff;height:25px;background-color:#333;padding:0 14px 0 0;position:absolute;bottom:0;left:0;z-index:999999;min-width:400px!important}.footerLight{color:#706969!important;background-color:#eee!important}.participantNames{font-size:small;height:inherit}.participantsButton{position:absolute;left:5px;top:none;height:-webkit-fill-available;height:-moz-available}.participantsButtonContainer{height:-webkit-fill-available;height:-moz-available}.mat-icon-button .mat-icon,.participantsButtonContainer .mat-icon-button i{line-height:18px}"]
            }]
    }], function () { return []; }, { sizeChange: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }], participants: [{
            type: Input
        }], lightTheme: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(RoomConfigComponent, [{
        type: Component,
        args: [{
                selector: 'app-room-config',
                template: "<div id=\"roomConfig\" [ngStyle]=\"{ display: (ovSettings | isAutoPublish) ? 'none' : 'block' }\">\n<!-- Modal -->\n<div class=\"modal\" *ngIf=\"showConfigCard\">\n    <div class=\"modal-dialog modal-xl\">\n      <div class=\"modal-content cardContainer\">\n\n        <!-- Modal Header -->\n        <div class=\"modal-header cardHeader\">\n\t\t\t<div class=\"headerLogo\">\n\t\t\t\t<img\n\t\t\t\t\tid=\"header_img\"\n\t\t\t\t\talt=\"OpenVidu Logo\"\n\t\t\t\t\tsrc=\"https://raw.githubusercontent.com/OpenVidu/openvidu-call/master/openvidu-call-front/src/assets/images/openvidu_logo_grey.png\"\n\t\t\t\t/>\n\t\t\t</div>\n\t\t\t<h3 class=\"headerTitle\">{{ mySessionId }}</h3>\n\n\t\t\t<button mat-mini-fab (click)=\"close()\" class=\"closeButton\" id=\"closeButton\">\n\t\t\t\t<mat-icon color=\"warn\" matTooltip=\"Close\">highlight_off</mat-icon>\n\t\t\t</button>\n        </div>\n\n        <!-- Modal body -->\n        <div class=\"modal-body\" #bodyCard>\n\n\t\t  <div class=\"row align-items-center\">\n\t\t\t<div class=\"col-sm-6 col-md-6 col-lg-6 leftSection\">\n\t\t\t\t<div class=\"videoContainer\">\n\n\t\t\t\t<!-- <mat-slider\n\t\t\t\t\t\tclass=\"volumeSlider\"\n\t\t\t\t\t\t*ngIf=\"volumeValue < 100\"\n\t\t\t\t\t\t[max]=\"0\"\n\t\t\t\t\t\t[min]=\"100\"\n\t\t\t\t\t\t[color]=\"updateVolumeColor()\"\n\t\t\t\t\t\t[ngModel]=\"volumeValue\"\n\t\t\t\t\t\t[vertical]=\"true\"\n\t\t\t\t\t>\n\t\t\t\t\t</mat-slider> -->\n\n\t\t\t\t\t<div *ngFor=\"let localUser of localUsers; let i = index\">\n\t\t\t\t\t\t<!-- Only webcam video will be shown if webcamera is available -->\n\t\t\t\t\t\t<ov-video\n\t\t\t\t\t\t\t*ngIf=\"(localUser.isCamera() && hasVideoDevices) || localUser.isScreen()\"\n\t\t\t\t\t\t\t[streamManager]=\"localUser.streamManager\"\n\n\t\t\t\t\t\t\t[className]=\"localUsers.length > 1 && i === 0 ? 'ovVideoSmall' : ''\"\n\t\t\t\t\t\t></ov-video>\n\t\t\t\t\t\t<div class=\"cameraMessageContainer\" *ngIf=\"localUser.isCamera() && !hasVideoDevices\">\n\t\t\t\t\t\t\t<span>Oops! Camera is not available</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class=\"avatarButton\">\n\t\t\t\t\t<button mat-stroked-button (click)=\"takePhoto()\">\n\t\t\t\t\t\t<mat-icon matTooltip=\"Take Photo\">photo_camera</mat-icon>\n\t\t\t\t\t\t<span style=\"margin-left: 5px;\">Capture Avatar</span>\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class=\"col-sm-6 col-md-6 col-lg-6 rightSection\">\n\t\t\t\t<div class=\"avatarContainer\">\n\t\t\t\t\t<h3>Avatar</h3>\n\n\t\t\t\t</div>\n\n\n\t\t\t\t<div fxLayout=\"row\" fxFill id=\"avatarSection\" *ngIf=\"hasVideoDevices\">\n\n\t\t\t\t\t<div class=\"\" fxFlex=\"100\" fxLayoutAlign=\"center center\">\n\n\n\t\t\t\t\t\t<div\n\t\t\t\t\t\t\tid=\"avatarContainer\"\n\t\t\t\t\t\t\t(click)=\"setAvatar('video')\"\n\t\t\t\t\t\t\t[style.background]=\"avatarSelected === 'video' ? 'lightgreen' : 'transparent'\"\n\t\t\t\t\t\t>\n\t\t\t\t\t\t\t<div id=\"imgText\" *ngIf=\"!videoAvatar\">\n\t\t\t\t\t\t\t\t<span>Press Avatar Button</span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<img id=\"avatarImg\" *ngIf=\"videoAvatar\" [src]=\"videoAvatar\" />\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div\n\t\t\t\t\t\t\tid=\"avatarContainer\"\n\t\t\t\t\t\t\t(click)=\"setAvatar('random')\"\n\t\t\t\t\t\t\t[style.background]=\"avatarSelected === 'random' ? 'lightgreen' : 'transparent'\"\n\t\t\t\t\t\t>\n\t\t\t\t\t\t\t<mat-spinner id=\"imgText\" [diameter]=\"70\" *ngIf=\"!randomAvatar\" color=\"accent\"></mat-spinner>\n\t\t\t\t\t\t\t<img id=\"avatarImg\" *ngIf=\"randomAvatar\" [src]=\"randomAvatar\" />\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Devices section / Nickname-->\n\t\t\t\t<div fxLayout=\"row\" fxFill id=\"devicesSection\">\n\t\t\t\t\t<div fxLayout fxFlex>\n\t\t\t\t\t\t<div class=\"one\" fxFlex=\"20\" fxLayoutAlign=\"center center\">\n\t\t\t\t\t\t\t<button mat-mini-fab (click)=\"setNicknameForm()\" class=\"deviceButton\">\n\t\t\t\t\t\t\t\t<mat-icon matTooltip=\"Nickname\">person</mat-icon>\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"two\" fxFlex=\"80\" fxLayoutAlign=\"center center\">\n\t\t\t\t\t\t\t<form id=\"nicknameForm\" class=\"alternate-theme\">\n\t\t\t\t\t\t\t\t<mat-form-field>\n\t\t\t\t\t\t\t\t\t<input\n\t\t\t\t\t\t\t\t\t\tmatInput\n\t\t\t\t\t\t\t\t\t\tplaceholder=\"Nickname\"\n\t\t\t\t\t\t\t\t\t\t[formControl]=\"nicknameFormControl\"\n\t\t\t\t\t\t\t\t\t\t[errorStateMatcher]=\"matcher\"\n\t\t\t\t\t\t\t\t\t\t(keypress)=\"eventKeyPress($event)\"\n\t\t\t\t\t\t\t\t\t\tautocomplete=\"off\"\n\t\t\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t\t\t<mat-error *ngIf=\"nicknameFormControl.hasError('required')\">\n\t\t\t\t\t\t\t\t\t\tNickname is <strong>required</strong>\n\t\t\t\t\t\t\t\t\t</mat-error>\n\t\t\t\t\t\t\t\t\t<mat-error *ngIf=\"nicknameFormControl.hasError('maxlength')\">\n\t\t\t\t\t\t\t\t\t\tNickname is <strong>too long!</strong>\n\t\t\t\t\t\t\t\t\t</mat-error>\n\t\t\t\t\t\t\t\t</mat-form-field>\n\t\t\t\t\t\t\t</form>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Devices section / Microphone-->\n\t\t\t\t<div fxLayout=\"row\" fxFill id=\"devicesSection\" *ngIf=\"hasAudioDevices && (ovSettings | hasAudio)\">\n\t\t\t\t\t<div fxLayout fxFlex>\n\t\t\t\t\t\t<div class=\"one\" fxFlex=\"20\" fxLayoutAlign=\"center center\">\n\t\t\t\t\t\t\t<button mat-mini-fab (click)=\"toggleMic()\" class=\"deviceButton\"  id=\"configCardMicrophoneButton\">\n\t\t\t\t\t\t\t\t<mat-icon *ngIf=\"isAudioActive\" matTooltip=\"Microphone Enabled\">mic</mat-icon>\n\t\t\t\t\t\t\t\t<mat-icon *ngIf=\"!isAudioActive\" color=\"warn\" matTooltip=\"Microphone Disabled\">mic_off</mat-icon>\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"two\" fxFlex=\"80\" fxLayoutAlign=\"center center\">\n\t\t\t\t\t\t\t<mat-form-field class=\"alternate-theme\">\n\t\t\t\t\t\t\t\t<mat-select\n\t\t\t\t\t\t\t\t\tplaceholder=\"Microphone Options\"\n\t\t\t\t\t\t\t\t\t[ngModel]=\"isAudioActive && micSelected ? micSelected.device : 'None'\"\n\t\t\t\t\t\t\t\t\t(selectionChange)=\"onMicrophoneSelected($event)\"\n\t\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t\t<mat-option *ngFor=\"let microphone of microphones\" [value]=\"microphone.device\">\n\t\t\t\t\t\t\t\t\t\t{{ microphone.label }}\n\t\t\t\t\t\t\t\t\t</mat-option>\n\t\t\t\t\t\t\t\t</mat-select>\n\t\t\t\t\t\t\t</mat-form-field>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<!-- Devices section / Camera-->\n\t\t\t\t<div fxLayout=\"row\" fxFill id=\"devicesSection\" *ngIf=\"hasVideoDevices && (ovSettings | hasVideo)\">\n\t\t\t\t\t<div fxLayout fxFlex>\n\t\t\t\t\t\t<div class=\"one\" fxFlex=\"20\" fxLayoutAlign=\"center center\">\n\t\t\t\t\t\t\t<button mat-mini-fab (click)=\"toggleCam()\" class=\"deviceButton\" id=\"configCardCameraButton\">\n\t\t\t\t\t\t\t\t<mat-icon *ngIf=\"isVideoActive\" matTooltip=\"Camera Enabled\">videocam</mat-icon>\n\t\t\t\t\t\t\t\t<mat-icon *ngIf=\"!isVideoActive\" color=\"warn\" matTooltip=\"Camera Disabled\">videocam_off</mat-icon>\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"two\" fxFlex=\"80\" fxLayoutAlign=\"center center\">\n\t\t\t\t\t\t\t<mat-form-field class=\"alternate-theme\">\n\t\t\t\t\t\t\t\t<mat-select\n\t\t\t\t\t\t\t\t\tplaceholder=\"Camera Options\"\n\t\t\t\t\t\t\t\t\t[ngModel]=\"isVideoActive && camSelected ? camSelected.device : 'None'\"\n\t\t\t\t\t\t\t\t\t(selectionChange)=\"onCameraSelected($event)\"\n\t\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t\t<mat-option *ngFor=\"let camera of cameras\" [value]=\"camera.device\">\n\t\t\t\t\t\t\t\t\t\t{{ camera.label }}\n\t\t\t\t\t\t\t\t\t</mat-option>\n\t\t\t\t\t\t\t\t</mat-select>\n\t\t\t\t\t\t\t</mat-form-field>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Devices section / ScreenShare-->\n\t\t\t\t<div fxLayout=\"row\" fxFill id=\"devicesSection\" *ngIf=\"ovSettings | hasScreenSharing\">\n\t\t\t\t\t<div fxLayout fxFlex>\n\t\t\t\t\t\t<div class=\"one\" fxFlex=\"20\" fxLayoutAlign=\"center center\">\n\t\t\t\t\t\t\t<button mat-mini-fab (click)=\"toggleScreenShare()\" class=\"deviceButton\" id=\"configCardScreenButton\">\n\t\t\t\t\t\t\t\t<mat-icon *ngIf=\"this.oVSessionService.isScreenShareEnabled()\" matTooltip=\"Screen Share Enabled\"\n\t\t\t\t\t\t\t\t\t>screen_share</mat-icon\n\t\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t<mat-icon\n\t\t\t\t\t\t\t\t\t*ngIf=\"!this.oVSessionService.isScreenShareEnabled()\"\n\t\t\t\t\t\t\t\t\tcolor=\"warn\"\n\t\t\t\t\t\t\t\t\tmatTooltip=\"Screen Share Disabled\"\n\t\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t\tstop_screen_share</mat-icon\n\t\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"two\" fxFlex=\"80\" fxLayoutAlign=\"center center\">\n\t\t\t\t\t\t\t<mat-form-field class=\"alternate-theme\">\n\t\t\t\t\t\t\t\t<input\n\t\t\t\t\t\t\t\t\tmatInput\n\t\t\t\t\t\t\t\t\tdisabled\n\t\t\t\t\t\t\t\t\tplaceholder=\"Screen\"\n\t\t\t\t\t\t\t\t\t[ngModel]=\"this.oVSessionService.isScreenShareEnabled() ? 'Screen' : 'None'\"\n\t\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t</mat-form-field>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t  </div>\n\n        </div>\n\n        <!-- Modal footer -->\n        <div class=\"modal-footer\" style=\"justify-content: center\">\n\t\t\t<button mat-flat-button color=\"accent\" (click)=\"joinSession()\" form=\"nicknameForm\" id=\"joinButton\">JOIN</button>\n\n        </div>\n\n      </div>\n    </div>\n  </div>\n</div>\n\n",
                styles: [".cardHeader{background-color:#ccc;border-radius:14px 14px 0 0;text-align:center;height:50px}.headerLogo{position:absolute;top:0;left:0;height:inherit}.headerTitle{font-size:large;margin:auto}.videoContainer{width:100%;height:calc(100% - 50px);text-align:center;margin:auto}.avatarButton{text-align:center;margin-top:10px}.videoContainer>div{display:inline}.ovVideoSmall{position:absolute;width:30%;left:15px;bottom:46px}.cameraMessageContainer{height:100%;width:100%;text-align:center;border:2px solid;font-size:large;display:table}.cameraMessageContainer>span{display:table-cell;vertical-align:middle}.deviceButton{box-shadow:none;background-color:#f5f5f5}.rightSection{padding-left:0!important;text-align:center}.avatarContainer{background-color:#f5f5f5;height:40px;text-align:center;display:flex}.avatarContainer h3{margin:auto}.closeButton{position:absolute;top:5px;right:7px;box-shadow:none;background-color:transparent}#roomConfig{position:absolute;width:100%;height:100%}#header_img{max-width:150px}#sessionInfo{margin-top:0}#joinButton{margin:15px;width:80%}#photoButton{margin:10px;text-align:center}#avatarContainer{border:1px solid #b6b6b6;width:100px;height:100px;margin:10px;position:relative;cursor:pointer;display:inline-block}#devicesSection{margin:15px 0}#avatarSection,#devicesSection{height:-webkit-fit-content!important;height:-moz-fit-content!important;height:fit-content!important;min-height:auto!important}#imgText{display:table}#avatarImg,#imgText{text-align:center;position:absolute;margin:auto;top:25%;left:0;right:0;bottom:25%}#avatarImg{height:83%;width:83%}#avatarContainer,#avatarImg{border-radius:25%}#optionsContent{position:initial}#nicknameForm,mat-form-field{width:100%}mat-card{max-width:85%!important;position:absolute;top:0;bottom:0;left:0;right:0;max-height:90%;margin:auto;padding:20px;overflow:auto;border:2px solid #fff;border-right:4px solid #fff}@media only screen and (max-width:959px){mat-card{max-width:80%!important;max-height:80%!important}}::ng-deep .mat-option-text{color:#000!important}::ng-deep .mat-slider-thumb{visibility:hidden}::ng-deep .mat-slider-vertical .mat-slider-track-background,::ng-deep .mat-slider-vertical .mat-slider-track-fill,::ng-deep .mat-slider-vertical .mat-slider-track-wrapper{width:10px!important}::-webkit-scrollbar{width:8px}::-webkit-scrollbar-thumb{background:#b8afaf;border-radius:4px}::-webkit-scrollbar-thumb:hover{background:#888}::-webkit-scrollbar-track{background:#e1e1e1;border-radius:4px}/*!\n * Generated using the Bootstrap Customizer (https://getbootstrap.com/docs/3.4/customize/)\n *//*!\n * Bootstrap v3.4.1 (https://getbootstrap.com/)\n * Copyright 2011-2019 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n *//*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */*,:after,:before{box-sizing:border-box}.container{padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}@media (min-width:768px){.container{width:750px}}@media (min-width:992px){.container{width:970px}}@media (min-width:1200px){.container{width:1170px}}.container-fluid{padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}.row{margin-right:-15px;margin-left:-15px}.row-no-gutters{margin-right:0;margin-left:0}.row-no-gutters [class*=col-]{padding-right:0;padding-left:0}.col-lg-1,.col-lg-10,.col-lg-11,.col-lg-12,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-md-1,.col-md-10,.col-md-11,.col-md-12,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-sm-1,.col-sm-10,.col-sm-11,.col-sm-12,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-xs-1,.col-xs-10,.col-xs-11,.col-xs-12,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9{position:relative;min-height:1px;padding-right:15px;padding-left:15px}.col-xs-1,.col-xs-10,.col-xs-11,.col-xs-12,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9{float:left}.col-xs-12{width:100%}.col-xs-11{width:91.66666667%}.col-xs-10{width:83.33333333%}.col-xs-9{width:75%}.col-xs-8{width:66.66666667%}.col-xs-7{width:58.33333333%}.col-xs-6{width:50%}.col-xs-5{width:41.66666667%}.col-xs-4{width:33.33333333%}.col-xs-3{width:25%}.col-xs-2{width:16.66666667%}.col-xs-1{width:8.33333333%}.col-xs-pull-12{right:100%}.col-xs-pull-11{right:91.66666667%}.col-xs-pull-10{right:83.33333333%}.col-xs-pull-9{right:75%}.col-xs-pull-8{right:66.66666667%}.col-xs-pull-7{right:58.33333333%}.col-xs-pull-6{right:50%}.col-xs-pull-5{right:41.66666667%}.col-xs-pull-4{right:33.33333333%}.col-xs-pull-3{right:25%}.col-xs-pull-2{right:16.66666667%}.col-xs-pull-1{right:8.33333333%}.col-xs-pull-0{right:auto}.col-xs-push-12{left:100%}.col-xs-push-11{left:91.66666667%}.col-xs-push-10{left:83.33333333%}.col-xs-push-9{left:75%}.col-xs-push-8{left:66.66666667%}.col-xs-push-7{left:58.33333333%}.col-xs-push-6{left:50%}.col-xs-push-5{left:41.66666667%}.col-xs-push-4{left:33.33333333%}.col-xs-push-3{left:25%}.col-xs-push-2{left:16.66666667%}.col-xs-push-1{left:8.33333333%}.col-xs-push-0{left:auto}.col-xs-offset-12{margin-left:100%}.col-xs-offset-11{margin-left:91.66666667%}.col-xs-offset-10{margin-left:83.33333333%}.col-xs-offset-9{margin-left:75%}.col-xs-offset-8{margin-left:66.66666667%}.col-xs-offset-7{margin-left:58.33333333%}.col-xs-offset-6{margin-left:50%}.col-xs-offset-5{margin-left:41.66666667%}.col-xs-offset-4{margin-left:33.33333333%}.col-xs-offset-3{margin-left:25%}.col-xs-offset-2{margin-left:16.66666667%}.col-xs-offset-1{margin-left:8.33333333%}.col-xs-offset-0{margin-left:0}@media (min-width:768px){.col-sm-1,.col-sm-10,.col-sm-11,.col-sm-12,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9{float:left}.col-sm-12{width:100%}.col-sm-11{width:91.66666667%}.col-sm-10{width:83.33333333%}.col-sm-9{width:75%}.col-sm-8{width:66.66666667%}.col-sm-7{width:58.33333333%}.col-sm-6{width:50%}.col-sm-5{width:41.66666667%}.col-sm-4{width:33.33333333%}.col-sm-3{width:25%}.col-sm-2{width:16.66666667%}.col-sm-1{width:8.33333333%}.col-sm-pull-12{right:100%}.col-sm-pull-11{right:91.66666667%}.col-sm-pull-10{right:83.33333333%}.col-sm-pull-9{right:75%}.col-sm-pull-8{right:66.66666667%}.col-sm-pull-7{right:58.33333333%}.col-sm-pull-6{right:50%}.col-sm-pull-5{right:41.66666667%}.col-sm-pull-4{right:33.33333333%}.col-sm-pull-3{right:25%}.col-sm-pull-2{right:16.66666667%}.col-sm-pull-1{right:8.33333333%}.col-sm-pull-0{right:auto}.col-sm-push-12{left:100%}.col-sm-push-11{left:91.66666667%}.col-sm-push-10{left:83.33333333%}.col-sm-push-9{left:75%}.col-sm-push-8{left:66.66666667%}.col-sm-push-7{left:58.33333333%}.col-sm-push-6{left:50%}.col-sm-push-5{left:41.66666667%}.col-sm-push-4{left:33.33333333%}.col-sm-push-3{left:25%}.col-sm-push-2{left:16.66666667%}.col-sm-push-1{left:8.33333333%}.col-sm-push-0{left:auto}.col-sm-offset-12{margin-left:100%}.col-sm-offset-11{margin-left:91.66666667%}.col-sm-offset-10{margin-left:83.33333333%}.col-sm-offset-9{margin-left:75%}.col-sm-offset-8{margin-left:66.66666667%}.col-sm-offset-7{margin-left:58.33333333%}.col-sm-offset-6{margin-left:50%}.col-sm-offset-5{margin-left:41.66666667%}.col-sm-offset-4{margin-left:33.33333333%}.col-sm-offset-3{margin-left:25%}.col-sm-offset-2{margin-left:16.66666667%}.col-sm-offset-1{margin-left:8.33333333%}.col-sm-offset-0{margin-left:0}}@media (min-width:992px){.col-md-1,.col-md-10,.col-md-11,.col-md-12,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9{float:left}.col-md-12{width:100%}.col-md-11{width:91.66666667%}.col-md-10{width:83.33333333%}.col-md-9{width:75%}.col-md-8{width:66.66666667%}.col-md-7{width:58.33333333%}.col-md-6{width:50%}.col-md-5{width:41.66666667%}.col-md-4{width:33.33333333%}.col-md-3{width:25%}.col-md-2{width:16.66666667%}.col-md-1{width:8.33333333%}.col-md-pull-12{right:100%}.col-md-pull-11{right:91.66666667%}.col-md-pull-10{right:83.33333333%}.col-md-pull-9{right:75%}.col-md-pull-8{right:66.66666667%}.col-md-pull-7{right:58.33333333%}.col-md-pull-6{right:50%}.col-md-pull-5{right:41.66666667%}.col-md-pull-4{right:33.33333333%}.col-md-pull-3{right:25%}.col-md-pull-2{right:16.66666667%}.col-md-pull-1{right:8.33333333%}.col-md-pull-0{right:auto}.col-md-push-12{left:100%}.col-md-push-11{left:91.66666667%}.col-md-push-10{left:83.33333333%}.col-md-push-9{left:75%}.col-md-push-8{left:66.66666667%}.col-md-push-7{left:58.33333333%}.col-md-push-6{left:50%}.col-md-push-5{left:41.66666667%}.col-md-push-4{left:33.33333333%}.col-md-push-3{left:25%}.col-md-push-2{left:16.66666667%}.col-md-push-1{left:8.33333333%}.col-md-push-0{left:auto}.col-md-offset-12{margin-left:100%}.col-md-offset-11{margin-left:91.66666667%}.col-md-offset-10{margin-left:83.33333333%}.col-md-offset-9{margin-left:75%}.col-md-offset-8{margin-left:66.66666667%}.col-md-offset-7{margin-left:58.33333333%}.col-md-offset-6{margin-left:50%}.col-md-offset-5{margin-left:41.66666667%}.col-md-offset-4{margin-left:33.33333333%}.col-md-offset-3{margin-left:25%}.col-md-offset-2{margin-left:16.66666667%}.col-md-offset-1{margin-left:8.33333333%}.col-md-offset-0{margin-left:0}}@media (min-width:1200px){.col-lg-1,.col-lg-10,.col-lg-11,.col-lg-12,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9{float:left}.col-lg-12{width:100%}.col-lg-11{width:91.66666667%}.col-lg-10{width:83.33333333%}.col-lg-9{width:75%}.col-lg-8{width:66.66666667%}.col-lg-7{width:58.33333333%}.col-lg-6{width:50%}.col-lg-5{width:41.66666667%}.col-lg-4{width:33.33333333%}.col-lg-3{width:25%}.col-lg-2{width:16.66666667%}.col-lg-1{width:8.33333333%}.col-lg-pull-12{right:100%}.col-lg-pull-11{right:91.66666667%}.col-lg-pull-10{right:83.33333333%}.col-lg-pull-9{right:75%}.col-lg-pull-8{right:66.66666667%}.col-lg-pull-7{right:58.33333333%}.col-lg-pull-6{right:50%}.col-lg-pull-5{right:41.66666667%}.col-lg-pull-4{right:33.33333333%}.col-lg-pull-3{right:25%}.col-lg-pull-2{right:16.66666667%}.col-lg-pull-1{right:8.33333333%}.col-lg-pull-0{right:auto}.col-lg-push-12{left:100%}.col-lg-push-11{left:91.66666667%}.col-lg-push-10{left:83.33333333%}.col-lg-push-9{left:75%}.col-lg-push-8{left:66.66666667%}.col-lg-push-7{left:58.33333333%}.col-lg-push-6{left:50%}.col-lg-push-5{left:41.66666667%}.col-lg-push-4{left:33.33333333%}.col-lg-push-3{left:25%}.col-lg-push-2{left:16.66666667%}.col-lg-push-1{left:8.33333333%}.col-lg-push-0{left:auto}.col-lg-offset-12{margin-left:100%}.col-lg-offset-11{margin-left:91.66666667%}.col-lg-offset-10{margin-left:83.33333333%}.col-lg-offset-9{margin-left:75%}.col-lg-offset-8{margin-left:66.66666667%}.col-lg-offset-7{margin-left:58.33333333%}.col-lg-offset-6{margin-left:50%}.col-lg-offset-5{margin-left:41.66666667%}.col-lg-offset-4{margin-left:33.33333333%}.col-lg-offset-3{margin-left:25%}.col-lg-offset-2{margin-left:16.66666667%}.col-lg-offset-1{margin-left:8.33333333%}.col-lg-offset-0{margin-left:0}}.modal-open{overflow:hidden}.modal{top:0;right:0;bottom:0;left:0;z-index:1050;overflow:hidden;-webkit-overflow-scrolling:touch;outline:0;display:block;height:100%}.modal.fade .modal-dialog{transform:translate(0,-25%);transition:transform .3s ease-out}.modal.in .modal-dialog{transform:translate(0,0)}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal-dialog{width:auto;margin:30px;padding:100px 0;position:absolute;top:40%;left:50%;transform:translate(-50%,-50%)}.modal-content{position:relative;background-color:#fff;-webkit-background-clip:padding-box;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:15px;box-shadow:0 3px 9px rgba(0,0,0,.5);outline:0}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop.in{opacity:.5}.modal-header{padding:15px;border-bottom:1px solid #e5e5e5}.modal-header .close{margin-top:-2px}.modal-title{margin:0;line-height:1.42857143}.modal-body{position:relative;padding:15px}.modal-footer{padding:1px;text-align:center;border-top:1px solid #e5e5e5}.modal-footer .btn+.btn{margin-bottom:0;margin-left:5px}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (max-width:600px){.headerTitle{display:none}.headerLogo{right:0}}@media (max-width:767px){.row{height:100%}.leftSection{height:60%}.rightSection{padding-right:0!important}.headerTitle{font-size:medium}.modal-content{max-height:100%;height:100%}.modal-dialog{height:calc(100% - 10px);margin:5px;padding:0;position:relative;top:0;left:0;transform:none}.modal-body{padding:10px 20px;overflow:auto;height:calc(100% - 120px);overflow:-moz-scrollbars-vertical;overflow-x:hidden;overflow-y:scroll}.modal{max-height:100%}.videoContainer{width:60%}}@media (min-width:768px){.ovVideoSmall{width:40%}.row{display:flex!important}.modal-dialog{width:90%;margin:55px auto}.modal-content{box-shadow:0 5px 15px rgba(0,0,0,.5)}.modal-sm{width:300px}}@media (min-width:992px){.modal-lg{width:75%}}@media (min-width:1440px){.modal-xl{width:75%}}"]
            }]
    }], function () { return [{ type: ɵngcc10.ActivatedRoute }, { type: UtilsService }, { type: OpenViduSessionService }, { type: DevicesService }, { type: LoggerService }, { type: StorageService }]; }, { join: [{
            type: Output
        }], leaveSession: [{
            type: Output
        }], publisherCreated: [{
            type: Output
        }], beforeunloadHandler: [{
            type: HostListener,
            args: ['window:beforeunload']
        }], bodyCard: [{
            type: ViewChild,
            args: ['bodyCard']
        }], externalConfig: [{
            type: Input
        }], ovSettings: [{
            type: Input
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(OpenviduSessionModule, { declarations: function () { return [OpenviduSessionComponent,
        VideoRoomComponent,
        StreamComponent,
        ChatComponent,
        OpenViduVideoComponent,
        DialogErrorComponent,
        RoomConfigComponent,
        FooterComponent,
        ToolbarComponent,
        ToolbarLogoComponent,
        LinkifyPipe,
        HasChatPipe,
        HasAudioPipe,
        HasVideoPipe,
        IsAutoPublishPipe,
        HasScreenSharingPipe,
        HasFullscreenPipe,
        HasLayoutSpeakingPipe,
        HasExitPipe,
        TooltipListPipe]; }, imports: function () { return [CommonModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatCardModule,
        MatToolbarModule,
        MatIconModule,
        MatInputModule,
        MatFormFieldModule,
        MatDialogModule,
        MatTooltipModule,
        MatBadgeModule,
        MatGridListModule,
        MatSelectModule,
        MatOptionModule,
        MatProgressSpinnerModule,
        MatSliderModule,
        MatSidenavModule,
        MatSnackBarModule,
        FlexLayoutModule, ɵngcc12.NgxLinkifyjsModule]; }, exports: function () { return [OpenviduSessionComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(OpenviduSessionModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    HttpClientModule,
                    FormsModule,
                    ReactiveFormsModule,
                    MatButtonModule,
                    MatCardModule,
                    MatToolbarModule,
                    MatIconModule,
                    MatInputModule,
                    MatFormFieldModule,
                    MatDialogModule,
                    MatTooltipModule,
                    MatBadgeModule,
                    MatGridListModule,
                    MatSelectModule,
                    MatOptionModule,
                    MatProgressSpinnerModule,
                    MatSliderModule,
                    MatSidenavModule,
                    MatSnackBarModule,
                    FlexLayoutModule,
                    NgxLinkifyjsModule.forRoot()
                ],
                declarations: [
                    OpenviduSessionComponent,
                    VideoRoomComponent,
                    StreamComponent,
                    ChatComponent,
                    OpenViduVideoComponent,
                    DialogErrorComponent,
                    RoomConfigComponent,
                    FooterComponent,
                    ToolbarComponent,
                    ToolbarLogoComponent,
                    LinkifyPipe,
                    HasChatPipe,
                    HasAudioPipe,
                    HasVideoPipe,
                    IsAutoPublishPipe,
                    HasScreenSharingPipe,
                    HasFullscreenPipe,
                    HasLayoutSpeakingPipe,
                    HasExitPipe,
                    TooltipListPipe
                ],
                entryComponents: [DialogErrorComponent],
                providers: [
                    NetworkService,
                    OpenViduSessionService,
                    UtilsService,
                    RemoteUsersService,
                    DevicesService,
                    LoggerService,
                    ChatService,
                    NotificationService,
                    StorageService
                ],
                exports: [OpenviduSessionComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of openvidu-angular
 */

/**
 * Generated bundle index. Do not edit.
 */

export { OpenViduLayout, OpenviduSessionComponent, OpenviduSessionModule, UserModel, LoggerService as ɵa, VideoRoomComponent as ɵb, HasExitPipe as ɵba, TooltipListPipe as ɵbb, NetworkService as ɵc, UtilsService as ɵd, RemoteUsersService as ɵe, OpenViduSessionService as ɵf, DevicesService as ɵg, StorageService as ɵh, ChatService as ɵi, NotificationService as ɵj, StreamComponent as ɵk, ChatComponent as ɵl, OpenViduVideoComponent as ɵm, DialogErrorComponent as ɵn, RoomConfigComponent as ɵo, FooterComponent as ɵp, ToolbarComponent as ɵq, ToolbarLogoComponent as ɵr, LinkifyPipe as ɵs, HasChatPipe as ɵt, HasAudioPipe as ɵu, HasVideoPipe as ɵv, IsAutoPublishPipe as ɵw, HasScreenSharingPipe as ɵx, HasFullscreenPipe as ɵy, HasLayoutSpeakingPipe as ɵz };

//# sourceMappingURL=openvidu-angular.js.map